var ADV = (function(app) {
  app.settings = $.extend(
    {
      colors: ['#5abee4', '#89ce41', '#ff9e13', '#63146b', '#e75953'],
      color_groups: [
        ['#5abee4', '#76c9e9', '#92d4ed', '#aedff2', '#4b9ebd', '#3b7d96', '#2c5d70', '#1d3d49'],
        ['#89ce41', '#9dd661', '#b1df82', '#c5e7a2', '#72ab36', '#5a882b', '#436520', '#2c4215'],
        ['#ff9e13', '#ffae3b', '#ffbf63', '#ffcf8b', '#d48310', '#a8680d', '#7d4d09', '#523306'],
        ['#63146b', '#7e3c84', '#98649d', '#b38cb6', '#521159', '#410d47', '#310a34', '#200622'],
        ['#e75953', '#eb7570', '#ef918d', '#f3aeab', '#c04a45', '#983b37', '#712c29', '#4a1c1b'],
        ['#cabffd', '#A07DB1', '#BFA8CC', '#DFD3E5', '#572A79', '#501E6A', '#411957', '#331444'],
      ],
      debt_management_colors: ['#4b9ebd', '#410d47'],
      expresswizard_colors: ['#4591ad', '#5fbfe2', '#b7ecff', '#7F5197', '#A07DB1'],
      breakdown_colors: [
        '#5abee4',
        '#2eaddd',
        '#3b7d96',
        '#2c5d70',
        '#7e3c84',
        '#63146b',
        '#521159',
        '#410d47',
      ],
      retirement_income_colors: ['#0078D4', '#6B3FA0', '#BF5700', '#B8DFF0', '#6092B4', '#686E7E'],

      MsgLib: {
        generic_error: 'Sorry, an error has occurred. Please try again.',
        cannot_connect:
          '<i class="fa fa-flash" style="font-size:39px;color:#ddd;display:block;float:left;margin:3px 13px 0 0;"></i>Sorry, we\'re having trouble connecting to our server. Please check your connection and try again.',
        timeout_warning:
          'Your session is about to be timed out for security reasons. Would you like stay logged in?',
        generic_account_linking_error:
          'Sorry, we were unable to import this account at this time. Please try again later, or contact us if you continue to experience this problem.',
        buttons: {
          default_button_ok: 'OK',
          default_button_cancel: 'Cancel',
        },
        FinancialPlan: {
          notice_changed_settings:
            'Your settings have been changed since this plan was generated. Would you like to reset this plan?',
          notice_changed_settings_warning:
            'Are you sure you want to reset all <strong class="weight-600">' +
            'what ifs</strong> variables? This will set all ' +
            'variables in the <strong class="weight-600">what ifs</strong> section ' +
            'for all goals to match their values in the ' +
            '<strong class="weight-600">profile</strong> section. All changes ' +
            'to the <strong class="weight-600">what ifs</strong> section for all ' +
            'goals will be lost.',
          notice_changed_profile:
            'An input on this client\'s <strong class="weight-600">' +
            'profile</strong> section has changed since the <strong class="weight-600">' +
            'recommendations</strong> page was last run. Would you like ' +
            'to reset all <strong class="weight-600">what ifs</strong> variables for all ' +
            'goals in this plan to match the <strong class="weight-600">profile</strong> section?',
          notice_changed_profile_consumer:
            'The <strong class="weight-600">profile</strong> has changed since the <strong class="weight-600">' +
            'recommendations</strong> page was last updated. Would you like to reset all <strong class="weight-600">' +
            'what ifs</strong> values for all goals to match the <strong class="weight-600">profile</strong> section?',
        },
      },

      misc: {
        notification_update_frequency: 1000 * 60,
        notification_limit: 10,
        session_timeout: 60 * 60 * 1000, //in milliseconds
        session_warning_time: 2 * 60 * 1000, //amount of warning to give, in milliseconds, before session timeout occurs
      },

      AccountLinking: {
        poll_interval: 1000, //in milliseconds
        fail_timeout_interval: 5 * 60 * 1000, //how long to wait until giving up, in milliseconds.
      },
    },
    app.settings || {},
  );
  return app;
})(ADV || {});

(function() {
  const js_dir = `${ADV.settings.endpoints.assets}js/`;

  ADV.resources = $.extend(
    {
      adviser_area: [`${js_dir}adviser_area.js`],

      checkout: ['https://js.stripe.com/v2/', `${js_dir}checkout.js`],

      express_wizard_hm: [`${js_dir}express_wizard_hm.js`],

      profile: [`${js_dir}profile.js`],

      profile_accounts: [`${js_dir}profile_accounts.js`],

      calibrate: [`${js_dir}calibrate.js`],

      reports: [`${js_dir}reports.js`],

      document_vault: [`${js_dir}document_vault.js`],

      settings: [`${js_dir}settings.js`],
    },
    ADV.resources || {},
  );
})();

/* eslint-disable @typescript-eslint/camelcase */
/* eslint camelcase: 0 */

const H = 'HM';
const R = 'React';

ADV.routes = {
  PageNotFound: { path: 'pageNotFound', type: R },
  FatalError: { path: 'fatalError', type: R },

  // Client Overview (react)
  ConsumerOverview: { path: 'overview/:clientId', type: R },

  UserActivity: { path: 'activity/:clientId', type: R },

  // Adviser Area
  GetStarted: { path: 'start', type: R },
  ClientEditPlan: { path: 'editplan/:clientId', type: R },
  ClientStartPage: { path: 'start/:clientId', type: R },
  Dashboard: { path: 'dashboard', type: R },
  Checkout: { path: 'Checkout', type: R },

  // reports
  NetWorth: { path: 'networth/:clientId/:pivot', type: R },
  Transactions: { path: 'transactions/:clientId/:accountId', type: R },
  ProjectedCashFlowReport: {
    path: 'projectedcashflowreport/:clientId/:mode',
    type: R,
    has_plan_selection: true,
  },
  ReactAssetAllocationReport: {
    path: 'reports/AssetAllocation/:clientId',
    type: R,
    has_plan_selection: true,
  },
  PortfolioReports: {
    path: 'portfolio-reports/:clientId',
    type: R,
    has_plan_selection: false,
  },
  AdvancedReports: { path: 'reports/:clientId/:mode', type: R, has_plan_selection: true },
  Assumptions: { path: 'assumptions/:clientId', type: R },

  // financial plan
  NewFinancialPlanWhatIfs: {
    path: 'planWhatIfs/:clientId/:goalId/:workflowEnded/:origin/:tab',
    type: R,
    has_plan_selection: true,
  },

  ProjectedBalanceSheet: {
    path: 'balance_sheet/:clientId/:is_projected',
    type: R,
    has_plan_selection: true,
  },

  // ============
  // Goals
  // ============
  Goal: {
    path: 'goal/:clientId/:goalId/:workflowEnded/:tab',
    type: R,
    has_plan_selection: true,
  },

  GoalsSummary: {
    path: 'goalsSummary/:clientId',
    type: R,
    has_plan_selection: true,
  },

  // tasks (react)
  TasksV2: { path: 'tasksV2/:clientId', type: R, has_plan_selection: true },

  /**
   * This component ensures backwards compatibility with the previous route scheme for the
   * Document Vault. Reason: some users might have old links or notification emails bookmarked.
   */
  DocumentVaultRedirect: { path: 'document_vault/:clientId/:navigateTo', type: R },

  // Document Vault
  DocumentVault: {
    path: 'document-vault/:clientId/:path/:providerType/:filterableByYear/:previousComponent',
    type: R,
  },

  // managed accounts
  AccountOpening: { path: 'account-opening/:clientId/:isFromWorkflow/:draftId', type: R },

  // pdf
  AdvancedPDF: { path: 'pdf/:clientId', type: R, has_plan_selection: true },

  // workflow. if any parameter is not used/unknown, provide 0 instead.
  // #workflow/0/1/personalinfo/930/0 <-- this will go to Personal Info in workflow 0.
  // stepId (1) is from the backend. client is 930
  // #workflow/2/0/start/930/0 <-- this will start workflow 2 for client 930
  Workflow: {
    path: 'workflow/:workflowId/:stepId/:pageId/:clientId/:pivotId/:institutionId',
    type: R,
  },

  // consumer area workflow start/end pages (acts like bookends for the workflow in consumer area).
  ConsumerWorkflowStart: { path: 'workflow/start/:clientId', type: R },
  ConsumerYouAreDone: { path: 'workflow/done/:clientId', type: R },
  DebtManagementWorkflow: {
    path: 'workflow_debt_management/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  DebtManagementWorkflowDone: { path: 'workflow_done_debt_management/:clientId', type: R },
  AllWorkflowsDone: { path: 'all_workflows_done/:clientId', type: R },
  FinancialAccountsWorkflow: {
    path: 'workflow_financial_accounts/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  WorkflowDoneV2: { path: 'workflow_done/:clientId', type: R },
  WorkflowDoneV3: { path: 'workflow_done/:clientId/:workflowId', type: R },
  FinancialAccountsWorkflowDone: { path: 'workflow_financial_accounts_done/:clientId', type: R },
  RetirementWorkflow: { path: 'workflow_retirement/:clientId/:goToSummaryWhenReady', type: R },
  RetirementWorkflowDone: { path: 'workflow_done_retirement/:clientId', type: R },
  EducationWorkflowDone: { path: 'workflow_done_education/:clientId', type: R },
  EducationWorkflow: {
    path: 'workflow_education/:clientId/:goToSummaryWhenReady/:selectedGoalId',
    type: R,
  },
  HomePurchaseWorkflow: { path: 'workflow_homePurchase/:clientId/:goToSummaryWhenReady', type: R },
  HomePurchaseWorkflowDone: { path: 'workflow_homePurchase_done/:clientId', type: R },
  EmergencyFundWorkflow: {
    path: 'workflow_emergencyFund/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  EmergencyFundWorkflowDone: { path: 'workflow_emergencyFund_done/:clientId', type: R },
  DecumulationWorkflow: {
    path: 'workflow_decumulation/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  DecumulationWorkflowDone: { path: 'workflow_decumulation_done/:clientId', type: R },
  LargePurchaseWorkflow: {
    path: 'workflow_largePurchase/:clientId/:goToSummaryWhenReady/:selectedGoalId',
    type: R,
  },
  LargePurchaseWorkflowDone: { path: 'workflow_largePurchase_done/:clientId', type: R },

  HealthCareWorkflow: { path: 'workflow_healthcare/:clientId/:goToSummaryWhenReady', type: R },
  HealthCareWorkflowDone: { path: 'workflow_done_healthcare/:clientId', type: R },
  RiskToleranceWorkflow: {
    path: 'workflow_risk_tolerance/:clientId/:redirectTo',
    type: R,
  },

  // profile. if any variable is not used, provide 0 instead. ex:
  // #profile/personalinfo/930/0
  // NOTE: HM-specific pages need to go above the "Profile" catch-all in order to be found.
  ProfileAccounts: {
    path: 'profile/accounts/:clientId/:tabSlug/:entityId',
    type: R,
  },
  ProfileStockOptions: { path: 'profile/stockoptions/:clientId/:pivotId', type: R },
  ProfileInsurance: { path: 'profile/insurance/:clientId/:pivotId', type: R },
  ProfileExpenses: { path: 'profile/expenses/:clientId/:pivotId', type: R },
  ProfileIncome: { path: 'profile/income/:clientId', type: R },

  // OLD React routes.
  // Do not delete until we migrate everything from accounts
  // some components are still used on the new work.
  // - Accounts Page      done on: ADV-8633
  // - Manage Links Page  done on: ADV-8633
  // - Add, Edit Modals
  ProfileAccountsOld: { path: 'profile/accounts_old/:clientId/:pivotId', type: R },
  ProfileLinkAccounts: {
    path: 'profile/linkAccounts/:clientId/:institutionLinkId/:fixConnection',
    type: R,
  },
  // OLD React routes.

  ProfileRiskTolerance: { path: 'profile/risktolerance/:clientId/:pivotId', type: R },
  Profile: { path: 'profile/:pageId/:clientId/:pivotId', type: R },

  // express wizard
  ExpressWizard: { path: 'express/:action/:goalId/:questionId', type: H },

  ClientSearch: { path: 'search_client', type: R },

  PdfImport: { path: 'pdf-import', type: R },

  ClientSettings: { path: 'client_settings/:clientId', type: R },

  Alight: { path: 'alight', type: R },

  NoClientAccess: { path: 'noaccess', type: R },

  AdviserSettings: {
    path: 'Application/Settings/:page',
    type: R,
  },

  Leads: {
    path: 'Leads',
    type: R,
  },

  AccountPerformanceReporting: {
    path:
      'AccountAccountPerformanceReporting/:clientId/:groupId/:accountId/:tabSlug/:allocationType/:isApex/:isLandingPageOption',
    type: R,
    skipWrapper: true,
  },

  Campaigns: {
    path: 'campaigns',
    type: R,
  },

  ApexAccount: { path: 'apex_account/:clientId/:accountId', type: R },

  MoneyGuidePro: { path: 'money_guide_pro/:clientId/:tabSlug/:tabId', type: R },

  EMoney: { path: 'eMoney/:clientId', type: R },

  Schwab: { path: 'schwab/:clientId', type: R },

  RISA: { path: 'RISA/:clientId', type: R },

  OrionTrading: { path: 'orion_trading/:clientId/:tabSlug', type: R },

  DataReconciliation: { path: 'data_recon/:clientId', type: R },

  AutoAccountWorkflow: { path: 'auto_account_workflow/:clientId', type: R },

  AutoAccountWorkflowResults: { path: 'auto_account_workflow_results/:clientId', type: R },

  AutoAccountAgreements: { path: 'auto_account_agreements/:clientId', type: R },

  RetirementSideBySide: { path: 'retirement-side-by-side/:clientId/:planIds/:goalId', type: R },

  AssetBucketingResults: {
    path: 'asset-bucketing-results/:clientId/:year',
    type: R,
    skipWrapper: true,
  },

  AssetBucketingPreview: { path: 'asset_bucketing_preview', type: R },

  AssetBucketingEdit: { path: 'asset_bucketing_edit/:clientId', type: R },

  Newsfeed: { path: 'newsfeed/:clientId', type: R },

  RightCapital: { path: 'rightcapital/:clientId', type: R },

  BeFi20Workflow: {
    path: 'beFi20/:clientId/workflow',
    type: R,
    skipWrapper: true,
  },

  BeFi20Results: {
    path: 'beFi20/:clientId/results/:compareToId/:isFromSurvey/:isInitiallyComparing',
    type: R,
    skipWrapper: true,
  },

  BeFi20Overview: {
    path: 'beFi20/:clientId/overview',
    type: R,
    skipWrapper: true,
  },

  PulseCheckWorkflow: {
    path: 'pulseCheck/:clientId/workflow',
    type: R,
    skipWrapper: true,
  },

  PulseCheckResults: {
    path: 'pulseCheck/:clientId/results',
    type: R,
    skipWrapper: true,
  },

  PulseCheckSetGoal: {
    path: 'pulseCheck/:clientId/set_goal/:categoryId/:goalId',
    type: R,
    skipWrapper: true,
  },

  GoalTrack: { path: 'goalTrack/:clientId', type: R, skipWrapper: true },

  CustomFormsWorkflow: { path: 'custom-forms-workflow/:clientId', type: R },

  CharitableGivingWorkflow: {
    path: 'charitable-giving-workflow/:clientId/:goalId',
    type: R,
    skipWrapper: false,
  },

  CharitableGivingWorkflowGoals: {
    path: 'charitable-giving-workflow-goals/:clientId',
    type: R,
    skipWrapper: false,
  },
  BeFi: { path: 'befi/:clientId', type: R },
  RiskToleranceResults: { path: 'risk_tolerance_results/:clientId/:redirectTo', type: R },

  PersonalFinanceTemplate: {
    path: 'personal-finance-template/:templateId',
    type: R,
  },
};

ADV.ChartDescriptors = {

    AssetAllocationPortfolioWidget:{
	    chart:{
		    plotBackgroundColor:null,
		    plotBorderWidth:null,
		    plotShadow:false,
		    backgroundColor:'transparent',
		    spacing: [0,0,0,0]
	    },
	    title:{
		    text:''
	    },
	    tooltip:{
		    enabled:true,
		    pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
	    },
	    plotOptions:{
		    pie:{
			    size:'100%',
			    innerSize:'65%',
			    dataLabels:{
				    enabled:false
			    },
			    point: {
				    events: {}
			    }
		    },
		    series: {
			    states: {
				    hover: {
					    enabled: false
				    }
			    }
		    }
	    },
	    series:[
		    {
			    type:'pie',
			    name:'Asset Allocation',
			    data:[]
		    }
	    ],
	    credits:{
		    enabled:false
	    }
    },

	AssetAllocationPortfolioWidget_Overview: {
		chart:{
			plotBackgroundColor:null,
			plotBorderWidth:null,
			plotShadow:false,
			backgroundColor:'transparent',
			spacing: [0,0,0,0]
		},
		title:{
			text:''
		},
		tooltip:{
			enabled:false
		},
		plotOptions:{
			pie:{
				slicedOffset: 0,
				size:'100%',
				innerSize:'90%',
				dataLabels:{
					enabled:false
				},
				point: {
					events: {}
				}
			},
			series: {
				states: {
					hover: {
						enabled: false
					}
				}
			}
		},
		series:[
			{
				type:'pie',
				name:'Asset Allocation',
				data:[]
			}
		],
		credits:{
			enabled:false
		}
	},

    Accounts: {
        chart:{
            plotBackgroundColor:null,
            plotBorderWidth:null,
            plotShadow:false,
            backgroundColor:'transparent'
        },
        title:{
            text:''
        },
        tooltip:{
            enabled:false,
            pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions:{
            pie:{
                size:245,
                innerSize:170,
                dataLabels:{
                    enabled:true,
                    formatter: function() {
                        return '<b>'+ this.point.name +'</b>: '+ Math.round(this.percentage) +' %';
                    },
                    style: {"fontSize":"14px"}
                },
                events: {
                    click: function(event){
                        //select tab
                        $('#accounts-subnav').find('li').each(function(){
                            var $this = $(this);
                            if($this.html() == event.point.name){
                                $this.trigger('click');
                            }
                        });
                    }
                }
            }
        },
        series:[
            {
                type:'pie',
                data:[]
            }
        ],
        credits:{
            enabled:false
        }
    },

    AccountsNetWorth: {
        chart:{
            plotBackgroundColor:null,
            plotBorderWidth:null,
            plotShadow:false,
            backgroundColor:'transparent'
        },
        title:{
            text:''
        },
        tooltip:{
            enabled:false,
            pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions:{
            pie:{
                size:245,
                innerSize:170,
                dataLabels:{
                    enabled:true,
                    formatter: function() {
                        return '<b>'+ this.point.name +'</b>: '+ Math.round(this.percentage) +' %';
                    },
                    style: {"fontSize":"14px"},
                    distance: 8
                },
                events: {
                    click: function(event){
                        //select tab
                        $('#accounts-subnav').find('li').each(function(){
                            var $this = $(this);
                            if($this.html() == event.point.name){
                                $this.trigger('click');
                            }
                        });
                    }
                }
            }
        },
        series:[
            {
                type:'pie',
                data:[]
            }
        ],
        credits:{
            enabled:false
        }
    },

    CashFlowReport: {
        chart: {
            type: 'column',
            events: {
                load: function (e) {
                    var x = this.yAxis[0].tickInterval / 2;
                    this.yAxis[0].update({
                        minorTickInterval: x
                    });
                }
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            categories: ['Income', 'Expenses'],
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                format: '${value:,.0f}',
                style: {
                    color: '#bababa',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                },
                tooltip: {
                    enabled: true,
                    useHTML: true,
                    shared: false,
                    crosshairs: false,
                    borderWidth: 1,
                    borderColor: '#71bee4',
                    backgroundColor: '#ffffff',
                    followPointer: true,
                    headerFormat: '',
                    pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
                }
            }
        },
        plotOptions: {
            column: {
                lineWidth: 0,
                stacking: 'normal'
            }
        }
    },

    PersonaFinanceReport_CashFlow: {
        chart:{
            plotBackgroundColor:null,
            plotBorderWidth:null,
            plotShadow:false,
            backgroundColor:'transparent'
        },
        title:{
            text:''
        },
        tooltip:{
            enabled:false,
            pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions:{
            pie:{
                size:245,
                innerSize:170,
                dataLabels:{
                    useHTML: true,
                    enabled:true,
                    formatter: function() {
                        var splitted = this.point.name.split("/");
                        return '<div class="chart-label">'+ splitted.join("/ ") +'\xa0'+ Math.round(this.percentage) +'%</div>';
                    },
                    style: {lineHeight:"26px"},
                    distance: 20
                }
            },
            series: {
                cursor: 'pointer'
            }
        },
        series:[
            {
                type:'pie',
                data:[]
            }
        ],
        credits:{
            enabled:false
        }
    },

    NetWorthReport: {
        chart: {
            type: 'column',
            events: {
                load: function (e) {
                    var x = this.yAxis[0].tickInterval / 2;
                    this.yAxis[0].update({
                        minorTickInterval: x
                    });
                }
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            categories: ['Assets', 'Liabilities'],
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                enabled: false
                // format: '',
                // style: {
                //     color: '#bababa',
                //     font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                // }
            }
        },
        tooltip: {
            enabled: false,
            useHTML: true,
            shared: false,
            crosshairs: false,
            borderWidth: 1,
            borderColor: '#71bee4',
            backgroundColor: '#ffffff',
            followPointer: true,
            headerFormat: '',
            pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
        },
        plotOptions: {
            column: {
                lineWidth: 0,
                stacking: 'normal',
                dataLabels: {
                    enabled: false,
                    align: 'center',
                    color: '#FFFFFF',
                    inside: true,
                    crop: false,
                    overflow:"none",
                    style:{
                        width:100,
                        fontFamily: "\"Open Sans\",Helvetica,Arial,sans-serif",
                        fontSize: "17px",
                        fontWeight: "700"
                    },
                    formatter: function() {
                        var point = this.point;
                        setTimeout(function(){
                            point.dataLabel.attr({
                                y: point.plotY + 10
                            });
                        }, 1000);
                        if (this.y === 0) { return "" }
                        return "$" + ADV.util.number_format(this.y, 0);
                    }
                }
            }
        }
    },

	CashReport_Overview: { /* used in ConsumerOverviewOld */
		chart: {
			type: 'column'
		},
		credits: {
			enabled: false
		},
		title: {
			text: ''
		},
		legend: {
			enabled: false
		},
		xAxis: {
			type: 'category',
			labels: {
				y: 20,
				style: {
					color: '#6C727F',
					font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
				}
			},
			tickWidth: 0
		},
		yAxis: {
			title: {
				text: ''
			},
			gridLineColor: '#dfdfdf',
			labels: {
				format: '${value:,.0f}',
				style: {
					color: '#bababa',
					font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
				}
			}
		},
		tooltip: {
			enabled: true,
			useHTML: true,
			shared: false,
			crosshairs: false,
			borderWidth: 1,
			borderColor: '#71bee4',
			backgroundColor: '#ffffff',
			followPointer: true,
			headerFormat: '',
			pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
		},
		plotOptions: {
			column: {
				lineWidth: 0
			}
		}
	},

    NetWorthCombinedReport: { /* used in Reports */
        chart: {
            type: 'column',
            events: {
                load: function (e) {
                    var x = this.yAxis[0].tickInterval / 2;
                    this.yAxis[0].update({
                        minorTickInterval: x
                    });
                }
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            categories: ['Assets', 'Liabilities'],
            lineColor: '#333333',
            lineWidth: 2,
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                enabled: true,
                formatter: function () {
                    if (this.value >= 1000000) { return '$' + (this.value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; }
                    if (this.value >= 1000) { return '$' + (this.value / 1000).toFixed(1).replace(/\.0$/, '') + 'K'; }
                    if (this.value === 0) { return '$0'; }
                    if (this.value <= -1000000) { return '($' + ((this.value / 1000000) * -1).toFixed(1).replace(/\.0$/, '') + 'M)'; }
                    if (this.value <= -1000) { return '($' + ((this.value / 1000) * -1).toFixed(1).replace(/\.0$/, '') + 'K)'; }

                }
            }
        },
        tooltip: {
            useHTML: true,
            shared: true,
            shadow: false,
            borderWidth: 0,
            backgroundColor: "rgba(255,255,255,0)",
            borderRadius: 0,
            formatter: function() {
                return HM.render('NetWorthHistoryTooltip', {
                    key: this.x,
                    networth: ADV.util.number_format(this.points[2].y),
                    networth_color: this.points[2].series.color,
                    asset_amount: ADV.util.number_format(this.points[0].y),
                    asset_color: this.points[0].series.color,
                    liability_amount: ADV.util.number_format((this.points[1].y * -1)),
                    liability_color: this.points[1].series.color
                })
            }
        },
        plotOptions: {
            column: {
                lineWidth: 0,
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    align: 'center',
                    color: '#FFFFFF',
                    inside: true,
                    crop: false,
                    overflow:"none",
                    style:{
                        width:100,
                        fontFamily: "\"Open Sans\",Helvetica,Arial,sans-serif",
                        fontSize: "17px",
                        fontWeight: "700"
                    },
                    formatter: function() {
                        var point = this.point;
                        setTimeout(function(){
                            point.dataLabel.attr({
                                y: point.plotY + (point.y < 0 ? -40 : 10)
                            });
                        }, 1000);
                        if (this.y === 0) { return "" }
                        return this.y < 0 ? "($" + ADV.util.number_format(this.y * -1, 0) + ")" :
                            "$" + ADV.util.number_format(this.y, 0);
                    }
                }
            }
        }
    },

    PersonalFinanceAccountReport: {
        chart: {
            type: 'line'
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                format: '${value:,.0f}',
                style: {
                    color: '#bababa',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            }
        },
        tooltip: {
            enabled: true,
            useHTML: true,
            shared: false,
            crosshairs: false,
            borderWidth: 1,
            borderColor: '#71bee4',
            backgroundColor: '#ffffff',
            followPointer: true,
            headerFormat: '',
            pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
        }
    }
};

var ADV = (function(app) {
  app.HelpDescriptors = {
    GetStarted: {
      title: 'Getting Started',
      description:
        'Add a client to start using Orion Planning.<span style="display:block;margin:15px 0 0 0;font-weight:700;">Come back here for helpful tips!</span>',
    },

    dashboard: {
      title: 'Dashboard',
      description:
        'The Dashboard provides an aggregate view of your top clients by assets, external assets, as well as life insurance opportunities. Use the panel on the left to create a new client or to search for existing clients.',
    },

    PersonalInfoStep: {
      title: 'Personal Information',
      description:
        'Begin the wizard by entering the household members including Spouse and any dependent children.',
    },

    GoalSelectionStep: {
      title: 'Goals',
      description:
        'Goals are the centerpiece of the financial plan. Select the ones that matter most.',
    },

    AccountLinkingStep: {
      title: 'Account Links',
      description:
        'Automatically import investment account balances and portfolio asset allocation.',
    },

    Accounts: {
      title: 'Accounts',
      description:
        'Enter/import financial accounts. Make sure to enter portfolio asset allocations, earmarks, and monthly contributions to create a baseline for the financial plan. Below are some supported account types: ' +
        '<ul><li>Checking</li><li>Savings</li><li>CD</li><li>Investment</li><li>401k/403(b)/457/IRA/Roth/SEP</li><li>Fixed Annuitiy</li><li>Credit Card</li><li>Installment Loans</li><li>Line of Credit</li><li>Student Loan</li><li>Mortgage</li></ul>',
    },

    OtherAssets: {
      title: 'Other Assets',
      description:
        'In this section, please include any other non-institutional assets you may have. Include such items as business assets, real estate, pensions, car, motorcycle, valuable artwork/jewelery, etc.',
    },

    InsuranceStep: {
      title: 'Insurance',
      description:
        'Enter any life insurance, disability insurance, or long-term care insurance policies.',
    },

    IncomeStep: {
      title: 'Income',
      description:
        'Please specify all incomes, including employment, business and real estate incomes, or social security incomes. You can also specify an expected other future income, such as an inheritance or a sale of your business.',
    },

    ExpensesStep: {
      title: 'Expenses',
      description:
        'Expenses can be entered as a single total monthly amount, or as a breakdown of expenses by category. Add as many categories as you want. To enter a custom category, use select "Other" in the Type dropdown menu.',
    },

    FutureExpensesStep: {
      title: 'Future Expenses',
      description:
        'Specify any expected large expenses in the future, such as buying a car or a home renovation. You can also specify recurring expenses.',
    },

    RiskToleranceStep: {
      title: 'Risk Tolerance',
      description:
        'Specify the risk tolerance, which will determine a matching investment portfolio for your goals.',
    },

    TaxFilingStep: {
      title: 'Tax Filing',
      description:
        'If you specify the tax filing state and status, we will estimate taxes based on your income. Alternatively, you can specify an effective tax rate. <a href="https://help.advizr.com/financial-planning/2019-tax-updates" target="_blank">See how Advizr calculates income taxes</a>.',
    },

    DocumentVault: {
      title: 'Document Vault',
      description:
        'Share documents with your advisor, such as tax documents, loan filings or other pertinent requested materials.',
    },

    FinancialPlan: {
      title: 'Financial Plan',
      description:
        "This financial plan summarizes the recommendation for each goal. Click on the dropdown, or use the buttons at the bottom, to navigate across the goals.<br><br>To edit your recommendations for a particular goal, click the 'What-Ifs' button at the top right. This will open the What-Ifs widget.<br><br>To reset the Financial Plan, click the 'Reset' button in the top right. If you cannot find the 'Reset' button, click 'What-Ifs' first.",
    },

    AccountsReport: {
      title: 'Accounts Report',
      description:
        'This section displays a summary of all of the accounts aggregated into one chart, and/or into separate charts for cash, investments and real estate with respective breakdowns for individual accounts.  A further segmentation can be provided to display accounts by type, goal, ownership and tax status.',
    },

    AssetAllocationReport: {
      title: 'Asset Allocation',
      description:
        "This report shows the client's overall asset allocation, broken down by owner, goal, institution, ownership or tax status.",
    },

    NetWorthReport: {
      title: 'Net Worth Report',
      description:
        'This report displays the overall net worth, segmented into overall assets and liabilities. Click on each section to expand and view more details.',
    },

    ProjectedCashFlowReport: {
      title: 'Projected Cash Flow Report',
      description:
        "This report displays the clients' projected cash flows, inclusive of all inputs and outputs, from today to plan-end, and is filterable by 'current situation' or 'proposed plan'.  Click on a section to expand and view more detailed cash flow items. Also, use the menu on the top right for easy access to a specific milestone.",
    },
  };
  return app;
})(ADV || {});

var ADV = (function (app) {
    app.tooltip_tours = {


    };

    return app;

})(ADV || {});
/* eslint-disable @typescript-eslint/camelcase */

ADV.tooltip_callouts = {
  AdviserSearchClient: {
    Welcome: {
      html:
        'Alight users can use the search operators, "organization" and "alightid" to further specify their search. For example, "organization:FedEx Dave Smith", "alightid:2700062". Combinations searches may also be used. For example, "organization:fedex organization:Huntington jane" will return all clients whose name starts with "jane" AND are in the organization Fedex OR organization Huntington Ingalls.',
      orientation: 'right',
    },
  },

  RetirementAssetsChart: {
    Current: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    ProposedPlan: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    ProposedPlanOverview: {
      html: 'Based on information entered in the What-Ifs fields from the recommendations page',
      orientation: 'left',
    },
  },

  FinancialPlan: {
    TooltipCurrent: {
      orientation: 'left',
    },
    TooltipRecommended: {
      orientation: 'left',
    },
  },

  FinancialPlan_Recommandations: {
    RetirementAssets_CurrentLabel: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    RetirementAssets_ProposedLabel: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    DebtManagement_CurrentLabel: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    DebtManagement_ProposedLabel: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    ActionNeededLabel: {
      html:
        'Action Needed indicates there are Action Steps listed below that have not yet been checked off as done.',
      orientation: 'right',
    },
    OnTrackLabel: {
      html: 'On Track indicates that there are no incomplete Action Steps listed below.',
      orientation: 'right',
    },
  },

  EditAccount_RealEstate: {
    MonthlyPayment: {
      html:
        'Monthly payment includes principal and interest. Real estate taxes, condos fees, home owners insurance can be added in the Expenses step.',
      orientation: 'right',
    },
    YearlyRentalIncome: {
      html: 'This is your net income from the property.',
      orientation: 'right',
    },
  },

  Income_Add: {
    EmploymentAmount: {
      html:
        "Enter your total income before deducting taxes, benefits, FICA, contributions, etc. in today's dollars.",
      orientation: 'right',
    },
    OtherAmount: {
      html: "Please specify the amount before deducting taxes in today's dollars.",
      orientation: 'right',
    },
    StartAtAge: {
      html:
        'Enter the age of the Earner when the income will start. To start this income immediately, leave this field blank.',
      orientation: 'right',
    },
    EndsAtAge: {
      html:
        'Enter the age of the Earner when the income will stop. To stop this income at retirement, leave this field blank.',
      orientation: 'right',
    },
    Inflation: {
      html:
        'Enter the inflation rate applied to the Salary field. Leave this field blank to use the global "Income Growth Rate" found in Settings.',
      orientation: 'right',
    },
    TaxFree: {
      html:
        'If checked, this income will be free of federal and state taxes (e.g. Military combat pay). By default employment incomes are taxed.',
      orientation: 'right',
    },
    SECATax: {
      html: 'Applies SECA tax and deducts half the amount from pre-tax profit.',
      orientation: 'right',
    },
    YearlyTaxableAmount: {
      html: 'Enter a taxable amount if the amount to be taxed is different from the yearly amount.',
      orientation: 'right',
    },
  },

  Profile_Accounts_Form_InheritedIRA: {
    DistributionSchedule: {
      html:
        'List distribution percentages for each year between the current year and the 10th year after inheritance. ' +
        'For example, entering 80, 20, followed by 0 values for subsequent years indicates distribution 80% of the ' +
        'balance in the first year and the remaining 20% in the second year, while 20, 20, 20, 20, 20, followed by 0 values ' +
        'for subsequent years would distribute 20% each year for 5 years.',
      orientation: 'right',
    },
  },

  PmiField: {
    html:
      'Private mortgage insurance, also called PMI, is a type of mortgage insurance you might be required to pay for if you have a conventional loan. Like other kinds of mortgage insurance, PMI protects the lender if you stop making payments on your loan.',
    orientation: 'right',
  },

  FinancialAccounts_Add: {
    Nickname: {
      // invoked manually via API
      target: 'input[name="AccountName"]',
      html: "This will help you easily identify this account wherever it's shown.",
      orientation: 'right',
    },
  },

  Profile_Accounts_Edit: {
    ShowAccount: {
      html:
        'If disabled, the account will be excluded from the Accounts list and the Financial Plan.',
      orientation: 'right',
    },
    AccountEarmark: {
      html: 'Please select the goal(s) you will fund with this specific account.',
      orientation: 'right',
    },
  },
  Profile_Accounts_Form_FixedAnnuity: {
    SurrenderSchedule: {
      html:
        'Enter the Surrender Schedule starting from the first contract year in the following comma separated format: 15%, 15%, 15%, 15%, 12.86%, 10.71%, 8.57%, 6.43%, 4.29%, 2.14%. In this example, there is a 15% surrender charge applied during the first year of the annuity based on the Purchase Year field.',
      orientation: 'right',
    },
  },
  Profile_Accounts_Form_Brokerage: {
    TurnoverRatio: {
      html: 'Percentage of portfolio that is realized and taxed annually.',
      orientation: 'right',
    },
    CapitalGainsRatio: {
      html: 'Percentage of portfolio taxed at long-term capital gains rate.',
      orientation: 'right',
    },
  },

  Profile_Accounts_Form_Annuity: {
    AnnuityLivingBenefitRider: {
      CurrentBenefitBase: {
        html: 'The benefit base is used to calculate the guaranteed minimum income',
        orientation: 'right',
      },
      RollUpRate: {
        html: 'The rate at which the benefit base grows',
        orientation: 'right',
      },
      WithdrawalBenefit: {
        html: 'The percentage of the benefit base that is withdrawn as income',
        orientation: 'right',
      },
    },
  },

  Profile_Accounts_Insurance_Policy: {
    LifeInsurance: {
      html: 'The rate the market value for the policy grows.',
      orientation: 'right',
    },
  },

  LinkAccount_Form: {
    FinancialInstitution: {
      html: "Can't find your institution? Please contact Customer Support to add it to the list.",
      orientation: 'right',
    },
  },

  ConsumerOverview: {
    Reset: {
      html: 'Reset to auto-generated Action Steps',
      orientation: 'top',
      hoverOnly: true,
    },
    Remove: {
      html: 'Remove',
      orientation: 'top',
      hoverOnly: true,
    },
    MarkAsDone: {
      html: 'Mark as Done',
      orientation: 'top',
      hoverOnly: true,
    },
    MarkAsNotDone: {
      html: 'Mark as Not Done',
      orientation: 'top',
      hoverOnly: true,
    },
  },

  SocialSecurity: {
    PIA: {
      html: 'Estimates monthly PIA from current income.',
      orientation: 'right',
      hoverOnly: true,
    },
    MonthlyPIA: {
      html:
        'The Primary Insurance Amount (PIA) is the benefit a person would receive if he/she elects to begin receiving retirement benefits at his/her Full Retirement Age (FRA). Estimates are also available from the Social Security Administration at https://www.ssa.gov/.',
      orientation: 'right',
      hoverOnly: true,
    },
    StartsAtAge: {
      html: 'Age will be used to calculate monthly retirement benefit based on monthly PIA.',
      orientation: 'right',
      hoverOnly: true,
    },
  },

  DebtManagement: {
    DebtRepaymentStrategy: {
      orientation: 'right',
      hoverOnly: true,
      html:
        'Additional payments chosen in the Cash Flow section will be put toward one loan at a time. For example, if you ' +
        'choose "Highest Interest Rate First", the loan that has the highest interest rate will be paid off until it is ' +
        'completely paid down. Then, the next highest interest rate loan will be paid off, and so on.',
    },
  },

  Expenses: {
    EstimateExpense: {
      orientation: 'right',
      hoverOnly: true,
      html:
        'Estimate your expenses for this category based on historical data available from your linked accounts.',
    },
  },

  Insurance: {
    AssetsRunOut: {
      orientation: 'right',
      hoverOnly: true,
      html:
        "The age at which the surviving partner will run out of assets based on investable assets, the survivor's income and current life insurance coverage.",
    },
    CurrentCoverage: {
      orientation: 'right',
      hoverOnly: true,
      html:
        'The current coverage combines existing life insurance with additional coverage specified in the what-ifs section.',
    },
  },
  Contribution: {
    EndYear: {
      html:
        "With plan default, contributions automatically end when the account's earmarked goal starts. However, if an account is not earmarked to any goal, contributions will continue until the end of plan.",
      orientation: 'right',
    },
  },
  Account: {
    Fees: {
      html:
        'This fee will reduce the investment return to represent account management and investment related fees. For example, if the account return is 7% and you enter 1% for the account fee, your net return will be 6%.',
      orientation: 'right',
      hoverOnly: true,
    },
    FeesAnnuity: {
      html:
        'This fee will reduce the investment return to represent account management and investment related fees. This account fee should also include any fees associated with M&E Expenses and Riders. For example, if the account return is 7% and you enter 2% for the account fee, your net return will be 5%.',
      orientation: 'right',
      hoverOnly: true,
    },
  },

  DebtManagementChart: {
    Current: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    ProposedPlan: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    ProposedPlanOverview: {
      html: 'Based on information entered in the What-Ifs fields from the recommendations page',
      orientation: 'left',
    },
  },
};

/* global ADV, HM */
/*
    eslint-disable
    func-names,
    no-param-reassign,
*/

window.ADV = (function (app) {
  app.init = function (callback) {
    return new Promise((resolve) => {
      // Configure HairyMustache
      HM.setViewModels(HM.ViewHelper);

      // load templates, then start application.
      ADV.util.loadTemplates(() => {
        // app is ready!
        if (typeof callback === 'function') {
          callback.call();
        }
        resolve();
      });
    });
  };

  return app;
}(window.ADV || {}));

/* global HM */
/* eslint-disable @typescript-eslint/camelcase,func-names,no-template-curly-in-string,no-param-reassign */

/**
 * As a temp solution, mustache templates are being hardcoded here.
 *
 * After upgrading EO.Pdf version, the request to get the templates is failing,
 * Hard-coding the templates avoids the need for such request.
 *
 * TODO -> Remove these templates and initPrint function as soon as the migration to React is completed
 */
const templates = {
  AdminArea:
    '<div id="master_container" class="area-admin" data-tplid="{{tplid}}">\n    <div id="main">\n        {{>AdminAreaLogo}}\n        <div id="module_container"></div>\n    </div>\n    {{>pagination-footer}}\n</div>',
  AdviserArea:
    '<div id="master_container" data-tplid="{{tplid}}">\n    <div id="main">\n        <div id="module_container"></div>\n        <footer class="application-footer">\n            Copyright &copy; {{info.CopyrightYear}} Advizr, Inc. &nbsp; {{info.version}} &nbsp; <a href="/Legal/Disclosures" target="_blank">Disclosures</a> &nbsp; <a href="/Legal/Privacy" target="_blank">Privacy Policy</a> &nbsp; <a href="#" data-action="Feedback">Feedback</a>\n        </footer>\n    </div>\n</div>',
  ConsumerArea:
    '<div id="master_container" data-tplid="{{tplid}}">\n    {{>WhiteLabel}}\n    <div id="main">\n        <div id="module_container"></div>\n    </div>\n    {{>consumer-area-footer}}\n</div>',
  ExpressWizardArea:
    '<div id="master_container" data-tplid="{{tplid}}">\n    <div id="module_container"></div>\n</div>',
  ChartEmptyState:
    '<div class="ChartEmptyState" data-tplid="{{tplid}}">\n    <i class="fa fa-chart-bar"></i>\n    <p>There is no chart data to display.</p>\n</div>',
  DashboardIntroBox:
    '<div id="DashboardIntroBox" data-tplid="{{tplid}}">\n    <i class="fa fa-times close"></i>\n    <div class="welcome-blurb">\n        <h3>Welcome to Advizr, {{name}}!</h3>\n        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed placerat viverra venenatis. Donec hendrerit nunc a risus mollis, vitae posuere purus egestas.</p>\n    </div>\n    <div class="demo">\n        <img src="{{img_dir}}demo-screenshot.jpg">\n        <span>\n            <i class="fa fa-caret-right"></i>\n            <p>Watch demo</p>\n        </span>\n    </div>\n    <div class="hot-tip">\n        <h3>Hot Tip: Need help?</h3>\n        <p>Anytime in the application, you can click the help <i class="fa fa-question"></i> button on the top right of the page.</p>\n    </div>\n</div>',
  ErrorBubble:
    '<div class="ErrorBubble {{#InfoMessage}}info{{/InfoMessage}}" data-tplid="{{tplid}}">\n    <div class="icon"><i class="fa fa-exclamation"></i></div>\n    <i class="fa fa-times close"></i>\n    {{{errors}}}\n    {{{InfoMessage}}}\n</div>',
  Feedback:
    '<div class="popup fixed" id="Feedback" data-tplid="{{tplid}}">\n    {{^HasHelpText}}\n    <h2><i class="far fa-comment"></i>Send Feedback<i class="fa fa-times close"></i></h2>\n    <p>HELLO WORLD HELLO WORLD Please tell us about any issues, suggestions, or questions. If you need any help, please check our <a href={{resourceCenterUrl}} target="_blank">Resource Center page</a>, or email us at <a href="mailto:financialplanning@orion.com">financialplanning@orion.com</a> or call (844) 223-8497.</p>\n    <form class="adv-form">\n        <ul class="horizontal-layout">\n            <li>\n                <textarea placeholder="Enter your request here." maxlength="1200"></textarea>\n            </li>\n        </ul>\n        <div class="actions">\n            <button class="green submit lhs">Send Request</button>\n            <button class="secondary cancel dismiss lhs">Cancel</button>\n        </div>\n    </form>\n    {{/HasHelpText}}\n    {{#HasHelpText}}\n    <h2><i class="far fa-calendar-alt"></i>Get Help<i class="fa fa-times close"></i></h2>\n    <p>{{HelpText}}</p>\n    {{/HasHelpText}}\n</div>',
  FormErrorMessage:
    '<div class="error-list">\n\t{{#errors}}\n\t<label class="error">{{.}}</label>\n\t{{/errors}}\n</div>',
  Help:
    '<div class="popup fixed {{^title}}no-contextual{{/title}}" id="Help" data-tplid="{{tplid}}">\n    <i class="fa fa-times close"></i>\n    {{#title}}\n        <div class="contextual">\n            <h2>You\'re looking at...</h2>\n            <h3>{{title}}</h3>\n            <p>{{{description}}}</p>\n        </div>\n    {{/title}}\n    <div class="everpresent">\n        <h2>Help oih ijewoijoewirj wo</h2>\n        <form class="adv-form">\n            <div class="input">\n                <i class="fa fa-search"></i>\n                <input type="text" placeholder="Search the Resource Center" id="term">\n            </div>\n            <input type="submit" value="Search">\n        </form>\n        <ul class="help-links">\n            <li><a href={{resourceCenterUrl}} target="_blank">Resource Center</a></li>\n            <li><a href="#" data-action="Demo">Watch a Demo</a></li>\n            {{#sample_clients}}\n            <li><a href="{{demo_uri}}&masterSampleClientId={{id}}" target="_blank">View sample client {{firstName}} {{lastName}}</a></li>\n            {{/sample_clients}}\n            {{^consumer_area}}\n                <li><a href="#" data-action="Feedback">Report a Problem</a></li>\n                <li><a href="#" data-action="Feedback">Contact Orion Planning</a></li>\n            {{/consumer_area}}\n        </ul>\n    </div>\n</div>\n',
  InviteClient:
    '<div class="popup {{Count}}" id="InviteClient" data-tplid="{{tplid}}">\n    <h2>Invite {{client.FirstName}} to Advizr<i class="fa fa-times close"></i></h2>\n    <form class="page1 adv-form">\n        <h3>{{client.FirstName}} will be able to complete the wizard and view their financial plan. After the client has registered, you will get an email confirmation.</h3>\n        <ul class="horizontal-layout">\n            <li>\n                <input id="Email" name="email" type="text" maxlength="50" placeholder="Client\'s Email Address" value="{{client.Email}}">\n            </li>\n        </ul>\n        {{#client.IsPlanGenerated}}\n        <section id="configure_client_access">\n            <ul><li class="{{#IsWizardMode}}selected{{/IsWizardMode}}" data-item="wizard">\n                <h2>Wizard Mode</h2>\n                <p>Client will have access to the wizard and be able to enter or update their profile information.</p>\n            </li><li class="{{#IsFinancialPlanMode}}selected{{/IsFinancialPlanMode}}" data-item="plan">\n                <h2>Financial Plan Mode</h2>\n                <p>Client will have view-only access to their Financial Plan.</p>\n            </li>{{#ShowManagedAccounts}}<li class="{{#IsManagedAccountsMode}}selected{{/IsManagedAccountsMode}}" data-item="managed-accounts">\n                <h2>Managed Accounts Mode</h2>\n                <p>Client will be able to see managed accounts.</p>\n            </li>{{/ShowManagedAccounts}}{{#ShowUniversalAccess}}<li class="{{#IsUniversalAccessMode}}selected{{/IsUniversalAccessMode}}" data-item="universal-access">\n                <h2>Full Access Mode</h2>\n                <p> Client will have access to update their Profile and Financial Plan after completing the wizard.</p>\n            </li>{{/ShowUniversalAccess}}</ul>\n        </section>\n        {{/client.IsPlanGenerated}}\n        <div class="actions">\n            <button class="green" id="SaveEmailButton">Next</button>\n            <button class="cancel secondary dismiss">Cancel</button>\n        </div>\n    </form>\n    <div class="page2">\n        <button id="SendInvitationButton"><i class="far fa-envelope"></i>Send Invitation to {{client.FirstName}}</button>\n        <label>Alternatively, you can copy the link below and paste it in an email to {{client.FirstName}}:</label>\n        <form class="adv-form"><input type="text" id="LinkField" readonly><button id="copy_to_clipboard" class="btn-primary"><i class="fa fa-copy"></i></button></form>\n    </div>\n</div>',
  MissingAccounts:
    '<div id="MissingAccounts" class="MissingInfo" data-tplid="{{tplid}}">\n\n    <h1>You have not added any accounts.</h1>\n    <h2>You can add banking, taxable investment, retirement, loan accounts, and more.</h2>\n\n    <i class="fa fa-university"></i>\n\n    <button data-route="profile/accounts/{{clientId}}/new"><i class="fa fa-plus"></i>Add an Account</button>\n\n</div>',
  PaginationFooter:
    '<ul id="PaginationFooter" class="page-footer" data-tplid="{{tplid}}">\n    {{#Pages}}\n        {{#NoClick}}<li><a class="btn page-btn noclick">{{Page}}</a></li>{{/NoClick}}\n        {{^NoClick}}\n            <li><a class="btn page-btn{{#Selected}} selected{{/Selected}}" data-page="{{Page}}">{{Page}}</a></li>\n        {{/NoClick}}\n    {{/Pages}}\n</ul>',
  PlanNotStarted:
    '<div id="PlanNotStarted" class="MissingInfo" data-tplid="{{tplid}}">\n\n    <h1 class="small">You have not yet created a financial plan.</h1>\n\n    <i class="far fa-edit"></i>\n\n    <button>Create a Financial Plan</button>\n\n</div>',
  Tooltip:
    '<div id="Tooltip" class="{{classes}}" style="{{inline_styles}}" data-tplid="{{tplid}}">\n    <i class="fa fa-times close"></i>\n    {{{html}}}\n    <div class="buttons">\n        {{#next}}<button class="btn-next" data-step="{{next}}">Next<i class="fa fa-angle-right"></i></button>{{/next}}\n        {{#done}}<button class="btn-done">OK, got it.</button>{{/done}}\n    </div>\n</div>',
  alert:
    '<div class="popup fixed" id="alert" data-tplid="{{tplid}}">\n    <p>{{{message}}}</p>\n    <div class="actions">\n        <button>{{button_label}}</button>\n    </div>\n</div>',
  confirm:
    '<div class="popup fixed modal" id="confirm" data-tplid="{{tplid}}">\n    <p>{{{message}}}</p>\n    <div class="actions">\n        {{#buttons}}\n        <button data-index="{{index}}" class="{{classes}}">{{label}}</button>\n        {{/buttons}}\n    </div>\n</div>',
  AdviserTerms:
    '<h3 style="text-align: center;font-weight: 600;color:#666;margin:0 0 30px 0;">Service Agreement</h3>\n<div>\n    This Application Services Agreement (the "Agreement") is made and entered into as of the Master Effective Date by and between ADVIZR, INC., A DELAWARE\n    CORPORATION ("Advizr") and the entity listed as Customer in the table above.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    A. Advizr offers a software-as-a-service offering (the "Application Services") designed to enable Customer to scaleably provide financial planning services\n    for Advisee\'s, and\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    B. Customer desires to purchase the Advizr Services.\n</div>\n<div>\n</div>\n<div>\n    For the good and valuable consideration set forth herein, the parties agree as follows:\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1. DEFINITIONS\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.1 "Advisees" means individuals that are party to a written agreement with Customer pursuant to which Customer provides financial planning services on\n    such individual\'s behalf. Advisees may have limited access to the Application Services.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.2 "Authorized User(s)" means Customer\'s employees, contractors and Advisees who are authorized by Customer to access the features and functions of the\n    Application Services.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.3 "Customer Data" means the information and data provided to Advizr by Authorized Users through the Application Services.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.4 "Fee" means the fee specified in the Order Form for the applicable services.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.5 "Initial Term" has the meaning set forth in Paragraph 3.1 ("Term").\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.6 "Order Form" means Advizr\'s standard form of ordering document pursuant to which Services are ordered by Customer subject to the terms and conditions\n    of this Agreement, which must be approved by Advizr to be effective.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.7 "Professional Services" means the development or consulting services ordered by Customer pursuant to an Order Form.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    1.8 "Services" mean any services provided by Advizr pursuant to this Agreement including the Application Services, Professional Services and related other\n    services like technical support services\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2. ACCESS GRANTS; PERFORMANCE OF SERVICES; AND OWNERSHIP\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.1 Provision of Services. Subject to the terms and conditions of this Agreement, Advizr will provide the Services ordered pursuant to any Order Form to\n    Customer in a workmanlike and professional manner in accordance with industry standards.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.2 Access Protocols; Authorized Users. Advizr will promptly after accepting an Order Form provide\n</div>\n<div>\n    Customer the Access Protocols. Customer will: (a) safeguard the Access Protocols and ensure that Authorized Users safeguard the Access Protocols; (b) make\n    Authorized Users aware of the Customer\'s obligations under this Agreement, and (c) be responsible for all acts and omissions of Authorized Users.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.3 Right of Access; Limitation on Number of Concurrent Users. Subject to terms and conditions of this Agreement and Advizr\'s acceptance of an applicable\n    Order Form, Advizr grants to Customer a non-exclusive, non-transferable right during the Term to allow Authorized Users to access the Application Services\n    solely for the purpose of developing financial plans on behalf its Advisees. Customer\'s right to access the Application Services is limited to the number\n    of Authorized Users listed in the applicable Order Form(s).\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.4 Customer Data. Use of the Application Services will permit or require Customer to provide Customer Data to Advizr for purposes of processing, analyzing\n    and storing such Customer Data and otherwise performing the Services. Customer hereby grants to Advizr a limited license: (a) during the Term to use, copy,\n    display, disclose, modify and distribute the Customer Data solely for the purpose of providing the Services and (b) on a perpetual basis, to use, copy,\n    display, disclose, modify and distribute the Customer Data solely to create and compile aggregated data and/or statistics; provided, however, in any such\n    aggregated data or statistics, Advizr will ensure that the Customer Data is used in aggregated form only and in a manner that is not directly attributable\n    to or identified with Customer or its Advisees. Advizr will use appropriate administrative, physical and technical safeguards to protect sensitive Customer\n    Data, including, as appropriate, encryption technology.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.5 Restrictions on Use. Customer will not: (a) modify, adapt, alter, translate or create derivative works of the Services, including the Application\n    Services; (b) sublicense, lease, rent, loan or otherwise transfer Customer\'s rights hereunder (except in connection with an assignment of Customer\'s rights\n    permitted under Section 12.3 ("Assignment") to any third party; (c) reverse engineer, decompile, disassemble, or otherwise attempt to derive the human\n    readable, source code version of the Application Services or the technology underlying the Application Services; (d) publish or post false or misleading\n    information about Advizr; (e) remove any proprietary notices of Advizr or third parties found on, in or in association with the Services; (f) publish any\n    performance or benchmark tests or analysis relating to the Services, including the use thereof, without the approval of Advizr; (g) use the Services in any\n    way that infringes any third party intellectual property right, breaches the terms of any agreement between Customer and any third party or violates\n    applicable law.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.6 Advisee Agreement. Customer acknowledges that prior to accessing the Application Services, Advisees may be required to enter into an end user license\n    agreement that includes a disclaimer that Advizr is not liable for any decisions, acts or omissions of the Advisee based upon any financial plan developed\n    by Customer.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.7 Ownership. Advizr retains all right, title and interest in the Services, including the Application Services, and all intellectual property rights\n    therein. All rights not expressly granted by Advizr is reserved. Customer retains all right, title and interest in the Customer Data and all intellectual\n    property rights therein. All rights not expressly granted by Customer is reserved.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    2.8 Feedback. Advizr may request that Customer provide feedback regarding the use, operation and functionality of the Services ("Feedback"), which Customer\n    will provide at its discretion. Feedback will include any information about operating results, known or suspected bugs, errors or compatibility problems\n    and user-desired features. Customer agrees that Advizr, without any compensation to Customer, will have an irrevocable right to use the Feedback and\n    related information in any manner it deems appropriate.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    3. TERM AND TERMINATION.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    3.1 Term. The term of this Agreement will commence on the Date of the Customer\'s signature and will continue for as long as any Order Form is in effect,\n    unless terminated in accordance with this Section or as otherwise expressly provided in this Agreement (the "Term").\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    3.2 Termination for Material Breach. Either party may terminate this Agreement or any Order Form, at its discretion, effective immediately upon written\n    notice to the other if the other party materially breaches any provision of this Agreement and does not substantially cure the breach within thirty (30)\n    days after receiving written notice.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    3.3 Suspension of Service(s). At any time during the Term, Advizr may, immediately upon notice to Customer, suspend access to any Service, at its\n    discretion, including a threat to the technical security or technical integrity of the Services or any amount due under this Agreement is not received by\n    Advizr within fifteen (15) days of the due date.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    3.4 Termination upon Bankruptcy or Insolvency. Advizr may, at its option, terminate this Agreement immediately upon written notice to Customer, in the\n    event (a) that Customer becomes insolvent or unable to pay its debts when due; (b) Customer files a petition in bankruptcy, reorganization or similar\n    proceeding, or, if filed against, such petition is not removed within ninety (90) days after such filing; (c) Customer discontinues its business; or (d) a\n    receiver is appointed or there is an assignment for the benefit of Customer\'s creditors.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    3.5 Termination for Convenience. Advizr may terminate any Order Form and this Agreement at any time at its convenience upon no less than thirty (30) days\n    notice. In the event of any such termination, Advizr will refund to Customer any prepaid, but unused fees, on a straight-line, pro-rata basis, based on a\n    365 day year.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    3.6 Effects of Termination. Upon termination or expiration of this Agreement for any reason: (a) any amounts owed to Advizr before such termination or\n    expiration will be immediately due and payable; and (b) all access rights granted will immediately cease to exist. The following provisions will survive\n    termination: Sections 1 ("Definitions"), 3 ("Term and Termination"), 4 ("Warranties, Disclaimers and Limitations on Damages"), 5 ("Indemnity"), 6\n    ("Confidential Information"), 7 ("Payment Terms") and 8 ("Miscellaneous") of this Agreement will survive any termination or expiration of this Agreement.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4. WARRANTIES, DISCLAIMERS AND LIMITATION ON DAMAGES\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.1 General Representations. Each party hereby represents and warrants: (a) that it is duly organized, validly existing and in good standing under the laws\n    of its jurisdiction of incorporation or organization; (b) that the execution and performance of the Agreement will not conflict with or violate any\n    provision of any law having applicability to such party; and (c) that the Agreement, when executed and delivered, will constitute a valid and binding\n    obligation of such party and will be enforceable against such party in accordance with its terms.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.2 General Disclaimers. EXCEPT AS EXPRESSLY PROVIDED IN THE AGREEMENT, INCLUDING ANY SCHEDULE, NEITHER PARTY MAKES ANY WARRANTIES OF ANY KIND, WHETHER\n    EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,\n    NON-INFRINGEMENT, QUIET ENJOYMENT OR FROM A COURSE OF DEALING OR USAGE IN TRADE. ADVIZR DOES NOT WARRANT, AND SPECIFICALLY DISCLAIMS, THAT THE SERVICES\n    WILL BE ACCURATE, SECURE, WITHOUT INTERRUPTION, OR ERROR-FREE.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.3 Use; Decision Support Disclaimer. Customer acknowledges that the Application Services are provided to Customer and its Authorized Users as a decision\n    support tool to aid in its financial planning business. Customer agrees that Customer will not rely solely on the output of the Application Services and\n    that Customer and its Authorized Users will rely on their professional judgment in providing any financial planning services to any Advisee. Customer is\n    solely responsible for (i) Customer\'s and its Authorized Users\' use of the Services, including the Application Services and the Professional Services and\n    (ii) any decision Customer or Advisees make, in whole or in part, therefrom, including any trades and investment decisions or strategies. Customer further\n    agrees that Advizr will not be responsible for any loss or damage to Customer, its Authorized Users, or any Advisees caused by the failure of the\n    Application Services or any error or data produced or derived therefrom.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.4 No Professional Advice. Advizr is not engaged in rendering any investment, trading or other professional advice. If investment, trading or other\n    professional advice is required, the services of a competent, licensed professional should be sought. No employee, agent or representative of Advizr is\n    authorized to provide any such advice of any nature whatever, and any such advice, if given, is in violation of Advizr\'s policies, is unauthorized and may\n    not be relied upon.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.5 No Guaranteed Results. THE SERVICES ARE NOT GUARANTEED TO ACHIEVE ANY PARTICULAR RESULTS. The use of any trading system or strategy, including any\n    system or strategy integrated within the Services, does not and cannot guarantee that Customer or Advisees will make profits, increase profits or minimize\n    losses.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.6 Customer is Solely Responsibility for Input Correctness and Accuracy: The quality of the product\'s analysis and optimization depends on the Authorized\n    User\'s inputs. While automated guidance and value generation has been made available in the product to ease and expedite entry of the parameters required\n    for the product\'s analysis and optimization, Customer and its Authorized Users are solely responsible for ensuring the quality of all its inputs. As such,\n    you must carefully review and update all input parameters and modify their values in all ways necessary to ensure their accuracy and fidelity. While there\n    are other factors governing analysis and optimization accuracy, the quality of the product outputs depends on the accuracy of your inputs.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.7 Beta Feature Disclaimers: Any input, feature of function marked "Alpha", "Beta" or similar designation invokes a Beta version of the Applications\n    Services. The Beta version is intended for the sole purpose of obtaining product feedback from the product\'s future customers, and Advizr\'s partners.\n    Accordingly, these additional terms and disclaimers apply to any Beta service.\n</div>\n<div>\n    (a) Beta-Quality Testing: The basic functionality of this Beta version has been tested by Advizr\'s internal users but it has not yet undergone production\n    quality testing. As such, reports of software malfunctions and bugs are fully anticipated and are solicited by Advizr.\n</div>\n<div>\n    (b) Beta-Quality Performance: The performance of the optimization algorithms has not been performance-enhanced. Specifically, the current Beta version run\n    times may exceed product release performance parameters for optimization runs.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.8 Specific Disclaimers. As the Services evolve, Advizr may provide Customer and Authorized Users explanations on how the Services work and certain\n    specific disclaimers. Any such specific disclaimers acknowledged by any Authorized User, including through a clickwrap made available within the\n    Applications Services, are agreed to be incorporated by reference into this Agreement. The following specific disclaimers appear within the Application\n    Services:\n</div>\n<div>\n    (a) No Guarantee. The recommendations above are not guarantees of investment performance or the full attainment of your goal. The results of this plan are\n    based on assumptions for, among other things, historical investment performance, client savings rates, average inflation rates and estimated tax rates. In\n    addition, investment expenses have not been considered in any of the calculations.\n</div>\n<div>\n    (b) Investment Disclosures: The projected investment returns are hypothetical in nature and do not reflect actual investment returns in the future.\n</div>\n<div>\n    (c) Data Integrity: The results of this plan are based, in large part, by the data that you have either entered into the Advizr application or provided to\n    your financial professional. Any underestimations or overestimations of data entered by you could drastically change the recommendations made by your\n    financial professional. It is important to update your financial information frequently.\n</div>\n<div>\n    (d) Tax &amp; Legal Advice: The creation and results of this plan do not constitute legal or tax advice. You should consult with an attorney or an\n    accountant for advice in those areas.\n</div>\n<div>\n    (e) IRS Circular 230 Notice: Any tax information provided herein is not intended or written to be used, and cannot be used, for the purpose of avoiding\n    penalties that may be imposed on any taxpayer.\n</div>\n<div>\n    (f) Limits of financial modeling. Market volatility may be more extreme than what is represented by the simulation.  The accuracy of the simulation is reduced\n    in periods of market crisis.  The simulation does not consider all investments, and those not considered might have characteristics similar or superior to those\n    analyzed in this report.\n</div>\n<div>\n    (g) Customer Future Situation: It is possible that your income, cash flow and ability to save may change in the future. The projections, in large part, are\n    based on the data that you have provided. It is important to update your plan frequently to account for any changes in your financial status. Therefore,\n    the results of this plan today cannot account for future changes in your financial situation.\n</div>\n<div>\n    (h) Investment and Insurance Product Fees: Depending on what investment or insurance product you purchase, you may incur front-end charges, annual expenses\n    or performance fees. For certain products, you may incur surrender charges, income taxes and penalties if the product is sold before a pre-determined\n    period. For variable life insurance and annuity products, you will incur mortality and expense fees. None of these expenses have been factored into the\n    projections. If included, fees and other expenses would materially reduce the projections.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.9 Disclaimer of Indirect Damages. IN NO EVENT SHALL EITHER PARTY BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE OR EXEMPLARY\n    DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, LOSS OF DATA, LOSS OF REVENUE, LOSS OF MARKET CAPITALIZATION, INTERRUPTION OF SERVICE, OR LOSS OF\n    BUSINESS OR BUSINESS OPPORTUNITY, EVEN IF SUCH DAMAGES ARE FORESEEABLE AND WHETHER OR NOT SUCH PARTY HAS BEEN ADVISED OF THE POSSIBILITY THEREOF. IN NO\n    EVENT WILL ADVIZR BE LIABLE FOR THE PROCUREMENT OF SUBSTITUTE SERVICES.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    4.10 Limitations on Liability. ADVIZR\'S MAXIMUM AGGREGATE LIABILITY UNDER ANY ORDER FORM WILL NOT EXCEED THE TOTAL AMOUNT OF FEES RECEIVED BY ADVIZR\'S\n    UNDER SUCH ORDER FORM DURING THE TWELVE (12) MONTH PERIOD PRIOR TO THE FIRST DATE ON WHICH THE LIABILITY AROSE.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    5. INDEMNITY.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    5.1 Advizr Indemnity. Advizr will indemnify, defend and hold Customer, its directors, officers, employees and representatives (each a "Customer Indemnified\n    Party"), harmless from and against any and all losses, damages, liability, costs and expenses awarded by a court or agreed upon in settlement, as well as\n    all reasonable and related attorneys\' fees and court costs, (collectively "Losses") arising out of any third party claim alleging that the Application\n    Services infringe any U.S. patent or copyright or breach any Advizr warranty.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    5.2 Exclusions. Section 5.1 will not apply if the alleged claim arises, in whole or in part, from (i) a use or modification of the Services by any Customer\n    or any Authorized User in a manner outside the scope of any right granted or in breach of this Agreement, (ii) a combination, operation or use of the\n    Services with other software, hardware or technology not provided by Advizr if the claim would not have arisen by the exclusive use of the Application\n    Services alone, (iii) the Customer Data or (iv) any financial plans, advice or other information provided by Customer to any Advisee (any of the foregoing\n    circumstances under clauses (i), (ii), (iii) or (iv) will be collectively referred to as a "Customer Indemnity Responsibility").\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    5.3 Customer Indemnity. Customer will indemnify, defend and hold harmless Advizr, its directors, officers, employees and representatives (each a "Advizr\n    Indemnified Party"), from and against any and all Losses arising out of any third party claim alleging a Customer breach of any Customer warranty or\n    arising out of any Customer Indemnity Responsibility.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    5.4 Indemnification Process. The foregoing indemnification obligations are conditioned on the indemnified party: (a) notifying the indemnifying party\n    promptly in writing of such action, (b) reasonably cooperating and assisting in such defense and (c) giving sole control of the defense and any related\n    settlement negotiations to the indemnifying party with the understanding that the indemnifying party may not settle any claim in a manner that admits guilt\n    or otherwise prejudices the indemnified party without consent.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    5.5 Infringement. If any Service is, or in Advizr\'s opinion, is likely to become the subject of any infringement-related claim, then Advizr will, at its\n    expense and in its discretion: (a) procure for Customer the right to continue using the Service; (b) replace or modify the infringing technology or\n    material so that the Service becomes non-infringing and remains materially functionally equivalent; or (c) terminate the Schedule(s) pursuant to which the\n    Service is provided and give Customer a refund for any pre-paid but unused fees.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    5.6 THE PROVISIONS OF THIS SECTION 5 STATE ADVIZR\'S ENTIRE LIABILITY AND CUSTOMER\'S EXCLUSIVE REMEDIES FOR ANY CLAIM THAT THE SERVICES, ANY DELIVERABLE, OR\n    THE TECHNOLOGY UNDERLYING ANY OF THE SERVICES, INFRINGE A THIRD PARTY\'S INTELLECTUAL PROPERTY RIGHT.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    6. CONFIDENTIAL INFORMATION.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    6.1 Confidentiality. Each party will maintain in confidence all Confidential Information disclosed by the other party hereto. As used herein "Confidential\n    Information" will mean all tangible information which is marked as "confidential" or "proprietary" and all information which is disclosed and should\n    reasonably be considered confidential. Notwithstanding the foregoing, (a) the Advizr Confidential Information will include the Application Services, and\n    the algorithms, know-how and technology underlying the Application Services and (b) Customer Confidential Information will include the Customer Data.\n    Advizr may disclose Customer Confidential Information to employees, contractors and trainees who have agreed in writing to hold such Customer Confidential\n    Information in confidence and not to use such information for any purposes other than those authorized by this Agreement. Customer may disclose Advizr\n    Confidential Information to employees and contractors who are not Advizr competitors who have agreed in writing to hold such Advizr Confidential\n    Information in confidence and not to use such information for any purpose other than those authorized by this Agreement. Each party will use at least the\n    same standard of care as it uses to protect its own most confidential information to ensure that such employees or contractors do not disclose or make any\n    unauthorized use of such Confidential Information.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    6.2 Exceptions. The obligations of confidentiality contained in Paragraph 6.1 ("Confidentiality") will not apply to the extent that it can be established\n    by the receiving party ("Recipient") by competent proof that such Confidential Information: (i) was already known to Recipient, other than under an\n    obligation of confidentiality, at the time of disclosure by the other party; (ii) was generally available to the public or otherwise part of the public\n    domain at the time of its disclosure; (iii) became generally available to the public or otherwise part of the public domain after its disclosure other than\n    through any act or omission of Recipient in breach of this Agreement; (iv) was disclosed to Recipient, other than under an obligation of confidentiality,\n    by a third party who had no obligation to the other party not to disclose such information to others; or (v) was independently developed by Recipient\n    without use of the disclosing party\'s Confidential Information.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    7. PAYMENT TERMS.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    7.1 Invoice for Professional Services. Fees for professional services will be due and payable in accordance with Section 7.2 ("Payment Terms") below.\n    Except as may otherwise be provided in an Order Form, fees for Professional Services will be provided on a time and materials basis; that is, Customer will\n    pay Advizr for the time spent performing such Professional Services, plus materials, taxes, and expenses. Any estimated price will be an estimate only for\n    Customer\'s budgeting and Advizr\'s resource scheduling purposes.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    7.2 Payment Terms. All fees will be invoiced upon execution of each Order Form by Customer. Payment will be due immediately upon invoice and each month\'s\n    service will be paid for at the beginning of the month. Overdue payments will accrue interest at the lesser of 1.5% per month or the maximum allowable\n    interest under applicable law, and Customer will pay Advizr\'s associated cost of collection including reasonable attorneys\' fees.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    7.3 Expenses. Customer will reimburse Advizr for all reasonable and customary expenses incurred by Advizr in providing Professional Services pursuant to\n    this Agreement and for all reasonable travel and lodging expenses incurred by Advizr.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    7.4 Taxes. Prices do not include taxes or duties. If Advizr is required to pay or collect any local, value added, goods and services taxes, or any other\n    similar taxes or duties arising out of or related to this Agreement (not including taxes based on Advizr\'s income), then such taxes and/or duties will be\n    billed to and paid by Customer.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8. MISCELLANEOUS\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.1 Reference. Customer hereby grants Advizr permission to identify Customer by name as a Customer of Advizr on the Advizr website and in any publicly\n    filed document, press release and/or any other marketing materials.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.2 Assignment. Neither party may assign or transfer its rights or obligations under this Agreement without the prior written consent of the other party,\n    and any assignment or transfer in derogation of the foregoing will be null and void; provided, however, that Advizr will have the right to assign its\n    rights to receivables hereunder to a bank or other financial institution and that either party will have the right to assign the Agreement, without the\n    prior written consent of the other party, to the successor entity in the event of merger, corporate reorganization or a sale of all or substantially all of\n    its assets. The terms of this Agreement will be binding upon such assignees.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.3 Force Majeure. Neither party will be liable to the other under this Agreement for any delay or lack of performance (other than nonpayment) resulting\n    from a Force Majeure event. "Force Majeure" event means any act of God, war, fire, typhoon, flood, earthquake, natural disasters, governmental action,\n    labor disruptions, materials shortages, or any other event beyond the reasonable control of the prevented party.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.4 Notices. All notices and other communications provided for hereunder will be in writing and will be required to be delivered by email (but solely to\n    the extent that an email address is provided in the Cover Page) and one of the following additional means: personal delivery, overnight courier, confirmed\n    facsimile, or certified or registered mail, return receipt requested. Notices will be sent to the parties using the notice information provided in the\n    Cover Page, or to such other address as that party may specify in writing pursuant to this section.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.5 Governing Law. All matters arising in connection with this Agreement or the enforcement or construction thereof will be governed by and resolved in\n    accordance with the laws of the State of New York without reference to its conflicts of laws principles or any other principles that would result in the\n    application of a different body of law. For any claim arising from or related to this Agreement, each party hereby expressly consents to exclusive\n    jurisdiction and venue of the state or federal courts located in the County of New York.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.6 Independent Contractors. The parties hereto are independent contractors and this Agreement will not be construed as creating any joint venture,\n    partnership or other like relationship.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.7 Waiver. No provision of this Agreement, unless such provision otherwise provides, will be waived by any act, omission or knowledge of a party or its\n    agents or employees except by an instrument in writing expressly waiving such provision and signed by a duly authorized officer of the waiving party.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.8 Severability. If any provision of this Agreement is unenforceable or illegal, such provision will be changed and interpreted to accomplish the\n    objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.9 Counterparts; Electronic Signatures. This Agreement may be executed in two or more counterparts, anyone of which need not contain the signatures of\n    more than one party, but all such counterparts taken together will constitute one and the same agreement. Delivery of an executed counterpart of a\n    signature page to this Agreement by electronic means (including by PDF or facsimile) will be effective as delivery of a mutually executed counterpart to\n    this Agreement.\n</div>\n<div>\n    <br/>\n</div>\n<div>\n    8.10 Entire Agreement. This Agreement, together with the exhibits attached hereto, constitute the entire agreement between the parties and supersede all\n    prior oral or written negotiations and agreements between the parties with respect to the subject matter hereof. In the event of any conflict between this\n    Agreement and any statement of work, the terms of this Agreement will control. No modification, variation or amendment of this Agreement will be effective\n    unless made in writing and signed by the parties. Purchase orders provided by Customer, including any terms and conditions contained therein, will be for\n    administrative purposes only and will have no force or effect.\n</div>\n',
  Checkout:
    '<div id="Checkout" data-tplid="{{tplid}}">\n    <section class="intro">\n        <div class="belt">\n            <h2>\n                {{^Expired}}{{#TrialPeriodDays}}Start your free trial of Advizr{{/TrialPeriodDays}}{{/Expired}}\n                {{^Expired}}{{^TrialPeriodDays}}Start your Advizr subscription{{/TrialPeriodDays}}{{/Expired}}\n                {{#Expired}}{{^TrialEnded}}Your subscription has expired{{/TrialEnded}}{{/Expired}}\n                {{#Expired}}{{#TrialEnded}}Start your Advizr membership today{{/TrialEnded}}{{/Expired}}\n            </h2>\n        </div>\n    </section>\n    <section class="form">\n        {{#TrialEnded}}\n        <section class="prompt">\n            Please enter your credit card information to continue with your subscription\n        </section>\n        {{/TrialEnded}}\n        <div id="Checkout_Form_Terms">\n            <div class="terms-container">\n                {{>AdviserTerms}}\n            </div>\n            <button class="primary agree">I Agree</button>\n        </div>\n        <div id="Checkout_Form_Payment">\n            <div class="description">\n                {{#Expired}}{{^TrialEnded}}{{>Checkout_Description_Expired}}{{/TrialEnded}}{{/Expired}}\n                {{#Expired}}{{#TrialEnded}}{{>Checkout_Description_Trial_Ended}}{{/TrialEnded}}{{/Expired}}\n                {{^Expired}}{{#TrialPeriodDays}}{{>Checkout_Description_New}}{{/TrialPeriodDays}}{{/Expired}}\n                {{^Expired}}{{^TrialPeriodDays}}{{>Checkout_Description_New_NoTrial}}{{/TrialPeriodDays}}{{/Expired}}\n            </div>\n            <div class="rhs">\n                <form class="adv-form">\n                    <div class="input ccn">\n                        <i class="fa fa-credit-card"></i>\n                        <input type="tel" placeholder="Card Number" data-stripe="number">\n                    </div>\n                    <div class="input exp">\n                        <i class="far fa-calendar-alt"></i>\n                        <input type="tel" placeholder="MM / YY" data-stripe="exp">\n                    </div>\n                    <div class="input cvc">\n                        <i class="fa fa-lock"></i>\n                        <input type="text" placeholder="CVC" data-stripe="cvc" autocomplete="off">\n                    </div>\n                    <input type="submit" value="Submit" class="hidden">\n                </form>\n                <button class="primary authorize">{{#Expired}}Authorize &amp; Pay{{/Expired}}{{^Expired}}Authorize{{/Expired}}</button>\n                <p class="legal">\n                    By entering your payment information, you authorize us to automatically charge your card every {{Interval}} for ${{Price}}.\n                </p>\n            </div>\n            <div id="seals">\n                <a target="_blank" href="https://www.mcafeesecure.com/verify?host=app.advizr.com"><img class="mfes-trustmark" border="0" src="//cdn.ywxi.net/meter/app.advizr.com/101.gif" width="125" height="55" title="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams" alt="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams" oncontextmenu="alert(\'Copying Prohibited by Law - McAfee Secure is a Trademark of McAfee, Inc.\'); return false;"></a>\n            </div>\n            <script type="text/javascript">\n                (function () {\n                    var sa = document.createElement(\'script\'); sa.type = \'text/javascript\'; sa.async = true;\n                    sa.src = (\'https:\' == document.location.protocol ? \'https://cdn\' : \'http://cdn\') + \'.ywxi.net/js/1.js\';\n                    var s = document.getElementsByTagName(\'script\')[0]; s.parentNode.insertBefore(sa, s);\n                })();\n            </script>\n        </div>\n    </section>\n</div>',
  CheckoutFrictionless:
    '<div id="CheckoutFrictionless" data-tplid="{{tplid}}">\n    <section class="intro">\n        <div class="belt">\n            <h2>\n                Continue your Advizr membership\n            </h2>\n        </div>\n    </section>\n    <section class="form">\n        <div id="Checkout_Form_Terms">\n            <div class="terms-container">\n                {{>AdviserTerms}}\n            </div>\n            <button class="primary agree">I Agree</button>\n        </div>\n        <div id="Checkout_Form_Payment">\n            <div class="jumbotron">\n                <div class="container frictionless" id="FrictionlessContainer">\n                    <section class="border-bottom">\n                        <h3><i class="fa fa-calculator"></i> Calculate Your Price</h3>\n                    </section>\n                    <form class="adv-form">\n                        <section class="border-bottom">\n                            <div class="description">\n                                <h4>Select your payment plan</h4>\n                            </div>\n                            <div class="rhs" id="FrictionlessSubscriptionPlans">\n                            </div>\n                        </section>\n                        <section>\n                            <div class="description">\n                                <h4 class="additional-discount">\n                                    Are you eligible for an additional discount?<br/>\n                                    These are our current partners:\n                                </h4>\n                            </div>\n                            <div class="rhs">\n                                <ul class="vertical-layout">\n                                    <li>\n                                        <select name="DiscountType" id="DiscountType" class="lg" data-value="{{DiscountType}}" placeholder="Select a discount type...">\n                                            <option value=" ">No Discount</option>\n                                            {{#Coupons}}\n                                            <option value="{{Id}}">{{Name}}</option>\n                                            {{/Coupons}}\n                                        </select>\n                                        <p class="legal">Is your custodian/BD/RIA not listed? Email us at hello@advizr.com</p>\n                                    </li>\n                                </ul>\n                            </div>\n                        </section>\n                    </form>\n                    <section class="custom-price">\n                        <h4>Your custom price:</h4>\n                        <div class="description">\n                            <div class="price-tag" id="FrictionlessPriceTag">\n                            </div>\n                        </div>\n                        <div class="rhs">\n                            <p class="legal volume-discounts">*If you are purchasing three or more licenses, please contact us for more information about volume discounts.</p>\n                        </div>\n                    </section>\n                </div>\n            </div>\n            <div class="container frictionless">\n                <section>\n                    <div class="description" id="FrictionlessTrialEndedDescription">\n                    </div>\n                    <div class="rhs">\n                        <form class="adv-form payment">\n                            <div class="input ccn">\n                                <i class="fa fa-credit-card"></i>\n                                <input type="tel" placeholder="Card Number" data-stripe="number">\n                            </div>\n                            <div class="input exp">\n                                <i class="far fa-calendar-alt"></i>\n                                <input type="tel" placeholder="MM / YY" data-stripe="exp">\n                            </div>\n                            <div class="input cvc">\n                                <i class="fa fa-lock"></i>\n                                <input type="text" placeholder="CVC" data-stripe="cvc" autocomplete="off">\n                            </div>\n                            <input type="submit" value="Submit" class="hidden">\n                        </form>\n                        <button class="primary authorize">{{#Expired}}Authorize &amp; Pay{{/Expired}}{{^Expired}}Authorize{{/Expired}}</button>\n                        <p class="legal" id="FrictionlessAuthorizationMessage">\n                        </p>\n                    </div>\n                </section>\n                <div id="seals">\n                    <a target="_blank" href="https://www.mcafeesecure.com/verify?host=app.advizr.com"><img class="mfes-trustmark" border="0" src="//cdn.ywxi.net/meter/app.advizr.com/101.gif" width="125" height="55" title="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams" alt="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams" oncontextmenu="alert(\'Copying Prohibited by Law - McAfee Secure is a Trademark of McAfee, Inc.\'); return false;"></a>\n                </div>\n            </div>\n        </div>\n    </section>\n</div>',
  Checkout_Description_Expired:
    "<p>Your Advizr subscription has expired.</p>\n<p>This could be due to an expired credit card, a card reported lost or stolen, or fraud prevention mechanisms. Please update your payment information to re-activate your account. Don't worry, everything is right where you left it.</p>",
  Checkout_Description_New:
    '<p>Your {{TrialPeriodDays}} day free trial will start today.</p>\n<p>Your credit card will not be charged until after your free trial ends. You can cancel anytime during your free trial.</p>\n<p>The Subscription price for Advizr is <strong>${{Price}}/{{Interval}}</strong>. Once your trial period ends, your card will be charged automatically each {{Interval}}.</p>',
  Checkout_Description_New_NoTrial:
    '<p>Start your Advizr subscription today.</p>\n<p>Your card will be charged automatically <strong>${{Price}}/{{Interval}}</strong> each month. You can cancel or change your payment information at any time.</p>',
  Checkout_Description_Trial_Ended:
    '<p>Your subscription will begin once you input your billing information and authorize payment</p>\n<p>The subscription price for Advizr is <strong>${{Price}}/{{Interval}}</strong> with an annual commitment, however you will have a 30-day grace\nperiod in which you can cancel if you wish. Your card will be charged automatically each {{Interval}}.</p>\n<p>By entering your payment information, you authorize us to automatically charge your card every {{Interval}} for ${{Price}} for the duration\nof your annual subscription.</p>',
  FrictionlessAuthorizationMessage:
    'By entering your payment information, you authorize us to automatically charge your card every {{Interval}} for ${{Price}}.',
  FrictionlessPriceTag: '<span>${{Price}}</span>/per {{Interval}}',
  FrictionlessSubscriptionPlans:
    '<ul class="checkboxes checkboxes-layout">\n   {{#SubscriptionPlans}}\n   <li>\n      <input name="SubscriptionPlan" type="radio" id="option-{{Id}}" value="{{Id}}" {{#IsChecked}}checked{{/IsChecked}}>\n      <label for="option-{{Id}}">\n      {{#IsMonthly}}\n      <i></i>Billed Monthly<br/>(annual commitment)\n      {{/IsMonthly}}\n      {{#IsYearly}}\n      <i></i>Billed Annually<br/>(Save 10%)\n      {{/IsYearly}}\n      </label>\n   </li>\n   {{/SubscriptionPlans}}\n</ul>',
  FrictionlessTrialEndedDescription:
    '<p>Your subscription will continue once you input your billing information and authorize payment</p>\n<p>The subscription price for Advizr is <strong>${{Price}}/{{Interval}}</strong> with an annual commitment, however you will have a 30-day grace\nperiod in which you can cancel if you wish. Your card will be charged automatically each {{Interval}}.</p>\n<p>By entering your payment information, you authorize us to automatically charge your card every {{Interval}} for ${{Price}} for the duration\nof your annual subscription.</p>',
  AddActionStep:
    '<li class="AddActionStep" data-tplid="{{tplid}}">\n    <form class="adv-form">\n        <div class="Icon">\n            <i class="icon" data-type="3"></i>\n            <i class="fa fa-caret-down"></i>\n            <input type="hidden" name="Icon" value="3">\n            <ul class="adv-dropdown">\n                <li><i class="icon" data-type="0"></i></li>\n                <li><i class="icon" data-type="1"></i></li>\n                <li><i class="icon" data-type="2"></i></li>\n                <li><i class="icon" data-type="3"></i></li>\n            </ul>\n        </div>\n        <input placeholder="Type action step here..." name="Text">\n        <button class="done">Done</button>\n        <button class="cancel outline secondary">Cancel</button>\n        <input type="submit" name="Submit" value="Submit" class="hidden">\n    </form>\n</li>',
  ConsumerOverview:
    '<div id="ConsumerOverview" data-tplid="{{tplid}}">\n    <div class="charts"></div>\n</div>',
  ConsumerOverview_AssetAllocationChart:
    '<div id="ConsumerOverview_AssetAllocationChart" data-tplid="{{tplid}}">\n    <h2 data-route="reports/assetallocation/{{clientId}}">Current Asset Allocation</h2>\n    <div class="chart_container"></div>\n    <div class="labels">\n        <ul>\n            {{#Labels}}\n                <li data-index={{index}}><i style="background:{{color}}"></i><span>{{#format_percentage}}{{value}}{{/format_percentage}}%</span>{{label}}</li>\n            {{/Labels}}\n        </ul>\n    </div>\n    <ul class="indicators">\n        {{#Indicators}}<li><label>{{Label}}</label><div>{{{Value}}}</div></li>{{/Indicators}}\n    </ul>\n</div>',
  ConsumerOverview_CashflowChart:
    '<div id="ConsumerOverview_CashflowChart" data-tplid="{{tplid}}">\n    <h2 data-route="projectedcashflowreport/{{clientId}}/0">Annual Cash Flow</h2>\n    <div class="chart_container"></div>\n</div>',
  ConsumerOverview_ExecutiveSummary:
    '<div id="ConsumerOverview_ExecutiveSummary" data-tplid="{{tplid}}">\n    <h2>Summary\n        {{^isPresentationMode}}{{#adviserArea}}\n            <a href="#" class="edit collapse"><i class="far fa-edit"></i> Edit</a>\n        {{/adviserArea}}{{/isPresentationMode}}\n    </h2>\n    {{#adviserArea}}\n        <textarea style="display: none" placeholder="Add a message for {{client.FirstName}} {{client.LastName}}"\n        >{{Summary}}</textarea>\n    {{/adviserArea}}\n    <p>{{Summary}}</p>\n    {{^isPresentationMode}}\n        <button class="btn-icon short blue save"><i class="fa fa-save"></i> Save Summary</button>\n        <span class="char-counter green"><span></span> characters remaining</span>\n    {{/isPresentationMode}}\n</div>',
  ConsumerOverview_GoalSummary:
    '<div id="ConsumerOverview_GoalSummary" data-tplid="{{tplid}}">\n    <h2>Goal Progress</h2>\n    {{#GoalProgress}}\n        <div class="goal" data-goalid="{{GoalId}}">\n            <header>\n                <a href="#" data-route="plan/{{clientId}}/{{GoalId}}">{{GoalName}}</a>\n                {{#adviser_area}}\n                    <button class="add outline"><i class="fa fa-plus"></i>New Action Step</button>\n                    <button class="reset" data-callout="Reset"><i class="fa fa-sync-alt"></i>Reset</button>\n                {{/adviser_area}}\n                <span class="track-indicator" {{^OnTrack}}style="display:none;"{{/OnTrack}}></span>\n            </header>\n            <ul class="action-steps">\n                {{#ActionSteps}}\n                    <li class="{{#IsComplete}}is-done{{/IsComplete}}" {{#IsHidden}}style="display:none;"{{/IsHidden}}>\n                        <i class="icon" data-type="{{Icon}}"></i>\n                        {{Text}}\n                        <div class="buttons">\n                            {{#IsComplete}}<i class="btn-not-done far fa-check-circle" data-callout="MarkAsNotDone"></i>{{/IsComplete}}\n                            {{^IsComplete}}<i class="btn-done far fa-circle" data-callout="MarkAsDone"></i>{{/IsComplete}}\n                            {{#adviser_area}}<i class="btn btn-remove far fa-trash-alt" data-callout="Remove"></i>{{/adviser_area}}\n                        </div>\n                    </li>\n                {{/ActionSteps}}\n                {{^ActionSteps}}<li class="empty">No action steps.</li>{{/ActionSteps}}\n            </ul>\n        </div>\n    {{/GoalProgress}}\n</div>',
  ConsumerOverview_NetWorthChart:
    '<div id="ConsumerOverview_NetWorthChart" data-tplid="{{tplid}}">\n    <h2 data-route="networth/{{clientId}}/0">Net Worth<span>${{TotalNetWorth}}</span></h2>\n    <div class="chart_container"></div>\n</div>',
  LinkAccount_Challenge:
    '<form class="adv-form">\n  {{#challenges}}\n    <ul class="challenges horizontal-layout">\n        <li data-type="answer" data-challenge="{{challenge}}" data-challengetype="{{challengeType}}" data-answertype="{{answerType}}">\n            <label>{{challenge}}</label>\n\n            {{#choices}}\n            <ul class="checkboxes checkboxes-layout">\n                <li>\n                    <input name="Value" type="radio" id="option-{{id}}" value="{{value}}">\n                    <label for="option-{{id}}"><i></i>{{text}}</label>\n                </li>\n            </ul>\n            {{/choices}}\n\n            {{^choices}}\n            <input type="text" maxlength="50"\n                   name="answer"\n                   value="{{answer}}" class="lg">\n            {{/choices}}\n        </li>\n    </ul>\n  {{/challenges}}\n</form>\n<div class="actions">\n    <button class="secondary" id="btn-cancel">Cancel</button>\n    <button class="green" id="btn-save-challenges">Save</button>\n</div>\n',
  LinkAccount_Form:
    '<div class="section">\n\t<form class="institution-form adv-form">\n\t\t        <ul class="horizontal-layout">\n\t\t            <li>\n\t                  <label>Financial Institution</label>\n\t                  <select type="text" maxlength="50" name="InstitutionId" placeholder="Start typing..."></select>\n\t                  <i class="fa fa-question-circle more-info" data-callout="FinancialInstitution"></i>\n\t\t            </li>\n\t\t       \t</ul>\n\t\t       \t<ul class="horizontal-layout">\n\t\t            <li>\n\t\t                <label>Username</label>\n\t\t                <input type="text" maxlength="50" name="username" value="{{username}}" class="md">\n\t\t            </li>\n\t\t        </ul>\n\t\t       \t<ul class="horizontal-layout">\n\t\t            <li class="YearOfBirth">\n\t\t                <label>Password</label>\n\t\t                <input type="password" name="password" value="{{password}}" class="md">\n\t\t            </li>\n\t\t        </ul>\n\t</form>\n\t<div class="actions">\n\t    <button class="secondary" id="btn-cancel">Cancel</button>\n\t    <button class="green" id="btn-link">Add Account</button>\n\t</div>\n</div>',
  LinkAccount_Polling:
    '<div class="status">\n\t<div class="spinner">\n\t\t<h3 class="legenda">Please wait while we update your accounts. This might take a few minutes.</h3>\n\t\t<div style="text-align:center;font-size: 30px;"><i class="fa fa-sync-alt fa-spin"></i></div>\n\t</div>\n</div>',
  ManagedAccounts: '<div id="ManagedAccounts" data-tplid="{{tplid}}">\n</div>',
  PortfolioWidget:
    '<div id="PortfolioWidget" class="popup PortfolioWidget{{#HypotheticalReturn}} has-hypothetical{{/HypotheticalReturn}}" data-tplid="{{tplid}}">\n    <h2>{{Title}}<i class="fa fa-times close"></i></h2>\n    {{#HypotheticalReturn}}\n    <ul class="vertical-layout" style="margin-top: 25px;">\n        <li>\n            <label for="hypothetical_return">Straight-line Hypothetical Return</label>\n            <span>{{HypotheticalReturn}}</span>\n        </li>\n    </ul>\n    {{/HypotheticalReturn}}\n    <h3>Monte Carlo Simulation Asset Allocation</h3>\n    <div class="chart"></div>\n\n    <div class="labels adv-scrollbars">\n        <ul>\n            {{#Labels}}\n                <li data-index={{index}} class="{{#inactive}}inactive{{/inactive}}"><i style="background:{{color}}"></i>{{label}}<span>{{#format_percentage}}{{value}}{{/format_percentage}}%</span></li>\n            {{/Labels}}\n        </ul>\n    </div>\n</div>',
  PortfolioWidget_Editable:
    '<div id="PortfolioWidget_Editable" \n     class="popup PortfolioWidget PortfolioWidget_Editable{{^ShowHypotheticalReturn}} collapsible{{/ShowHypotheticalReturn}}" \n     data-tplid="{{tplid}}">\n    <h2>{{Title}}<i class="fa fa-times close"></i></h2>\n    {{#ShowHypotheticalReturn}}\n        <form class="adv-form">\n            <ul class="vertical-layout">\n                <li>\n                    <label for="hypothetical_return">Straight-line Hypothetical Return</label>\n                    <div class="input">\n                        <input id="hypothetical_return" type="text" data-type="interest" value="{{HypotheticalReturn}}" /><i>%</i>\n                    </div>\n                </li>\n            </ul>\n        </form>\n    {{/ShowHypotheticalReturn}}\n    <h3>Monte Carlo Simulation Asset Allocation</h3>\n    <div class="chart" {{#ShowHypotheticalReturn}}style="top:245px; "{{/ShowHypotheticalReturn}}></div>\n\n    <div class="labels adv-scrollbars adv-form">\n        <ul class="small-fields">\n            {{#Labels}}\n                <li data-index={{index}} class="{{#inactive}}inactive{{/inactive}}"><i style="background:{{color}}"></i>{{label}}<div class="input"><input type="text" value="{{#format_percentage}}{{value}}{{/format_percentage}}" maxlength="3"><i>%</i></div></li>\n            {{/Labels}}\n        </ul>\n    </div>\n\n    <div class="information">\n        <div class="tip error"><i class="fa fa-exclamation-triangle"></i>\n            <ul>\n                <li class="hypothetical">Hypothetical return value must be 12.00% or less</li>\n                <li class="total">The total must add up to 100%</li>\n            </ul>\n        </div>\n        <div class="tip total">Total: 100%</div>\n    </div>\n\n    <div class="actions">\n        <button class="green save">Save Changes</button>\n        <button class="secondary dismiss">Cancel</button>\n    </div>\n</div>',
  Profile: '<div id="Profile" data-tplid="{{tplid}}"></div>',
  Profile_AdvancedSettings:
    '<div id="Profile_AdvancedSettings" class="Profile" data-tplid="{{tplid}}">\n\n    <header>\n        <h2>Advanced Settings</h2>\n    </header>\n\n    <form class="adv-form">\n        <ul class="vertical-layout">\n            <li class="lifeExpectancy">\n                <label>{{PrincipalName}}\'s Life Expectancy</label>\n                <select name="PrincipalLifeExpectancy" data-value="{{PrincipalLifeExpectancy}}" class="xsm">\n                    {{#principal_les}}\n                        <option>{{.}}</option>\n                    {{/principal_les}}\n                </select>\n            </li>\n\n            {{#SpouseName}}\n                <li>\n                    <label>{{SpouseName}}\'s Life Expectancy</label>\n                    <select name="SpouseLifeExpectancy" data-value="{{SpouseLifeExpectancy}}" class="xsm">\n                        {{#spouse_les}}\n                            <option>{{.}}</option>\n                        {{/spouse_les}}\n                    </select>\n                </li>\n            {{/SpouseName}}\n        </ul>\n    </form>\n\n</div>',
  Profile_RetirementGoalRelaxation:
    '<div id="Profile_RetirementGoalRelaxation" class="Profile" data-tplid="{{tplid}}">\n\n    <header>\n        <h2>{{InstructionsLine1}}</h2>\n        <h3>By retiring at {{RetirementAge}} and spending {{LivingExpenses}}, you will be only {{CurrentPot}}% on track for retirement. Choose one of the options below to get more on track.</h3>\n    </header>\n\n    <form class="adv-form">\n        <ul class="checkboxes checkboxes-layout">\n            <li>\n                <input name="Value" type="radio" id="option-RetireLater" value="0" {{#selected}}checked{{/selected}}>\n                <label for="option-RetireLater"><i></i>Retire Later (Age {{RetireLaterAge}}, {{RetireLaterPot}} on track)</label>\n            </li>\n            <li>\n                <input name="Value" type="radio" id="option-SpendLess" value="1" {{#selected}}checked{{/selected}}>\n                <label for="option-SpendLess"><i></i>Spend Less ({{SpendLessExpense}}, {{SpendLessPot}} on track)</label>\n            </li>\n            <li>\n                <input name="Value" type="radio" id="option-NoChange" value="2" {{#selected}}checked{{/selected}}>\n                <label for="option-NoChange"><i></i>I prefer not change my retirement goal</label>\n            </li>\n        </ul>\n    </form>\n\n</div>',
  SaveSuccess:
    '<div id="SaveSuccess" data-tplid="{{tplid}}">Saved <i class="fa fa-check"></i></div>',
  Workflow: '<div id="Workflow" data-tplid="{{tplid}}">\n    <div class="module"></div>\n</div>',
  Workflow_Header:
    '<div id="Workflow_Header" data-tplid="{{tplid}}">\n    <h2>{{title}}</h2>\n    <ul class="steps"></ul>\n</div>',
  Workflow_Header_Comprehensive:
    '<ul class="tabs2 no-border-top" id="Workflow_Header_Comprehensive" data-tplid="{{tplid}}">\n    <li data-tab="General"><span><i>1</i> General</span></li>\n    <li data-tab="Accounts"><span><i>2</i> Accounts</span></li>\n    <li data-tab="Income"><span><i>3</i> Income</span></li>\n    <li data-tab="Expenses"><span><i>4</i> Expenses</span></li>\n    <li data-tab="Advanced"><span><i>5</i> Advanced</span></li>\n    {{^is_adviser_area}}<li class="help"><i class="fa fa-question-circle"></i></li>{{/is_adviser_area}}\n</ul>',
  Workflow_footernav:
    '<div class="nav-actions">\n    {{^is_first_step}}{{#prev}}<button class="secondary prev">Previous</button>{{/prev}}{{/is_first_step}}\n    {{#reset}}<button class="secondary reset">Reset</button>{{/reset}}\n    {{#save_and_next}}<button class="green rhs save">Save &amp; Next</button>{{/save_and_next}}\n    {{#next}}<button class="green rhs save">Next</button>{{/next}}\n    {{#save}}<button class="green save">Save Changes</button>{{/save}}\n</div>',
  EditPortfolio_Labels:
    '<ul class="small-fields" data-tplid="{{tplid}}">\n    {{#Labels}}\n        <li><i class="indicator" style="background-color:{{color}};"></i>{{label}}<div class="input"><input class="js-allocation" data-name=\'{{label}}\' type="text" value="{{#format_percentage}}{{value}}{{/format_percentage}}"><i>%</i></div></li>\n    {{/Labels}}\n</ul>',
  ClientList:
    '<ul class="clientlist{{#hasWhiteLabel}} has-white-label{{/hasWhiteLabel}}" data-tplid="{{tplid}}">\n    {{#clients}}\n        <li data-id="{{Id}}">\n            <span class="name" title="{{FirstName}} {{LastName}}">{{FirstName}} {{LastName}}</span>\n            {{#Email}}<span class="email">{{Email}}</span>{{/Email}}\n        </li>\n    {{/clients}}\n    <li class="empty">There are no clients matching your query.</li>\n    <div class="grad-spacer"></div>\n</ul>',
  SidebarWidget:
    '<div id="SidebarWidget" data-tplid="{{tplid}}">\n    {{#hasWhiteLabel}}\n    <div class="powered-by">\n        <div class="text">Powered By:</div>\n        <div class="logo"></div>\n    </div>\n    {{/hasWhiteLabel}}\n    <div class="search"><i class="fa fa-search"></i><input type="text" class="search" placeholder="Search Clients"><i class="clear fa fa-times-circle"></i></div>\n</div>',
  client_details_actions:
    '<ul class="actions">\n    <li data-route="start/{{Id}}" class="item-start"><i class="fa fa-flag"></i>Overview</li>\n    <li class="has-dropdown"><i class="fa fa-user"></i>Profile\n        <ul>\n            <li data-route="profile/personalinfo/{{Id}}/0" class="item-personalinfo">Personal Info</li>\n            <li data-route="profile/goals/{{Id}}/0" class="item-goals">Goals</li>\n            <li data-route="profile/accounts/{{Id}}/0" class="item-accounts">Accounts</li>\n            <li data-route="profile/otherassets/{{Id}}/0" class="item-otherassets">Other Assets</li>\n            <li data-route="profile/stockoptions/{{Id}}/0" class="item-stockoptions">Equity Compensation</li>\n            <li data-route="profile/trusts/{{Id}}/0" class="item-trusts">Trusts</li>\n            <li data-route="profile/lifeinsurance/{{Id}}/0" class="item-insurance">Insurance</li>\n            <li data-route="profile/income/{{Id}}/0" class="item-income">Income</li>\n            <li data-route="profile/taxfiling/{{Id}}/0" class="item-taxfiling">Taxes</li>\n            <li data-route="profile/expenses/{{Id}}/0" class="item-expenses">Expenses</li>\n            <li data-route="profile/risktolerance/{{Id}}/0" class="item-risktolerance">Risk Tolerance</li>\n        </ul>\n    </li>\n    <li class="has-dropdown"><i class="far fa-chart-bar"></i>Current Finances\n        <ul>\n            <li data-route="networth/{{Id}}/0" class="item-networthcombinedreport">Net Worth</li>\n            <li data-route="personalfinancereport/{{Id}}/0" class="item-personalfinancereport">Transactions</li>\n        </ul>\n    </li>\n    <li class="has-dropdown"><i class="fa fa-location-arrow"></i>Financial Plan\n        <ul>\n            <li data-route="plan/{{Id}}/" class="item-plan">Recommendations</li>\n            <li data-route="projectedcashflowreport/{{Id}}/" class="item-projectedcashflowreport">Cash Flow</li>\n            <li data-route="balance_sheet/{{Id}}/0" class="item-projectedbalancesheet">Balance Sheet</li>\n            <li data-route="reports/{{Id}}/" class="item-reports">Reports</li>\n            <li data-route="reports/assetallocation/{{Id}}" class="item-assetallocationreport">Asset Allocation</li>\n            <li data-route="tasks/{{Id}}" class="item-tasks">Action Steps</li>\n        </ul>\n    </li>\n    <li data-route="document_vault/{{Id}}/" class="item-vault"><i class="fa fa-cube"></i>Document Vault</li>\n    {{#ShowManagedAccounts}}\n        <li data-route="managed_accounts/{{Id}}" class="item-managed-accounts"><i class="fa fa-university"></i>Managed accounts</li>\n    {{/ShowManagedAccounts}}\n</ul>',
  configure_client_access:
    '<div data-tplid="{{tplid}}" id="configure_client_access" class="popup fixed {{Count}}">\n    <h2>Configure Client Access<i class="fa fa-times close"></i></h2>\n    <h3>Configure what {{FirstName}} sees when they log in to Advizr.</h3>\n    <ul><li\n            class="{{#IsWizardMode}}selected{{/IsWizardMode}}" data-item="wizard">\n            <h2>Wizard Mode</h2>\n            <p>Client will have access to the wizard and be able to enter or update their profile information.</p>\n        </li><li class="{{#IsFinancialPlanMode}}selected{{/IsFinancialPlanMode}}" data-item="plan">\n            <h2>Financial Plan Mode</h2>\n            <p>Client will have view-only access to their Financial Plan.</p>\n        </li>{{#ShowManagedAccounts}}<li class="{{#IsManagedAccountsMode}}selected{{/IsManagedAccountsMode}}" data-item="managed-accounts">\n            <h2>Managed Accounts Mode</h2>\n            <p>Client will be able to see managed accounts.</p>\n        </li>{{/ShowManagedAccounts}}{{#ShowUniversalAccess}}<li class="{{#IsUniversalAccessMode}}selected{{/IsUniversalAccessMode}}" data-item="universal-access">\n            <h2>Full Access Mode</h2>\n            <p> Client will have access to update their Profile and Financial Plan after completing the wizard.</p>\n        </li>{{/ShowUniversalAccess}}</ul>\n</div>',
  Tasks: '<div id="Tasks" data-tplid="{{tplid}}"></div>',
  FinancialStatementReport:
    '<div class="FinancialStatementReport" data-tplid="{{tplid}}">\n  <div class="adviser"></div>\n  <h1>{{Title}} <span class="print-only">(Summary)</span></h1>\n  \n  <div class="chart">\n    <h2>{{GraphTitle}} <label class="{{#NetTotalInRed}}text-red{{/NetTotalInRed}}">${{#format_money}}{{fNetTotal}}{{/format_money}} {{#ShowNetTotalPerYear}}<span>/year</span>{{/ShowNetTotalPerYear}}</label> </h2>\n    <div id="financial-graph"></div>\n  </div>\n  <div class="details">\n\n    <h3>{{TitleA}}</h3>\n    <table>\n      <tbody>\n        {{#GroupA}}\n        <tr class="category">\n          <td class="title"><a href="#">{{CategoryName}}</a></td>\n          <td class="value">${{#format_money}}{{fTotal}}{{/format_money}}</td>\n        </tr>\n        {{#Subcategories}}\n          <tr class="sub-category fade out" data-subcategory="{{CategoryName}}">\n            <td class="title">{{Key}}</td>\n            <td class="value">{{#format_money}}{{fValue}}{{/format_money}}</td>\n          </tr>\n        {{/Subcategories}}\n        {{/GroupA}}\n        <tr class="totals">\n          <td class="title">Total {{TitleA}}</td>\n          <td class="value">${{#format_money}}{{fTotalA}}{{/format_money}}</td>\n        </tr>\n      </tbody>\n    </table>\n\n    <h3>{{TitleB}}</h3>\n    <table>\n      <tbody>\n        {{#GroupB}}\n        <tr class="category">\n          <td class="title"><a href="#">{{CategoryName}}</a></td>\n          <td class="value">${{#format_money}}{{fTotal}}{{/format_money}}</td>\n        </tr>\n        {{#Subcategories}}\n          <tr class="sub-category fade out">\n            <td class="title">{{Key}}</td>\n            <td class="value">{{#format_money}}{{fValue}}{{/format_money}}</td>\n          </tr>\n        {{/Subcategories}}\n        {{/GroupB}}\n        <tr class="totals">\n          <td class="title">Total {{TitleB}}</td>\n          <td class="value red">${{#format_money}}{{fTotalB}}{{/format_money}}</td>\n        </tr>\n      </tbody>\n    </table>\n\n  </div>\n</div>',
  FinancialStatementReport_rawData:
    '<div class="FinancialStatementReport FinancialStatementReport_rawData" data-tplid="{{tplid}}">\n  <div class="adviser"></div>\n  <h1>{{Title}} (Detailed)</h1>\n\n  <div class="details">\n\n    <h3>{{TitleA}}</h3>\n    <table>\n      <tbody>\n        {{#GroupA}}\n        <tr class="category">\n          <td class="title"><a href="#">{{CategoryName}}</a></td>\n          <td class="value">${{#format_money}}{{fTotal}}{{/format_money}}</td>\n        </tr>\n        {{#Subcategories}}\n          <tr class="sub-category fade out" data-subcategory="{{CategoryName}}">\n            <td class="title">{{Key}}</td>\n            <td class="value">{{#format_money}}{{fValue}}{{/format_money}}</td>\n          </tr>\n        {{/Subcategories}}\n        {{/GroupA}}\n        <tr class="totals">\n          <td class="title">Total {{TitleA}}</td>\n          <td class="value">${{#format_money}}{{fTotalA}}{{/format_money}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class="details">\n\n    <h3>{{TitleB}}</h3>\n    <table>\n      <tbody>\n        {{#GroupB}}\n        <tr class="category">\n          <td class="title"><a href="#">{{CategoryName}}</a></td>\n          <td class="value">${{#format_money}}{{fTotal}}{{/format_money}}</td>\n        </tr>\n        {{#Subcategories}}\n          <tr class="sub-category fade out">\n            <td class="title">{{Key}}</td>\n            <td class="value">{{#format_money}}{{fValue}}{{/format_money}}</td>\n          </tr>\n        {{/Subcategories}}\n        {{/GroupB}}\n        <tr class="totals">\n          <td class="title">Total {{TitleB}}</td>\n          <td class="value red">${{#format_money}}{{fTotalB}}{{/format_money}}</td>\n        </tr>\n      </tbody>\n    </table>\n\n  </div>\n</div>',
  GoalSummaryReport:
    '<div id="GoalSummaryReport" data-tplid="{{tplid}}">\n    {{#GoalProgress.length}}\n        <h1>Action Steps</h1>\n        <div class="goal_action_steps">\n    {{/GoalProgress.length}}\n    {{#GoalProgress}}\n        <div class="prevent-page-break-inside">\n            <h3>\n                <span class="track-indicator" {{^OnTrack}}style="display:none;"{{/OnTrack}}></span>\n                {{GoalName}}\n            </h3>\n            <ul class="action-steps">\n                {{#ActionSteps}}\n                    <li class="{{#IsComplete}}is-done{{/IsComplete}}"\n                        {{#IsHidden}}style="display: none;"{{/IsHidden}}\n                    >\n                        <i\n                            class="icon"\n                            data-type="{{Icon}}"\n                        />\n                            {{{Text}}}\n                        {{^isPrint}}\n                            <div class="buttons">\n                                {{#IsComplete}}\n                                <i class="btn-not-done fa fa-check-circle" data-callout="MarkAsNotDone" />\n                                {{/IsComplete}}\n                                {{^IsComplete}}\n                                    <i class="btn-done fa fa-circle" data-callout="MarkAsDone" />\n                                {{/IsComplete}}\n                                <i class="btn btn-remove far fa-trash-alt" data-callout="Remove" />\n                            </div>\n                        {{/isPrint}}\n                    </li>\n                {{/ActionSteps}}\n                {{^ActionSteps}}\n                    <li class="empty"><i></i>None</li>\n                {{/ActionSteps}}\n            </ul>\n        </div>\n    {{/GoalProgress}}\n    {{#GoalProgress.length}}\n        </div>\n    {{/GoalProgress.length}}\n</div>\n',
  Summary:
    '<div id="GoalSummaryReport" data-tplid="{{tplid}}">\n    {{#Summary}}\n        <div class="summary">\n            <h1>Executive Summary</h1>\n            <p>{{.}}</p>\n        </div>\n    {{/Summary}}\n</div>\n',
  AddClientAdmin:
    '<div id="AddClientAdmin" class="popup" data-tplid="{{tplid}}">\n    <h2 class="title">Add Client<i class="fa fa-times close"></i></h2>\n    \n    <form class="adv-form">\n        <ul class="horizontal-layout">\n            <li>\n                <p class="info">\n                    Paste the coded string and click save to add a new client manually.\n                </p>\n            </li>   \n            <li>\n                <label>Paste Data Here</label>\n                <textarea class="mono" name="JsonRawData"></textarea>\n            </li>\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green lhs" id="btn-save">Save</button>\n        <button class="secondary dismiss lhs" id="btn-cancel">Cancel</button>\n    </div>\n</div>',
  AddEditAdvisors:
    '<div id="AddEditAdvisors" class="popup" data-tplid="{{tplid}}">\n    <h2 class="title">Add / Edit Advisor<i class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <ul class="vertical-layout">\n            {{#Id}}\n            <li>\n                <label>Id</label>\n                <input id="id" name="Id" type="text" readonly value="{{Id}}" />\n            </li>\n            {{/Id}}\n            <li>\n                <label>Active</label>\n                <input type="text" readonly value="{{#IsActive}}Yes{{/IsActive}}{{^IsActive}}No{{/IsActive}}" />\n            </li>\n            <li>\n                <label>Blocked</label>\n                <input type="text" readonly value="{{#IsBlocked}}Yes{{/IsBlocked}}{{^IsBlocked}}No{{/IsBlocked}}" />\n            </li>\n            <li>\n                <label>Registered</label>\n                <input type="text" readonly value="{{#IsRegistered}}Yes{{/IsRegistered}}{{^IsRegistered}}No{{/IsRegistered}}" />\n            </li>\n            <li>\n                <label for="first">First</label>\n                <input id="first" name="FirstName" type="text" maxlength="50" placeholder="Advisor\'s First Name"\n                       value="{{FirstName}}">\n            </li>\n            <li>\n                <label for="last">Last</label>\n                <input id="last" name="LastName" type="text" maxlength="50" placeholder="Advisor\'s Last Name"\n                       value="{{LastName}}">\n            </li>\n            <li>\n                <label for="email">Email</label>\n                <input id="email" name="Email" type="text" maxlength="50" placeholder="Advisor\'s Email Address"\n                       value="{{Email}}">\n            </li>\n            <li>\n                <label for="username">Username</label>\n                <input id="username" name="Username" type="text" maxlength="50" placeholder="Advisor\'s Username" readonly value="{{Username}}">\n            </li>\n            <li>\n                <label for="organization">Organization</label>\n                {{#IsAdding}}\n                <select readonly="true" data-value="{{OrganizationId}}" name="OrganizationId" id="organization" class="md">\n                    {{#OrganizationOptions}}\n                    <option value="{{Id}}">{{Name}}</option>{{/OrganizationOptions}}\n                </select>\n                {{/IsAdding}}\n                {{^IsAdding}}\n                <input id="organization" name="OrganizationId" type="hidden" value="{{OrganizationId}}" />\n                <input type="text" readonly value="{{OrganizationName}}" />\n                {{/IsAdding}}\n            </li>\n            <li id="ftciTrustId">\n                <label for="ftciid">Fiduciary Trust ID</label>\n                <input id="ftciid" name="FtciUserId" type="text" maxlength="255" placeholder="Fiduciary Trust ID" value="{{FtciUserId}}">\n            </li>\n            {{^IsFtciUser}}\n\t\t\t    {{^user.IsFtci}}\n                    {{^user.HideBillingInfo}}\n                        {{#user.ShowSubscriptionPlan}}\n                            <li id="subscriptionPlan">\n                                <label for="subscription">Subscription Plan</label>\n                                <select data-value="{{SubscriptionPlanId}}" name="SubscriptionPlanId" id="subscription" class="md">\n                                    {{#SubscriptionPlanOptions}}\n                                    <option value="{{Id}}">{{Name}}</option>{{/SubscriptionPlanOptions}}\n                                </select>\n                            </li>\n                        {{/user.ShowSubscriptionPlan}}\n                    {{/user.HideBillingInfo}}\n\t\t\t    {{/user.IsFtci}}\n            {{/IsFtciUser}}\n            {{#hasOrgAutomatedAccounts}}\n                <li id="automatedAccounts">\n                    <label>Automated Accounts</label>\n                    <div>\n                        <input type="checkbox" id="automated_accounts" name="HasAutomatedAccounts" class="toggle"\n                            {{#HasAutomatedAccounts}}checked{{/HasAutomatedAccounts}}/>\n                        <label for="automated_accounts"></label>\n                    </div>\n                </li>\n            {{/hasOrgAutomatedAccounts}}\n            {{#hasOrgCampaignsAccess}}\n                <li id="campaignsAccess">\n                    <label>Campaigns Access</label>\n                    <div>\n                        <input type="checkbox" id="campaigns" name="AccessToCampaigns" class="toggle" {{#AccessToCampaigns}} checked{{/AccessToCampaigns}} />\n                        <label for="campaigns"></label>\n                    </div>\n                </li>\n            {{/hasOrgCampaignsAccess}}\n            <li id="financialPlanningAccess">\n                <label>Financial Planning</label>\n                <div>\n                    <input type="checkbox" id="financialPlanning" name="HasFinancialPlanning" class="toggle" {{#HasFinancialPlanning}} checked{{/HasFinancialPlanning}} />\n                    <label for="financialPlanning"></label>\n                </div>\n            </li>\n            <li>\n                <label>Firm Settings</label>\n                <div>\n                    <input type="checkbox" id="firmsettings" name="AccessToFirmSettings" class="toggle" {{#AccessToFirmSettings}} checked{{/AccessToFirmSettings}} />\n                    <label for="firmsettings"></label>\n                </div>\n            </li>\n            <li>\n                <label>Manager Access</label>\n                <div>\n                    <input type="checkbox" id="manageraccess" name="IsManager" class="toggle" {{#IsManager}} checked{{/IsManager}} />\n                    <label for="manageraccess"></label>\n                </div>\n            </li>\n            <li>\n                <label>Org Admin</label>\n                <div>\n                    <input type="checkbox" id="orgadmin" name="IsOrganizationAdmin" class="toggle" {{#IsOrganizationAdmin}} checked{{/IsOrganizationAdmin}} />\n                    <label for="orgadmin"></label>\n                </div>\n            </li>\n            {{^IsFtciUser}}\n\t\t\t    {{^user.IsFtci}}\n                    {{^user.HideBillingInfo}}\n                        <li id="promptForBilling">\n                            <label>Prompt for Billing</label>\n                            <div>\n                                <input type="checkbox" id="promptforbilling" name="PromptForBillingInfo" class="toggle" {{#PromptForBillingInfo}} checked{{/PromptForBillingInfo}} />\n                                <label for="promptforbilling"></label>\n                            </div>\n                        </li>\n                    {{/user.HideBillingInfo}}\n\t\t\t    {{/user.IsFtci}}\n            {{/IsFtciUser}}\n\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green lhs" id="btn-save">Save</button>\n        <button class="secondary dismiss lhs" id="btn-cancel">Cancel</button>\n    </div>\n</div>\n',
  Admin_Advisors:
    '<div id="Admin_Advisors" data-tplid="{{tplid}}">\n    <button id="AddAdvisor" class="btn-icon blue auto-width lg"><i class="fa fa-plus"></i> Add Advisor</button><!--\n    {{!No Spaces!}}\n    --><button id="Search" class="btn-icon blue auto-width lg search"><i class="fa fa-search"></i> Find Advisor(s)</button><!--\n    {{!No Spaces}}\n    --><button id="ClearSearch" class="btn-icon gray auto-width lg clear"><i class="fa fa-times"></i> Clear Search</button>\n    <div class="advisers_table">\n        <table id="advisers" class="table" cellspacing="0">\n            <thead>\n            <th>\n                ID\n            </th>\n            <th>\n                First\n            </th>\n            <th>\n                Last\n            </th>\n            <th>\n                Email\n            </th>\n            <th>\n                Username\n            </th>\n            <th>\n                Organization\n            </th>\n            <th></th>\n            </thead>\n            <tbody id="advisors_body">\n            {{#Advisors}}\n                {{>AdvisorsRow}}\n            {{/Advisors}}\n            </tbody>\n        </table>\n    </div>\n    <div id="pages_footer">\n    </div>\n</div>',
  AdvisorsRow:
    '<tr data-index="{{Index}}">\n    <td>\n        {{Id}}\n    </td>\n    <td title="{{FirstName}}">\n        {{FirstName}}\n    </td>\n    <td title="{{LastName}}">\n        {{LastName}}\n    </td>\n    <td class="truncate" title="{{Email}}">\n        {{Email}}\n    </td>\n    <td class="truncate" title="{{Username}}">\n        {{Username}}\n    </td>\n    <td title="{{OrganizationName}}">\n        {{OrganizationName}}\n    </td>\n    <td class="actions">\n        <div class="has-dropdown">Actions<i class="fa fa-caret-down"></i>\n                                         <ul class="adv-dropdown" data-adviserid="{{Id}}">\n                                             <li class="edit">\n                                                 <a><i class="far fa-edit"></i> Edit</a>\n                                             </li>\n                                             <li class="emails">\n                                                 <a><i class="fa fa-envelope"></i> Invite/Reset Password</a>\n                                             </li>\n                                             <li class="add-client">\n                                                 <a><i class="fa fa-plus"></i> Add Client</a>\n                                             </li>\n                                             <li class="view-clients">\n                                                 <a><i class="fa fa-users"></i> View Clients</a>\n                                             </li>\n                                             {{^IsBlocked}}\n                                             <li class="block">\n                                                 <a class="red"><i class="fa fa-ban"></i> Block Advisor</a>\n                                             </li>\n                                             {{/IsBlocked}}\n                                             {{#IsBlocked}}\n                                             <li class="unblock">\n                                                 <a><i class="fa fa-unlock"></i> Un-Block Advisor</a>\n                                             </li>\n                                             {{/IsBlocked}}\n                                             {{#CanBeDeleted}}\n                                             <li class="delete red">\n                                                 <a class="red"><i class="far fa-trash-alt"></i> Delete Advisor</a>\n                                             </li>\n                                             {{/CanBeDeleted}}\n                                         </ul>\n        </div>\n    </td>\n</tr>\n',
  SearchAdvisors:
    '<div id="SearchAdvisors" class="SearchAdvisors popup" data-tplid="{{tplid}}">\n    <h2 class="title">Search All Advisors<i class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <p class="info">\n            Search for advisors by one or more of the below fields.\n        </p>\n        <ul class="vertical-layout">\n            <li>\n                <label for="AdviserId">Advisor ID</label>\n                <input id="AdviserId" name="AdviserId" type="text" maxlength="50" placeholder="ex. 123">\n            </li>\n            <li>\n                <label for="Name">Advisor Name</label>\n                <input id="Name" name="Name" type="text" maxlength="150">\n            </li>\n            <li>\n                <label for="Email">Advisor Email</label>\n                <input id="Email" name="Email" type="text" maxlength="150" placeholder="ex. user@example.com">\n            </li>\n            <li>\n                <label for="OrganizationId">Organization ID</label>\n                <input id="OrganizationId" name="OrganizationId" type="text" maxlength="150" placeholder="ex. 123">\n            </li>\n            <li>\n                <label for="OrganizationName">Organization Name</label>\n                <input id="OrganizationName" name="OrganizationName" type="text" maxlength="50">\n            </li>\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green lhs" id="btn-search">Search</button>\n        <button class="secondary dismiss lhs" id="btn-cancel">Cancel</button>\n    </div>\n</div>',
  Admin_Consumers:
    '<div id="Admin_Consumers" data-tplid="{{tplid}}">\n    <button id="Search" class="btn-icon blue auto-width lg search"><i class="fa fa-search"></i> Find Consumer</button>\n    <div class="consumers_table">\n        <table id="consumers" class="table" cellspacing="0">\n            <thead>\n            <th>\n                ID\n            </th>\n            <th>\n                Client Name\n            </th>\n            <th>\n                Username\n            </th>\n            <th>\n                Registered\n            </th>\n            <th>\n                Advisor ID\n            </th>\n            <th></th>\n            </thead>\n            <tbody id="consumer_body">\n            {{#Clients}}\n                {{>ClientsRow}}\n            {{/Clients}}\n            {{^Clients}}\n                {{>EmptyClientsRow}}\n            {{/Clients}}\n            </tbody>\n        </table>\n    </div>\n    <div id="pages_footer">\n    </div>\n</div>',
  ClientsRow:
    '<tr data-index="{{Index}}">\n    <td>\n        {{Id}}\n    </td>\n    <td title="{{FirstName}} {{LastName}}">\n        {{FirstName}} {{LastName}}\n    </td>\n    <td title="{{Username}}">\n        {{Username}}\n    </td>\n    <td>\n        {{#IsRegistered}}Yes{{/IsRegistered}}{{^IsRegistered}}No{{/IsRegistered}}\n    </td>\n    <td>\n        {{AdviserId}}\n    </td>\n    <td class="actions" data-id="{{Id}}" data-advisor-id="{{AdviserId}}">\n        <div class="has-dropdown">Actions<i class="fa fa-caret-down"></i>\n            <ul class="adv-dropdown" data-adviserid="{{Id}}">\n                {{^HideExportClient}}\n                <li class="export">\n                    <a target="_blank" href="Consumer/ExportClient?consumerId={{Id}}"><i class="fa fa-upload"></i> Export Client</a>\n                </li>\n                {{/HideExportClient}}\n                <li class="deactivate"{{^IsActive}} style="display:none"{{/IsActive}}>\n                    <a><i class="fa fa-ban"></i> Deactivate Client</a>\n                </li>\n                <li class="view_advisor">\n                    <a><i class="fa fa-user"></i> View Advisor</a>\n                </li>\n            </ul>\n        </div>\n    </td>\n</tr>',
  EmptyClientsRow:
    '<tr data-tplid="{{tplid}}">\n    <td colspan="5" class="no-padding">\n        <div class="empty">\n            <i class="fa fa-search"></i>\n            <p>\n                Please choose an Advisor ID, Consumer ID or Username and press "Find Clients" to display matching records.\n            </p>\n        </div>\n    </td>\n</tr>',
  SearchConsumers:
    '<div class="popup" id="SearchConsumers" data-tplid="{{tplid}}">\n    <h2 class="title">Search All Consumers<i class="fa fa-times close"></i></h2>\n    <form class="adv-form">\n        <ul class="vertical-layout">\n            <li>\n                <label for="AdviserId">Advisor ID</label>\n                <input type="text" id="AdviserId" name="AdviserId" value="{{AdviserId}}"/>\n            </li>\n            <li>\n                <label for="ConsumerId">Consumer ID</label>\n                <input type="text" id="ConsumerId" name="ConsumerId" value="{{ConsumerId}}"/>\n            </li>\n            <li>\n                <label for="Username">Username</label>\n                <input type="text" id="Username" name="Username" value="{{Username}}"/>\n            </li>\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green lhs" id="btn-search">Search</button>\n        <button class="secondary dismiss lhs" id="btn-cancel">Cancel</button>\n    </div>\n</div>',
  AddEditOrganizations:
    '<div id="AddEditOrganizations" class="popup" data-tplid="{{tplid}}">\n    <h2 class="title">Add / Edit Organization<i class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <input type="hidden" name="Id" value="{{Id}}"/>\n        <ul class="vertical-layout">\n            <li>\n                <label for="affiliation">Affiliation</label>\n                <select data-value="{{Affiliation}}" name="Affiliation" id="affiliation" class="md">\n                    <option></option>\n                    {{#Affiliations}}<option value="{{.}}">{{.}}</option>{{/Affiliations}}\n                </select>\n            </li>\n            <li>\n                <label for="name">Name</label>\n                <input id="name" name="Name" type="text" maxlength="50" placeholder="Organization Name" value="{{Name}}">\n            </li>\n            <li>\n                <label>Subdomain</label>\n                <input id="subdomain" name="SubDomain" type="text" maxlength="50" placeholder="Subdomain" value="{{SubDomain}}">\n            </li>\n            <li>\n                <label>Automated Accounts</label>\n                <div>\n                    <input type="checkbox" id="automated_accounts" name="HasAutomatedAccounts" class="toggle"\n                        {{#HasAutomatedAccounts}}checked{{/HasAutomatedAccounts}}/>\n                    <label for="automated_accounts"></label>\n                </div>\n            </li>\n            <li>\n                <label for="data_aggregation">Data Aggregation</label>\n                <div>\n                    <input type="checkbox" id="data_aggregation" name="HasDataAggregation" class="toggle"\n                        {{#HasDataAggregation}}checked{{/HasDataAggregation}}/>\n                    <label for="data_aggregation"></label>\n                </div>\n            </li>\n            <li>\n                <label for="data_reconciliation">Data Reconciliation</label>\n                <div>\n                    <input type="checkbox" id="data_reconciliation" name="HasDataReconciliation" class="toggle"\n                        {{#HasDataReconciliation}}checked{{/HasDataReconciliation}}/>\n                    <label for="data_reconciliation"></label>\n                </div>\n            </li>\n            <li>\n                <label>Default Firm Settings</label>\n                <div>\n                    <input type="checkbox" id="DefaultAdviserAccessToFirmSettings" name="DefaultAdviserAccessToFirmSettings" class="toggle" {{#DefaultAdviserAccessToFirmSettings}} checked{{/DefaultAdviserAccessToFirmSettings}} />\n                    <label for="DefaultAdviserAccessToFirmSettings"></label>\n                </div>\n            </li>\n            <li>\n                <label>Disable Glia</label>\n                <div>\n                    <input type="checkbox" id="DisableGlia" name="DisableGlia" class="toggle" {{#DisableGlia}} checked{{/DisableGlia}} />\n                    <label for="DisableGlia"></label>\n                </div>\n            </li>\n\t\t\t<li>\n                <label for="data_fidelityaccess">Fidelity Access</label>\n                <div>\n                    <input type="checkbox" id="data_fidelityaccess" name="HasFidelityAccess" class="toggle"\n                        {{#HasFidelityAccess}}checked{{/HasFidelityAccess}}/>\n                    <label for="data_fidelityaccess"></label>\n                </div>\n            </li>\n            <li>\n                <label for="data_financialplanning">Financial Planning</label>\n                <div>\n                    <input type="checkbox" id="data_financialplanning" name="HasFinancialPlanning" class="toggle"\n                        {{#HasFinancialPlanning}}checked{{/HasFinancialPlanning}}/>\n                    <label for="data_financialplanning"></label>\n                </div>\n            </li>\n            <li>\n                <label for="show_campaigns">Show Campaigns</label>\n                <div>\n                    <input type="checkbox" id="show_campaigns" name="ShowCampaigns" class="toggle"\n                        {{#ShowCampaigns}}checked{{/ShowCampaigns}}/>\n                    <label for="show_campaigns"></label>\n                </div>\n            </li>\n            <li>\n                <label for="show_employers_and_self_registration">Show Employers And Self Registration</label>\n                <div>\n                    <input type="checkbox" id="show_employers_and_self_registration" name="ShowEmployersAndSelfRegistration" class="toggle"\n                        {{#ShowEmployersAndSelfRegistration}}checked{{/ShowEmployersAndSelfRegistration}}/>\n                    <label for="show_employers_and_self_registration"></label>\n                </div>\n            </li>\n            <li>\n                <label for="show_leads">Show Leads</label>\n                <div>\n                    <input type="checkbox" id="show_leads" name="ShowLeads" class="toggle"\n                        {{#ShowLeads}}checked{{/ShowLeads}}/>\n                    <label for="show_leads"></label>\n                </div>\n            </li>\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green lhs" id="btn-save">Save</button>\n        <button class="secondary dismiss lhs" id="btn-cancel">Cancel</button>\n    </div>\n</div>',
  Admin_Organizations:
    '<div id="Admin_Organizations" data-tplid="{{tplid}}">\n    <button id="AddOrganization" class="btn-icon blue auto-width lg"><i class="fa fa-plus"></i> Add Organization</button><!--\n    {{!No Spaces!}}\n    --><button id="Search" class="btn-icon blue auto-width lg search"><i class="fa fa-search"></i> Find Organization(s)</button><!--\n    {{!No Spaces}}\n    --><button id="ClearSearch" class="btn-icon gray auto-width lg clear"><i class="fa fa-times"></i> Clear Search</button>\n    <div class="organization_table">\n        <table id="organizations" class="table" cellspacing="0">\n            <thead>\n            <th>\n                ID\n            </th>\n            <th>\n                Name\n            </th>\n            <th>\n                Data Aggregation\n            </th>\n            <th>\n                Employers And Self Registration\n            </th>\n            <th>\n                Leads\n            </th>\n            <th>\n                Campaigns\n            </th>\n            <th>\n                Active\n            </th>\n            <th></th>\n            </thead>\n            <tbody id="organizations_body">\n            {{#Organizations}}\n                {{>OrganizationsRow}}\n            {{/Organizations}}\n            </tbody>\n        </table>\n    </div>\n    <div id="pages_footer">\n    </div>\n</div>',
  OrganizationsRow:
    '<tr data-index="{{Index}}">\n    <td>\n        {{Id}}\n    </td>\n    <td title="{{Name}}">\n        {{Name}}\n    </td>\n    <td>\n        {{#HasDataAggregation}}\n            Yes\n        {{/HasDataAggregation}}\n        {{^HasDataAggregation}}\n            No\n        {{/HasDataAggregation}}\n    </td>\n    <td>\n        {{#ShowEmployersAndSelfRegistration}}\n            Yes\n        {{/ShowEmployersAndSelfRegistration}}\n        {{^ShowEmployersAndSelfRegistration}}\n            No\n        {{/ShowEmployersAndSelfRegistration}}\n    </td>\n    <td>\n        {{#ShowLeads}}\n            Yes\n        {{/ShowLeads}}\n        {{^ShowLeads}}\n            No\n        {{/ShowLeads}}\n    </td>\n    <td>\n        {{#ShowCampaigns}}\n            Yes\n        {{/ShowCampaigns}}\n        {{^ShowCampaigns}}\n            No\n        {{/ShowCampaigns}}\n    </td>\n    <td>\n        {{#IsActive}}\n            Yes\n        {{/IsActive}}\n        {{^IsActive}}\n            No\n        {{/IsActive}}\n    </td>\n    <td class="actions">\n        <div class="has-dropdown">Actions<i class="fa fa-caret-down"></i>\n            <ul class="adv-dropdown" data-organizationid="{{Id}}">\n                <li class="edit">\n                    <a><i class="far fa-edit"></i> Edit</a>\n                </li>\n                <li class="deactivate">\n                    <a><i class="fa fa-times"></i> Deactivate</a>\n                </li>\n                {{^IsBlocked}}\n                <li class="block">\n                    <a><i class="fa fa-ban"></i> Block</a>\n                </li>\n                {{/IsBlocked}}\n                {{#IsBlocked}}\n                <li class="unblock">\n                    <a><i class="fa fa-unlock"></i> Un-Block</a>\n                </li>\n                {{/IsBlocked}}\n                <li class="advisors">\n                    <a><i class="fa fa-users"></i> View Advisors</a>\n                </li>\n            </ul>\n        </div>\n    </td>\n</tr>',
  SearchOrganizations:
    '<div id="SearchOrganizations" class="SearchOrganizations popup" data-tplid="{{tplid}}">\n    <h2 class="title">Search All Advisors<i class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <p class="info">\n            Search for organizations by one or more of the below fields.\n        </p>\n        <ul class="vertical-layout">\n            <li>\n                <label for="OrganizationId">Organization ID</label>\n                <input id="OrganizationId" name="OrganizationId" type="text" maxlength="50" placeholder="ex. 123">\n            </li>\n            <li>\n                <label for="OrganizationName">Organization Name</label>\n                <input id="OrganizationName" name="OrganizationName" type="text" maxlength="150">\n            </li>\n\t\t\t<li>\n                <label for="AffiliationName">Affiliation Name</label>\n                <input id="AffiliationName" name="AffiliationName" type="text" maxlength="150">\n            </li>\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green lhs" id="btn-search">Search</button>\n        <button class="secondary dismiss lhs" id="btn-cancel">Cancel</button>\n    </div>\n</div>',
  Admin_Reports:
    '<div id="Admin_Reports" data-tplid="{{tplid}}">\n    <h3 class="has-dropdown dropdown select-report">\n        <span class="placeholder">Select a report</span>\n        <i class="fa fa-caret-down"></i>\n        <ul class="adv-dropdown adv-scrollbars report-list"></ul>\n    </h3>\n    <div class="actions float-right">\n        <button style="display:none" id="export_csv" class="btn-icon auto-width outline"><i class="fa fa-download"></i>Export to CSV</button>\n    </div>\n    <div class="reports_table">\n        {{>Admin_Reports_Table}}\n    </div>\n    <div id="pages_footer">\n    </div>\n</div>',
  Admin_Reports_Subnav:
    '{{#.}}\n    <li data-value="{{value}}" data-tplid="{{tplid}}">\n        <a>{{name}}</a>\n    </li>\n{{/.}}',
  Admin_Reports_Table:
    '<table id="advisers" data-tplid="{{tplid}}" class="table" cellspacing="0">\n    {{#SelectedReportDetails}}\n        <thead>\n        <tr>\n            {{#ReportRecords.Header}}\n                <th>{{.}}</th>\n            {{/ReportRecords.Header}}\n        </tr>\n        </thead>\n        <tbody id="advisors_body">\n        {{#ReportRecords.Rows}}\n            <tr>\n                {{#.}} {{!iterate over the array}}\n                    <td>\n                        {{.}}  {{!display the array value}}\n                    </td>\n                {{/.}}\n            </tr>\n        {{/ReportRecords.Rows}}\n        {{^ReportRecords.Rows}}\n            <tr>\n                <td colspan="5">\n                    <div class="empty">\n                        <i class="fa fa-filter"></i>\n                        <p>\n                            Select a report in the dropdown above.\n                        </p>\n                    </div>\n                </td>\n            </tr>\n        {{/ReportRecords.Rows}}\n        </tbody>\n    {{/SelectedReportDetails}}\n</table>',
  DataCollection_accounts:
    '<div id="DataCollection_accounts" data-tplid="{{tplid}}">\n    <h3>Life Insurance Policies</h3>\n    <table class="col-6">\n        {{#Items.Life.length}}\n        <tr class="labels">\n            {{#colsLife}}<td>{{{.}}}</td>{{/colsLife}}\n            <td class="spacer-rhs"></td>\n        </tr>\n        {{/Items.Life.length}}\n        {{#Items.Life}}\n        <tr data-accountid="{{AccountId}}" data-type="Life">\n            <td>{{Description}}</td>\n            <td>${{LifeInsurancePolicyAmountDisplay}}</td>\n            <td>{{LifeInsurancePolicyTerm}}</td>\n            <td>{{LifeInsurancePolicyStartYear}}</td>\n            <td>${{CashBalanceDisplay}}</td>\n            <td class="spacer-rhs">{{^IsLinked}}<i class="far fa-trash-alt del"></i>{{/IsLinked}}<i class="far fa-edit"></i>{{#LifeInsurancePolicyType}}<i class="fa fa-chart-pie portfolio-widget"></i>{{/LifeInsurancePolicyType}}</td>\n        </tr>\n        {{/Items.Life}}\n        {{^Items.Life}}\n        <tr class="empty"><td>You have not added any Life Insurance policies.</td></tr>\n        {{/Items.Life}}\n    </table>\n    <h3>Disability Insurance Policies</h3>\n    <table class="col-6">\n        {{#Items.Disability.length}}\n            <tr class="labels">\n                {{#colsDisability}}<td>{{{.}}}</td>{{/colsDisability}}\n                <td class="spacer-rhs"></td>\n            </tr>\n        {{/Items.Disability.length}}\n        {{#Items.Disability}}\n            <tr data-accountid="{{AccountId}}" data-type="Disability">\n                <td>{{Description}}</td>\n                <td>${{DisabilityMonthlyBenefitAmountDisplay}}</td>\n                <td>{{DisabilityCoveragePeriod.Value}} {{DisabilityCoveragePeriod.Label}}</td>\n                <td>{{DisabilityEliminationPeriod.DisplayString}}</td>\n                <td class="spacer-rhs">{{^IsLinked}}<i class="far fa-trash-alt del"></i>{{/IsLinked}}<i class="far fa-edit"></i></td>\n            </tr>\n        {{/Items.Disability}}\n        {{^Items.Disability}}\n            <tr class="empty"><td>You have not added any Disability Insurance policies.</td></tr>\n        {{/Items.Disability}}\n    </table>\n    <h3>Long Term Care Insurance Policies</h3>\n    <table class="col-6">\n        {{#Items.LongTermCare.length}}\n            <tr class="labels">\n                {{#colsLTC}}<td>{{{.}}}</td>{{/colsLTC}}\n                <td class="spacer-rhs"></td>\n            </tr>\n        {{/Items.LongTermCare.length}}\n        {{#Items.LongTermCare}}\n            <tr data-accountid="{{AccountId}}" data-type="LongTermCare">\n                <td>{{Description}}</td>\n                <td>${{LongTermCareDailyBenefitAmountDisplay}}</td>\n                <td>{{LongTermCareCoveragePeriod.DisplayString}}</td>\n                <td>{{LongTermCareHomeCareCoveragePercentage}}%</td>\n                <td>{{LongTermCareNursingCareCoveragePercentage}}%</td>\n                <td class="spacer-rhs">{{^IsLinked}}<i class="far fa-trash-alt del"></i>{{/IsLinked}}<i class="far fa-edit"></i></td>\n            </tr>\n        {{/Items.LongTermCare}}\n        {{^Items.LongTermCare}}\n            <tr class="empty"><td>You have not added any Long Term Care Insurance policies.</td></tr>\n        {{/Items.LongTermCare}}\n    </table>\n    <h3>Health Insurance Policies</h3>\n    <table class="col-6">\n        {{#Items.HealthInsurance.length}}\n            <tr class="labels">\n                {{#colsHealth}}<td>{{{.}}}</td>{{/colsHealth}}\n                <td class="spacer-rhs"></td>\n            </tr>\n        {{/Items.HealthInsurance.length}}\n        {{#Items.HealthInsurance}}\n            <tr data-accountid="{{AccountId}}" data-type="Health">\n                <td>{{Description}}</td>\n                <td>{{TableHealthPlanType}}</td>\n                <td>{{TableHealthInsuredMembers}}</td>\n                <td class="spacer-rhs">{{^IsLinked}}<i class="far fa-trash-alt del"></i>{{/IsLinked}}<i class="far fa-edit"></i></td>\n            </tr>\n        {{/Items.HealthInsurance}}\n        {{^Items.HealthInsurance}}\n            <tr class="empty"><td>You have not added any Health Insurance policies.</td></tr>\n        {{/Items.HealthInsurance}}\n    </table>\n</div>',
  EditAccount_LifeInsurance:
    '<div id="EditAccount_LifeInsurance" class="EditAccountWidget popup" data-tplid="{{tplid}}">\n    <h2 class="title">{{#Id}}Edit Insurance{{/Id}}{{^Id}}Edit Insurance{{/Id}}<i class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <input type="hidden" name="Id" value="{{Id}}">\n        <ul class="vertical-layout narrow-labels">\n            <li>\n                <label>Insured</label>\n                <select data-value="{{InsuranceHolder}}" name="InsuranceHolder" id="field-InsuranceHolder" class="md">\n                    {{#insuranceHolderOptions}}<option>{{.}}</option>{{/insuranceHolderOptions}}\n                </select>\n            </li>\n            <li>\n                <label>Type</label>\n                <select data-value="{{LifeInsurancePolicyType}}" name="LifeInsurancePolicyType" id="field-LifeInsurancePolicyType" class="md" placeholder="Select a type">\n                    <option></option>\n                    {{#LifeInsurancePolicyTypeOptions}}<option value="{{value}}">{{label}}</option>{{/LifeInsurancePolicyTypeOptions}}\n                </select>\n            </li>\n            <li class="Term">\n                <label>Term</label>\n                <select data-value="{{Term}}" name="Term" id="field-Term" class="md" placeholder="Select a term">\n                    <option></option>\n                    {{#termOptions}}<option>{{.}}</option>{{/termOptions}}\n                </select>\n            </li>\n            <li class="Year">\n                <label>Purchase Year</label>\n                <select data-value="{{Year}}" name="Year" id="field-Year" class="md dropdown-direction-up">\n                    {{#purchaseYearOptions}}<option>{{.}}</option>{{/purchaseYearOptions}}\n                </select>\n            </li>\n            <li>\n                <label>Policy Name</label>\n                <input type="text" maxlength="50" name="Name" value="{{Name}}" maxlength="32">\n            </li>\n            <li>\n                <label>Amount</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="Amount" value="{{Amount}}" id="field-Amount" class="sm">\n                </div>\n            </li>\n            <li class="CashValue">\n                <label>Cash Value</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="CashValue" value="{{CashValue}}" id="field-CashValue" class="sm">\n                </div>\n            </li>\n        </ul>\n    </form>\n\n    <div class="actions">\n        <button class="green" id="btn-save">{{#Id}}Save Changes{{/Id}}{{^Id}}Add Policy{{/Id}}</button>\n        <button class="secondary dismiss" id="btn-cancel">Cancel</button>\n        {{#Id}}<button class="red rhs" id="btn-remove" data-id="{{Id}}"><i class="far fa-trash-alt"></i>Delete{{/Id}}\n    </div>\n</div>',
  Profile_DataCollection:
    '<div id="Profile_DataCollection" class="Profile" data-tplid="{{tplid}}">\n\n    <header>\n        <h2>{{InstructionsLine1}}</h2>\n        <h3>{{InstructionsLine2}}</h3>\n    </header>\n\n    <button class="add" disabled><i class="fa fa-plus"></i>Add {{type}}</button>\n\n    <div class="CRUDTable accounts">\n        {{>DataCollection_accounts}}\n    </div>\n</div>',
  Expense_Recurrence:
    '<div class="recurrence no-float muted">\n    Starting\n    <select class="fancy no-float" name="Year">\n        <option>Start Today</option>\n\n        {{#YearsOptions}}\n            <option value="{{year}}" {{selected}}>{{year}}</option>\n        {{/YearsOptions}}\n    </select>\n    <span class="frequency">\n        Every <input type="text" data-type="integer" class="underline single" maxlength="2" name="RepeatEveryNYears"\n                     id="year_freq_{{Name}}" value="{{RepeatEveryNYears}}"/>\n        year(s) for <input type="number" data-type="integer" class="underline single" maxlength="2"\n                           name="RepeatForNYears" id="year_duration_{{Category}}"\n                           value="{{RepeatForNYears}}"/>\n        year(s)\n    </span>\n</div>',
  ExpensesStep_Form_Item:
    '<ul id="detailed_expenses" class="table" cellspacing="0">\n    <li class="thead">\n        <ul>\n            <li class="input-length">\n                Type\n            </li>\n            <li>\n                Cost\n            </li>\n            <li class="offset_control_edge">\n                Mo/Yr\n            </li>\n            <li class="actions"></li>\n        </ul>\n    </li>\n    <li class="tbody" id="items">\n        {{#MortgageMonthlyTotal}}\n            <ul class="non-editable">\n                <li><span class="title">Mortgage(s)</span></li>\n                <li>\n                    <div>\n                        <div class="input readonly"><i>$</i>\n                            <input type="text" readonly\n                                   value="{{MortgageMonthlyTotal}}"/></div>\n                    </div>\n                </li>\n                <li><select disabled class="sm no-float">\n                    <option>/MO</option>\n                </select></li>\n                <li class="actions"></li>\n            </ul>\n        {{/MortgageMonthlyTotal}}\n        {{#LoanMonthlyTotal}}\n            <ul class="non-editable">\n                <li><span class="title">Loan(s)</span></li>\n                <li>\n                    <div>\n                        <div class="input readonly"><i>$</i>\n                            <input type="text" readonly value="{{LoanMonthlyTotal}}"/>\n                        </div>\n                    </div>\n                </li>\n                <li><select disabled class="sm no-float">\n                    <option>/MO</option>\n                </select></li>\n                <li class="actions"></li>\n            </ul>\n        {{/LoanMonthlyTotal}}\n        {{#InsuranceMonthlyTotal}}\n        <ul class="non-editable">\n            <li><span class="title">Insurance(s)</span></li>\n            <li>\n                <div>\n                    <div class="input readonly">\n                        <i>$</i>\n                        <input type="text" readonly value="{{InsuranceMonthlyTotal}}" />\n                    </div>\n                </div>\n            </li>\n            <li>\n                <select disabled class="sm no-float">\n                    <option>/MO</option>\n                </select>\n            </li>\n            <li class="actions"></li>\n        </ul>\n        {{/InsuranceMonthlyTotal}}\n        {{#CategoryItems}}\n            {{> ExpensesStep_Item}}\n        {{/CategoryItems}}\n    </li>\n    </li>\n',
  ExpensesStep_Item:
    '<ul data-tplid="{{tplid}}" data-value="{{Id}}" data-name="{{Name}}" data-new="{{Custom}}">\n    <li>\n        {{^Custom}}<span class="title">{{Name}}</span>{{/Custom}}\n        {{#Custom}}\n            <div class="input inline-editor">\n                <input placeholder="Expense Name" class="expense_name" type="text" value="{{Name}}"/>\n            </div>\n        {{/Custom}}\n        <input type="hidden" name="Name" value="{{Name}}"/>\n    </li>\n    <li>\n        <div {{#CanEstimate}}class="estimable"{{/CanEstimate}}>\n            <div class="input">\n                <i>$</i>\n                <input autocomplete="off" value="{{Amount}}" name="Amount" type="text" data-type="money" id="{{Name}}"/>\n            </div>\n            {{#CanEstimate}}\n                <a class="estimate_expense" data-callout="EstimateExpense">\n                    <i class="fa fa-lg fa-magic"></i>\n                </a>\n            {{/CanEstimate}}\n        </div>\n    </li>\n    <li>\n        <select data-value="{{Frequency}}" name="Frequency" class="sm no-float">\n            {{#Frequencies}}\n                <option value="{{value}}">{{label}}</option>\n            {{/Frequencies}}\n        </select>\n    </li>\n    <li class="actions">\n        <div>\n            <a title="Removes all data for this expense category"\n               tabindex="-1" class="btn no-margin float-left muted trash">\n                <i class="fa fa-lg fa-trash-alt"></i>\n            </a>\n            <a title="Make this a recurring expense." tabindex="-1"\n               class="btn no-margin float-left muted expense-schedule">\n                <i class="far fa-lg fa-calendar-alt"></i>\n            </a>\n            <input type="hidden" name="index" value="{{index}}"/>\n        </div>\n    </li>\n</ul>',
  Profile_Expenses:
    '<div id="Profile_Expenses" class="Profile" data-tplid="{{tplid}}">\n\n    <header>\n        <h2>Expenses</h2>\n        <h3>Include all expenses except for mortgage, loans, insurance premiums, and systematic savings.</h3>\n    </header>\n    <form class="adv-form">\n        <div>\n            {{#CanEstimate}}\n            <div class="clearfix float-left">\n                <button class="outline auto-width estimate_expense">\n                    <i class="fa fa-magic"></i> Estimate from Transactions\n                </button>\n            </div>\n            {{/CanEstimate}}\n            <div class="clearfix float-right">\n                <input type="checkbox" id="total_option" class="toggle" {{^Total}}checked{{/Total}} />\n                <label for="total_option"></label>\n                <p data-disabled>Detailed</p>\n                <p data-enabled>Detailed</p>\n            </div>\n            <div class="clearfix">\n                <ul class="horizontal-layout total-section">\n                    <li>\n                        <label for="amount">Amount</label>\n                    </li>\n                    <li>\n                        <div id="total_expense" class="input">\n                            <i>$</i>\n                            <input type="text" data-type="money" placeholder="0" id="amount" value="{{Total.Amount}}"/>\n                        </div>\n                    </li>\n                    <li>\n                        <select data-value="{{Total.Frequency}}" id="amount_freq" name="Frequency" class="fancy">\n                            {{#Frequencies}}\n                                <option value="{{value}}">{{label}}</option>\n                            {{/Frequencies}}\n                        </select>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div id="detailed-form">\n            <div class="container">\n                {{! Empty form to add expense }}\n                {{>ExpensesStep_Form_Item}}\n            </div>\n            <a class="btn-add"><i class="fa fa-lg fa-plus-circle"></i> Add Expense</a>\n        </div>\n    </form>\n\n</div>',
  Profile_Recurrence:
    '<ul data-tplid="{{tplid}}" data-schedule>\n    <li>\n        <input type="hidden" name="schedule" value="true" />\n        {{>Expense_Recurrence}}\n    </li>\n</ul>',
  Profile_Trusts:
    '<div id="Profile_Trusts" class="Profile" data-tplid="{{tplid}}">\n\n    <header>\n        <h2>Trusts</h2>\n        <h3>Please specify any trusts that have legal ownership over some of your accounts.</h3>\n    </header>\n\n    <button class="add" disabled><i class="fa fa-plus"></i>Add Trust</button>\n\n    <section class="trusts"></section>\n</div>',
  Profile_Trusts_Add:
    '<div id="Profile_Trusts_Add" class="popup" data-tplid="{{tplid}}">\n    <h2 class="title">{{#Id}}Edit Trust{{/Id}}{{^Id}}Add Trust{{/Id}}<i\n            class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <input type="hidden" name="Id" value="{{Id}}">\n        <ul class="vertical-layout narrow-labels">\n            <li>\n                <label for="TrustName">Name</label>\n                <input type="text" value="{{Name}}" name="Name" id="TrustName" />\n            </li>\n        </ul>\n        <button class="toggle" id="show-advanced"><i class="fa fa-sliders-h"></i>Show Advanced</button>\n\n        <div id="advanced-section">\n            <button class="toggle" id="hide-advanced"><i class="fa fa-sliders-h"></i>Hide Advanced</button>\n            <form class="adv-form">\n                <ul class="vertical-layout narrow-labels">\n                    <li>\n                        <label for="TrustType">Type</label>\n                        <select data-value="{{TrustType}}" name="TrustType"\n                                id="TrustType" class="md" placeholder="Select a type">\n                            <option></option>\n                            {{#TrustTypeOptions}}\n                                <option value="{{value}}">{{label}}</option>\n                            {{/TrustTypeOptions}}\n                        </select>\n                    </li>\n                    <li class="irrevocable-extra-fields">\n                        <label for="Grantor">Grantor</label>\n                        <select data-value="{{Grantor}}" name="Grantor"\n                                id="Grantor" class="md" placeholder="Select a grantor">\n                            <option></option>\n                            {{#GrantorOptions}}\n                                <option value="{{value}}">{{label}}</option>\n                            {{/GrantorOptions}}\n                        </select>\n                    </li>\n                    <li class="irrevocable-extra-fields">\n                        <label for="IsGstExempt">GST Exempt</label>\n                        <select data-value="{{IsGstExempt}}" name="IsGstExempt"\n                                id="IsGstExempt" class="md" placeholder="Select an option">\n                            <option value="true">Yes</option>\n                            <option value="false">No</option>\n                        </select>\n                    </li>\n                    <li>\n                        <label for="Situs">Situs</label>\n                        <input type="text" value="{{Situs}}" name="Situs" id="Situs" placeholder="Type a location" />\n                    </li>\n                    <li>\n                        <label for="Trustees">Trustees</label>\n                        <input type="text" value="{{Trustees}}" name="Trustees" id="Trustees" placeholder="Type a list of trustees" />\n                    </li>\n                    <li>\n                        <label for="DatedDate">Dated Date</label>\n                        <div class="input">\n                            <input type="text" data-type="date" value="{{DatedDate}}" name="DatedDate" id="DatedDate" placeholder="MM/DD/YYYY" />\n                            <i class="far fa-calendar-alt"></i>\n                        </div>\n                    </li>\n                </ul>\n            </form>\n        </div>\n    </form>\n    <div class="actions">\n        <button class="green" id="btn-save">{{#Id}}Save Changes{{/Id}}{{^Id}}Add Trust{{/Id}}</button>\n        <button class="secondary dismiss" id="btn-cancel">Cancel</button>\n        {{#Id}}<button class="red rhs" id="btn-remove" data-id="{{.}}"><i class="far fa-trash-alt"></i>Delete</button>{{/Id}}\n    </div>\n</div>',
  Profile_Trusts_List:
    '<div id="Profile_Trusts_List" data-tplid="{{tplid}}">\n    {{#Trusts.Items.length}}\n        <table class="CRUD institution {{^Trusts.Items}}empty{{/Trusts.Items}}">\n            <tr class="title"><td colspan="2">\n                <i class="fa fa-home"></i>Trusts\n            </td></tr>\n            <tr class="labels">\n                <td>Name</td>\n                {{!<td>Type</td>}}\n                <td>&nbsp;</td>\n            </tr>\n            {{#Trusts.Items}}\n                <tr data-id="{{Id}}" class="row">\n                    <td class="name">{{Name}}</td>\n                    <td class="datedDate hidden">{{DatedDate}}</td>\n                    <td class="grantor hidden">{{Grantor}}</td>\n                    <td class="isGstExempt hidden">{{IsGstExempt}}</td>\n                    <td class="trustType hidden">{{TrustType}}</td>\n                    <td class="situs hidden">{{Situs}}</td>\n                    <td class="trustees hidden">{{Trustees}}</td>\n                    <td class="actions"><i class="far fa-edit"></i><i class="far fa-trash-alt del"></i></td>\n                </tr>\n            {{/Trusts.Items}}\n        </table>\n    {{/Trusts.Items.length}}\n    {{^Trusts.Items}}\n        <div class="empty">\n            <i class="fa fa-briefcase"></i>\n            <p>You have not added any trusts.</p>\n            <button class="add"><i class="fa fa-plus"></i>Add Trust</button>\n        </div>\n    {{/Trusts.Items}}\n</div>',
  Profile_OtherAssets:
    '<div id="Profile_OtherAssets" class="Profile" data-tplid="{{tplid}}">\n\n    <header>\n        <h2>Other Assets</h2>\n        <h3>Please include pensions, real estate, business assets, and other miscellaneous assets.</h3>\n    </header>\n\n    <button class="add"><i class="fa fa-plus"></i>Add Asset</button>\n\n    <section class="assets"></section>\n</div>',
  Profile_OtherAssets_Add:
    '<div id="Profile_OtherAssets_Add" class="popup" data-tplid="{{tplid}}">\n    <h2 class="title">Add Asset<i class="fa fa-times close"></i></h2>\n\n    <ul>\n        <li data-val="BusinessAsset"><i class="fa fa-briefcase"></i>Business Asset</li>\n        <li data-val="RealEstate"><i class="fa fa-home"></i>Real Estate</li>\n        <li data-val="Pension"><i class="fa fa-university"></i>Pension</li>\n        <li data-val="MiscellaneousAsset"><i class="fa fa-car"></i>Miscellaneous<span>Car, jewelery, art, etc.</span></li>\n    </ul>\n\n</div>',
  Profile_OtherAssets_Edit_BusinessAsset:
    '<div id="Profile_OtherAssets_Edit_BusinessAsset" class="EditAccountWidget popup" data-tplid="{{tplid}}">\n    <h2 class="title">{{^asset.Id}}Add Business Asset{{/asset.Id}}{{#asset.Id}}Edit Business Asset{{/asset.Id}}<i class="fa fa-times close"></i></h2>\n    <form class="adv-form">\n        <input type="hidden" name="Id" value="{{asset.Id}}">\n        <ul class="vertical-layout">\n            <li>\n                <label for="field-Name">Name</label>\n                <input type="text" name="Name" value="{{asset.Name}}" id="field-Name" maxlength="32">\n            </li>\n            <li>\n                <label for="field-Owner">Owner</label>\n                <select data-value="{{asset.Owner}}" name="Owner" id="field-Owner" class="md">\n                    {{#options.BusinessAssetOptions.ownerOptions}}\n                        {{#options.BusinessAssetOptions.ownerOptions.Trusts.length}}\n                            <optgroup label="People">\n                                {{#options.BusinessAssetOptions.ownerOptions.People}}\n                                    <option value="{{.}}">{{.}}</option>\n                                {{/options.BusinessAssetOptions.ownerOptions.People}}\n                            </optgroup>\n                            <optgroup label="Trusts">\n                                {{#options.BusinessAssetOptions.ownerOptions.Trusts}}\n                                    <option value="{{.}}">{{.}}</option>\n                                {{/options.BusinessAssetOptions.ownerOptions.Trusts}}\n                            </optgroup>\n                        {{/options.BusinessAssetOptions.ownerOptions.Trusts.length}}\n                        {{^options.BusinessAssetOptions.ownerOptions.Trusts.length}}\n                            {{#options.BusinessAssetOptions.ownerOptions.People}}\n                                <option value="{{.}}">{{.}}</option>\n                            {{/options.BusinessAssetOptions.ownerOptions.People}}\n                        {{/options.BusinessAssetOptions.ownerOptions.Trusts.length}}\n                    {{/options.BusinessAssetOptions.ownerOptions}}\n                </select>\n            </li>\n            <li>\n                <label for="field-MarketValue">Value</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="Value" value="{{asset.Value}}" id="field-MarketValue" class="sm">\n                </div>\n            </li>\n            <li>\n                <label for="field-YearlyIncome">Pre-tax Profit</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="YearlyIncome" id="field-YearlyIncome" value="{{asset.YearlyIncome}}" class="sm">\n                    <i>/year</i>\n                </div>\n            </li>\n            <li>\n                <label>Earmark</label>\n                <select data-value="{{AssetEarmark}}" name="AssetEarmark[Type]" class="lg" placeholder="Select a goal...">\n                    <option></option>\n                    {{#options.BusinessAssetOptions.EarmarkOptions}}\n                        <option value="{{value}}">{{label}}</option>\n                    {{/options.BusinessAssetOptions.EarmarkOptions}}\n                </select>\n            </li>\n            <li class="show-advanced">\n                <label>&nbsp;</label>\n                <a href="#"><i class="fa fa-sliders-h"></i><span class="show">Show</span><span class="hide">Hide</span> Advanced</a>\n            </li>\n            <li class="advanced adv-form">\n                <ul class="vertical-layout">\n                    <li>\n                        <label>Sale Year</label>\n                        <select data-value="{{asset.SaleYear}}" id="field-SaleYear" name="SaleYear" class="sm dropdown-direction-up">\n                            <option value="">&nbsp;</option>\n                            {{#options.BusinessAssetOptions.SaleYearOptions}}\n                                <option value="{{.}}">{{.}}</option>\n                            {{/options.BusinessAssetOptions.SaleYearOptions}}\n                        </select>\n                        <i class="fa fa-question-circle more-info" data-callout="SaleYear"></i>\n                    </li>\n                    <li>\n                        <label>Net Proceeds from Sale</label>\n                        <div class="input">\n                            <i>$</i>\n                            <input type="text" maxlength="14" data-type="money" name="SaleNetEarnings" value="{{asset.SaleNetEarnings}}">\n                        </div>\n                        <i class="fa fa-question-circle more-info" data-callout="SaleNetEarnings"></i>\n                    </li>\n                    <li>\n                        <label for="field-IncomeGrowth">Income Growth</label>\n                        <div class="input">\n                            <input type="text" data-type="interest-negative" maxlength="3" name="IncomeGrowth" id="field-IncomeGrowth" value="{{asset.IncomeGrowth}}" />\n                            <i>%</i>\n                        </div>\n                    </li>\n                    <li>\n                        <label>SECA Tax</label>\n                        <div>\n                            <input type="checkbox" id="field-SelfEmployed" name="SelfEmployed"\n                                   class="toggle" {{#asset.SelfEmployed}}\n                                   checked{{/asset.SelfEmployed}} />\n                            <label for="field-SelfEmployed"></label>\n                            <p data-enabled></p>\n                            <p data-disabled></p>\n                        </div>\n                        <i class="fa fa-question-circle more-info" data-callout="SECATax"></i>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green" id="btn-save">{{#asset.Id}}Save Changes{{/asset.Id}}{{^asset.Id}}Add Asset{{/asset.Id}}</button>\n        <button class="secondary dismiss" id="btn-cancel">Cancel</button>\n        {{#asset.Id}}<button class="red rhs" id="btn-remove" data-id="{{.}}"><i class="far fa-trash-alt"></i>Delete</button>{{/asset.Id}}\n    </div>\n</div>',
  Profile_OtherAssets_Edit_MiscellaneousAsset:
    '<div id="Profile_OtherAssets_Edit_MiscellaneousAsset" class="EditAccountWidget popup" data-tplid="{{tplid}}">\n    <h2 class="title">{{^asset.Id}}Add Miscellaneous Asset{{/asset.Id}}{{#asset.Id}}Edit Miscellaneous Asset{{/asset.Id}}<i class="fa fa-times close"></i></h2>\n    <form class="adv-form">\n        <input type="hidden" name="Id" value="{{asset.Id}}">\n        <ul class="vertical-layout">\n            <li>\n                <label for="field-Name">Name</label>\n                <input type="text" name="Name" value="{{asset.Name}}" id="field-Name" maxlength="32">\n            </li>\n            <li>\n                <label for="field-Owner">Owner</label>\n                <select data-value="{{asset.Owner}}" name="Owner" id="field-Owner" class="md">\n                    {{#options.MiscellaneousAssetOptions.ownerOptions}}\n                        {{#options.MiscellaneousAssetOptions.ownerOptions.Trusts.length}}\n                            <optgroup label="People">\n                                {{#options.MiscellaneousAssetOptions.ownerOptions.People}}\n                                    <option value="{{.}}">{{.}}</option>\n                                {{/options.MiscellaneousAssetOptions.ownerOptions.People}}\n                            </optgroup>\n                            <optgroup label="Trusts">\n                                {{#options.MiscellaneousAssetOptions.ownerOptions.Trusts}}\n                                    <option value="{{.}}">{{.}}</option>\n                                {{/options.MiscellaneousAssetOptions.ownerOptions.Trusts}}\n                            </optgroup>\n                        {{/options.MiscellaneousAssetOptions.ownerOptions.Trusts.length}}\n                        {{^options.MiscellaneousAssetOptions.ownerOptions.Trusts.length}}\n                            {{#options.MiscellaneousAssetOptions.ownerOptions.People}}\n                                <option value="{{.}}">{{.}}</option>\n                            {{/options.MiscellaneousAssetOptions.ownerOptions.People}}\n                        {{/options.MiscellaneousAssetOptions.ownerOptions.Trusts.length}}\n                    {{/options.MiscellaneousAssetOptions.ownerOptions}}\n                </select>\n            </li>\n            <li>\n                <label for="field-MarketValue">Value</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="MarketValue" value="{{asset.MarketValue}}" id="field-MarketValue" class="sm">\n                </div>\n            </li>\n\n            <li class="show-advanced">\n                <label>&nbsp;</label>\n                <a href="#"><i class="fa fa-sliders-h"></i><span class="show">Show</span><span class="hide">Hide</span> Advanced</a>\n            </li>\n            <li class="advanced adv-form" style="display: none;">\n                <ul class="vertical-layout">\n                    <li>\n                        <label>Sale Year</label>\n                        <select data-value="{{asset.SaleYear}}" id="field-SaleYear" name="SaleYear" class="sm dropdown-direction-up">\n                            <option value="">&nbsp;</option>\n                            {{#options.MiscellaneousAssetOptions.SaleYearOptions}}\n                                <option value="{{.}}">{{.}}</option>\n                            {{/options.MiscellaneousAssetOptions.SaleYearOptions}}\n                        </select>\n                        <i class="fa fa-question-circle more-info" data-callout="SaleYear"></i>\n                    </li>\n                    <li>\n                        <label>Net Proceeds from Sale</label>\n                        <div class="input">\n                            <i>$</i>\n                            <input type="text" maxlength="14" data-type="money" name="SaleNetEarnings" value="{{asset.SaleNetEarnings}}">\n                        </div>\n                        <i class="fa fa-question-circle more-info" data-callout="SaleNetEarnings"></i>\n                    </li>\n                </ul>\n            </li>\n\n        </ul>\n    </form>\n    <div class="actions">\n        <button class="green" id="btn-save">{{#asset.Id}}Save Changes{{/asset.Id}}{{^asset.Id}}Add Asset{{/asset.Id}}</button>\n        <button class="secondary dismiss" id="btn-cancel">Cancel</button>\n        {{#asset.Id}}<button class="red rhs" id="btn-remove" data-id="{{.}}"><i class="far fa-trash-alt"></i>Delete</button>{{/asset.Id}}\n    </div>\n</div>',
  Profile_OtherAssets_Edit_Pension:
    '<div id="Profile_OtherAssets_Edit_Pension" class="EditAccountWidget popup" data-tplid="{{tplid}}">\n    <h2>{{#asset.Id}}Edit Pension Plan{{/asset.Id}}{{^asset.Id}}Add Pension Plan{{/asset.Id}}<i class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <input type="hidden" name="Id" value="{{asset.Id}}">\n        <ul class="vertical-layout">\n            <li>\n                <label for="field-Name">Name</label>\n                <input type="text" name="Name" value="{{asset.Name}}" id="field-Name" maxlength="32">\n            </li>\n            <li>\n                <label for="field-Recipient">Recipient</label>\n                <select data-value="{{asset.Recipient}}" name="Recipient" id="field-Recipient" class="md">\n                    {{#options.PensionOptions.recepientOptions}}<option>{{.}}</option>{{/options.PensionOptions.recepientOptions}}\n                </select>\n            </li>\n            <li>\n                <label for="field-PensionPlanType">Type</label>\n                <select data-value="{{asset.PensionPlanType}}" name="PensionPlanType" id="field-PensionPlanType" class="md">\n                    <option></option>\n                    {{#options.PensionOptions.planTypeOptions}}<option value="{{value}}">{{label}}</option>{{/options.PensionOptions.planTypeOptions}}\n                </select>\n            </li>\n            <li>\n                <label for="field-MonthlyPayment">Monthly Payment</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="MonthlyPayment" value="{{asset.MonthlyPayment}}" id="field-MonthlyPayment" class="xxsm">\n                    <i>/month</i>\n                </div>\n            </li>\n            <li>\n                <label for="field-DistributionAge">Distribution Age</label>\n                <select data-value="{{asset.DistributionAge}}" name="DistributionAge" id="field-DistributionAge" class="xsm dropdown-direction-up">\n                    <option></option>\n                    {{#options.PensionOptions.distributionAgeOptions}}\n                    <option>{{.}}</option>{{/options.PensionOptions.distributionAgeOptions}}\n                </select>\n            </li>\n        </ul>\n        <ul class="vertical-layout">\n            <li class="show-advanced">\n                <label>&nbsp;</label>\n                <a href="#"><i class="fa fa-sliders-h"></i><span class="show">Show</span><span\n                        class="hide">Hide</span> Advanced</a>\n            </li>\n            <li class="advanced adv-form">\n                <ul class="vertical-layout">\n                    <li>\n                        <label for="field-IsInflationAdjusted">Inflation Adjusted</label>\n                        <select data-value="{{asset.IsInflationAdjusted}}" name="IsInflationAdjusted" id="field-IsInflationAdjusted" class="xsm">\n                            <option></option>\n                            <option value="false">No</option>\n                            <option value="true">Yes</option>\n                        </select>\n                    </li>\n                    <li id="inflation_field">\n                        <label for="field-Inflation">Inflation Rate</label>\n                        <div class="input">\n                            <input type="text" data-type="interest-negative" name="Inflation" id="field-Inflation" value="{{asset.Inflation}}" />\n                            <i>%</i>\n                        </div>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n\n    </form>\n    <div class="actions">\n        <button class="green" id="btn-save">{{#asset.Id}}Save Changes{{/asset.Id}}{{^asset.Id}}Add Plan{{/asset.Id}}</button>\n        <button class="secondary dismiss" id="btn-cancel">Cancel</button>\n        {{#asset.Id}}<button class="red rhs" id="btn-remove" data-id="{{.}}"><i class="far fa-trash-alt"></i>Delete</button>{{/asset.Id}}\n    </div>\n</div>',
  Profile_OtherAssets_Edit_RealEstate:
    '<div id="Profile_OtherAssets_Edit_RealEstate" class="EditAccountWidget popup" data-tplid="{{tplid}}">\n\n    <h2 class="title">{{#asset.Id}}Edit Real Estate{{/asset.Id}}{{^asset.Id}}Add Real Estate{{/asset.Id}}<i class="fa fa-times close"></i></h2>\n\n    <form class="adv-form">\n        <input type="hidden" name="Id" value="{{asset.Id}}">\n        <input type="hidden" name="MortgageId" value="{{asset.MortgageId}}">\n        <ul class="vertical-layout">\n            <li>\n                <label for="field-Name">Property Name</label>\n                <input type="text" name="Name" value="{{asset.Name}}" id="field-Name" maxlength="32">\n            </li>\n            <li>\n                <label for="field-InvestmentType">Usage</label>\n                <select data-value="{{asset.InvestmentType}}" name="InvestmentType" id="field-InvestmentType" class="md">\n                    <option></option>\n                    {{#options.RealEstateOptions.investmentTypeOptions}}<option value="{{value}}">{{label}}</option>{{/options.RealEstateOptions.investmentTypeOptions}}\n                </select>\n            </li>\n            <li>\n                <label for="field-Owner">Owner</label>\n                <select data-value="{{asset.Owner}}" name="Owner" id="field-Owner" class="md">\n                    {{#options.RealEstateOptions.ownerOptions}}\n                        {{#options.RealEstateOptions.ownerOptions.Trusts.length}}\n                            <optgroup label="People">\n                                {{#options.RealEstateOptions.ownerOptions.People}}\n                                    <option value="{{.}}">{{.}}</option>\n                                {{/options.RealEstateOptions.ownerOptions.People}}\n                            </optgroup>\n                            <optgroup label="Trusts">\n                                {{#options.RealEstateOptions.ownerOptions.Trusts}}\n                                    <option value="{{.}}">{{.}}</option>\n                                {{/options.RealEstateOptions.ownerOptions.Trusts}}\n                            </optgroup>\n                        {{/options.RealEstateOptions.ownerOptions.Trusts.length}}\n                        {{^options.RealEstateOptions.ownerOptions.Trusts.length}}\n                            {{#options.RealEstateOptions.ownerOptions.People}}\n                                <option value="{{.}}">{{.}}</option>\n                            {{/options.RealEstateOptions.ownerOptions.People}}\n                        {{/options.RealEstateOptions.ownerOptions.Trusts.length}}\n                    {{/options.RealEstateOptions.ownerOptions}}\n                </select>\n            </li>\n            <li>\n                <label for="field-MarketValue">Market Value</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="MarketValue" value="{{asset.MarketValue}}" id="field-MarketValue" class="sm">\n                </div>\n            </li>\n            <li>\n                <label for="field-MortgageType">Mortgage Type</label>\n                <select data-value="{{asset.MortgageType}}" name="MortgageType" id="field-MortgageType" data-action="show-next" data-relation-value="" class="md">\n                    <option value="">No Mortgage</option>\n                    <option value="Existing">Link Existing Mortgage</option>\n                    {{#options.RealEstateOptions.mortgageTypeOptions}}<option value="{{value}}">{{label}}</option>{{/options.RealEstateOptions.mortgageTypeOptions}}\n                </select>\n            </li>\n            <li style="display: none;" data-relation="MortgageType" data-restriction="Existing">\n                <label>Mortgage</label>\n                <select name="MortgageId" id="field-MortgageId" data-value="{{asset.MortgageId}}">\n                    <option value="">Select an existing mortgage</option>\n                    {{#options.RealEstateOptions.ExistingMortgages}}\n                        <option value="{{MortgageId}}">{{MortgageLabel}}</option>\n                    {{/options.RealEstateOptions.ExistingMortgages}}\n                </select>\n            </li>\n            <li style="display: none;" data-relation="MortgageType" data-restriction="NotLinked">\n                <label>Financial Institution</label>\n                <select name="MortgageInstitutionId" placeholder="Start typing..."></select>\n            </li>\n            <li style="display: none;" data-relation="MortgageType">\n                <label for="field-MortgageOutstandingBalance">Outstanding Balance</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="MortgageOutstandingBalance" value="{{asset.MortgageOutstandingBalance}}" id="field-MortgageOutstandingBalance" class="sm">\n                </div>\n            </li>\n            <li style="display: none;" data-relation="MortgageType">\n                <label for="field-MortgageInterestRate">Interest Rate</label>\n                <div class="input">\n                    <input type="text" data-type="interest" maxlength="6" name="MortgageInterestRate" value="{{asset.MortgageInterestRate}}" id="field-MortgageInterestRate" class="sm">\n                    <i>%</i>\n                </div>\n            </li>\n            <li style="display: none;" data-relation="MortgageType" data-restriction="NotInterestOnly">\n                <label for="field-MortgageMonthlyPayment">Monthly Payment</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="MortgageMonthlyPayment" value="{{asset.MortgageMonthlyPayment}}" id="field-MortgageMonthlyPayment" class="xsm">\n                    <i>/month</i>\n                </div>\n                <i class="fa fa-question-circle more-info" data-callout="MonthlyPayment"></i>\n            </li>\n            <li style="display: none;" data-relation="MortgageType">\n                <label>Origination Date</label>\n                <div class="input">\n                    <input type="text" data-type="date" data-hidden-field="MortgageOriginationDate" value="{{asset.MortgageOriginationDate}}" id="field-MortgageOriginationDate" placeholder="MM/DD/YYYY">\n                    <input data-date type="hidden" name="MortgageOriginationDate" value="{{asset.MortgageOriginationDate}}">\n                    <i class="far fa-calendar-alt"></i>\n                </div>\n            </li>\n            <li>\n                <label for="field-YearlyRentalIncome">Rental Income (Yearly)</label>\n                <div class="input">\n                    <i>$</i>\n                    <input type="text" data-type="money" maxlength="14" name="YearlyRentalIncome" value="{{asset.YearlyRentalIncome}}" id="field-YearlyRentalIncome" class="sm">\n                    <i>/year</i>\n                </div>\n                <i class="fa fa-question-circle more-info" data-callout="YearlyRentalIncome"></i>\n            </li>\n            <li>\n                <label>Earmark</label>\n                <select data-value="{{AssetEarmark}}" name="AssetEarmark[Type]" class="lg" placeholder="Select a goal...">\n                    <option></option>\n                    {{#options.RealEstateOptions.EarmarkOptions}}\n                        <option value="{{value}}">{{label}}</option>\n                    {{/options.RealEstateOptions.EarmarkOptions}}\n                </select>\n            </li>\n            <li class="show-advanced">\n                <label>&nbsp;</label>\n                <a href="#"><i class="fa fa-sliders-h"></i><span class="show">Show</span><span class="hide">Hide</span> Advanced</a>\n            </li>\n            <li class="advanced adv-form" style="display: none;">\n                <ul class="vertical-layout">\n                    <li>\n                        <label>Sale Year</label>\n                        <select data-value="{{asset.SaleYear}}" id="field-SaleYear" name="SaleYear" class="sm dropdown-direction-up">\n                            <option value="">&nbsp;</option>\n                            {{#options.RealEstateOptions.SaleYearOptions}}\n                                <option value="{{.}}">{{.}}</option>\n                            {{/options.RealEstateOptions.SaleYearOptions}}\n                        </select>\n                        <i class="fa fa-question-circle more-info" data-callout="SaleYear"></i>\n                    </li>\n                    <li>\n                        <label>Net Proceeds from Sale</label>\n                        <div class="input">\n                            <i>$</i>\n                            <input type="text" maxlength="14" data-type="money" name="SaleNetEarnings" value="{{asset.SaleNetEarnings}}">\n                        </div>\n                        <i class="fa fa-question-circle more-info" data-callout="SaleNetEarnings"></i>\n                    </li>\n                    <li>\n                        <label for="field-IncomeGrowth">Income Growth</label>\n                        <div class="input">\n                            <input type="text" data-type="interest-negative" maxlength="14" name="IncomeGrowth" value="{{asset.IncomeGrowth}}" id="field-IncomeGrowth">\n                            <i>%</i>\n                        </div>\n                    </li>\n                </ul>\n            </li>\n\n        </ul>\n    </form>\n\n    <div class="actions">\n        <button class="green" id="btn-save">{{#asset.Id}}Save Changes{{/asset.Id}}{{^asset.Id}}Add Property{{/asset.Id}}</button>\n        <button class="secondary dismiss" id="btn-cancel">Cancel</button>\n        {{#asset.Id}}<button class="red rhs" id="btn-remove" data-id="{{.}}"><i class="far fa-trash-alt"></i>Delete</button>{{/asset.Id}}\n    </div>\n</div>',
  Profile_OtherAssets_List:
    '<div id="Profile_OtherAssets_List" data-tplid="{{tplid}}">\n    {{#Assets}}\n        {{#RealEstates.length}}\n            <table class="CRUD RealEstate">\n                <tr class="title"><td colspan="5"><i class="fa fa-home"></i>Real Estate</td></tr>\n                <tr class="labels">\n                    <td>Name</td>\n                    <td>Value</td>\n                    <td>Balance</td>\n                    <td>Mthly Pymt</td>\n                    <td>&nbsp;</td>\n                </tr>\n                {{#RealEstates}}\n                    <tr data-id="{{Id}}" data-type="RealEstate" class="row">\n                        <td class="field-name">{{Name}}</td>\n                        <td class="field-value">{{#format_money}}{{MarketValue}}{{/format_money}}</td>\n                        <td class="field-balance">{{#MortgageOutstandingBalance}}{{#format_money}}{{MortgageOutstandingBalance}}{{/format_money}}{{/MortgageOutstandingBalance}}{{^MortgageOutstandingBalance}}<span style="color:#999;">N/A</span>{{/MortgageOutstandingBalance}}</td>\n                        <td class="field-payment">{{#MortgageMonthlyPayment}}{{#format_money}}{{MortgageMonthlyPayment}}{{/format_money}}{{/MortgageMonthlyPayment}}{{^MortgageMonthlyPayment}}<span style="color:#999;">N/A</span>{{/MortgageMonthlyPayment}}</td>\n                        <td class="actions"><i class="far fa-edit"></i><i class="far fa-trash-alt del"></i></td>\n                    </tr>\n                {{/RealEstates}}\n            </table>\n        {{/RealEstates.length}}\n        {{#BusinessAssets.length}}\n            <table class="CRUD BusinessAsset">\n                <tr class="title"><td colspan="5"><i class="fa fa-briefcase"></i>Business Assets</td></tr>\n                <tr class="labels">\n                    <td>Name</td>\n                    <td>Owner</td>\n                    <td>Value</td>\n                    <td>Yrly Income</td>\n                    <td>&nbsp;</td>\n                </tr>\n                {{#BusinessAssets}}\n                    <tr data-id="{{Id}}" data-type="BusinessAsset" class="row">\n                        <td class="field-name">{{Name}}</td>\n                        <td class="field-owner">{{Owner}}</td>\n                        <td class="field-value">{{#format_money}}{{Value}}{{/format_money}}</td>\n                        <td class="field-income">{{#format_money}}{{YearlyIncome}}{{/format_money}}</td>\n                        <td class="actions"><i class="far fa-edit"></i><i class="far fa-trash-alt del"></i></td>\n                    </tr>\n                {{/BusinessAssets}}\n            </table>\n        {{/BusinessAssets.length}}\n        {{#Pensions.length}}\n            <table class="CRUD Pension">\n                <tr class="title"><td colspan="5"><i class="fa fa-university"></i>Pensions</td></tr>\n                <tr class="labels">\n                    <td>Recipient</td>\n                    <td>Type</td>\n                    <td>Mthly Pymt</td>\n                    <td>Dist Age</td>\n                    <td>&nbsp;</td>\n                </tr>\n                {{#Pensions}}\n                    <tr data-id="{{Id}}" data-type="Pension" class="row">\n                        <td class="field-owner">{{Recipient}}</td>\n                        <td class="field-type">{{#format_pension_plan_type}}{{PensionPlanType}}{{/format_pension_plan_type}}</td>\n                        <td class="field-pymt">{{#format_money}}{{MonthlyPayment}}{{/format_money}}</td>\n                        <td class="field-distage">{{DistributionAge}}</td>\n                        <td class="actions"><i class="far fa-edit"></i><i class="far fa-trash-alt del"></i></td>\n                    </tr>\n                {{/Pensions}}\n            </table>\n        {{/Pensions.length}}\n        {{#MiscellaneousAssets.length}}\n            <table class="CRUD MiscellaneousAsset">\n                <tr class="title"><td colspan="5"><i class="fa fa-car"></i>Miscellaneous Assets</td></tr>\n                <tr class="labels">\n                    <td>Name</td>\n                    <td>Value</td>\n                    <td>Owner</td>\n                    <td>&nbsp;</td>\n                    <td>&nbsp;</td>\n                </tr>\n                {{#MiscellaneousAssets}}\n                    <tr data-id="{{Id}}" data-type="MiscellaneousAsset" class="row">\n                        <td class="field-name">{{Name}}</td>\n                        <td class="field-value">{{#format_money}}{{MarketValue}}{{/format_money}}</td>\n                        <td class="field-owner">{{Owner}}</td>\n                        <td>&nbsp;</td>\n                        <td class="actions"><i class="far fa-edit"></i><i class="far fa-trash-alt del"></i></td>\n                    </tr>\n                {{/MiscellaneousAssets}}\n            </table>\n        {{/MiscellaneousAssets.length}}\n    {{/Assets}}\n    {{^Assets}}\n        <div class="empty">\n            <i class="fa fa-briefcase"></i>\n            <p>You have not added any assets.</p>\n            <button class="add"><i class="fa fa-plus"></i>Add Asset</button>\n        </div>\n    {{/Assets}}\n</div>',
  AdminAreaHeader:
    '<header id="AdminAreaHeader" data-tplid="{{tplid}}">\n    <ul class="actions">\n        {{^user.HideOrganizations}}\n        <li data-route="admin/organizations" class="overview"><i class="fa fa-users"></i>Organizations</li>\n        {{/user.HideOrganizations}}\n        <li data-route="admin/advisors" class="overview"><i class="fa fa-users"></i>Advisors</li>\n        <li data-route="admin/consumers" class="overview"><i class="fa fa-users"></i>Consumers</li>\n        {{^user.HideReports}}\n        <li data-route="admin/reports" class="overview"><i class="fa fa-table"></i>Reports</li>\n        {{/user.HideReports}}\n    </ul>\n    <ul class="rhs-menu">\n        <li class="has-dropdown">\n            <i class="fa fa-bars"></i>\n            <ul class="adv-dropdown">\n                {{#user.ShowAdviserAreaLink}}\n                <li data-action="Go2AdviserArea"><i class="fa fa-users"></i>Adviser Area</li>\n                {{/user.ShowAdviserAreaLink}}\n                <li data-action="logout" data-params="true, false"><i class="fa fa-sign-out-alt"></i>Sign Out</li>\n            </ul>\n        </li>\n    </ul>\n</header>',
  AdminAreaLogo:
    '{{#info.WhiteLabel}}\n    <div class="WhiteLabel" data-route="admin/organizations">\n        {{#logo}}<img src="{{settings.endpoints.whitelabelDir}}{{logo}}" alt="{{title}}" style="{{inlineImgStyle}}"/>{{/logo}}\n        {{#title}}<p>{{title}}</p>{{/title}}\n    </div>\n{{/info.WhiteLabel}}\n{{^info.WhiteLabel}}\n    <div class="logo" data-route="admin/organizations">\n    </div>\n{{/info.WhiteLabel}}',
  WhiteLabel:
    '{{#info.WhiteLabel}}\n    <div class="WhiteLabel">\n        {{#logo}}<img src="{{settings.endpoints.whitelabelDir}}{{logo}}" alt="{{title}}" style="{{inlineImgStyle}}"/>{{/logo}}\n        {{#title}}<p>{{title}}</p>{{/title}}\n    </div>\n{{/info.WhiteLabel}}',
  'consumer-area-footer':
    '<footer class="application-footer">\n    <a class="powered-by" href="http://advizr.com" target="_blank">Powered by<img src="{{settings.endpoints.imgDir}}logo-hires-black.png" /></a>\n    Copyright &copy; {{info.CopyrightYear}} Advizr, Inc. &nbsp; {{info.version}} &nbsp; <a href="/Legal/Disclosures" target="_blank">Disclosures</a> &nbsp; <a href="/Legal/Privacy" target="_blank">Privacy Policy</a> &nbsp; <a href="#" data-action="Feedback">Feedback</a>\n</footer>',
  NetWorthHistory_NavItem:
    '<li data-tplid="{{tplid}}" data-index="{{index}}" data-title="{{title}}" data-value="{{value}}" class="{{#selected}}selected{{/selected}}">{{title}}</li>',
  Income_SocSec:
    '<li>\n    <label>Earner</label>\n    <select name="Earner" data-value="{{income.Earner}}" class="md">\n        {{#OwnerOptionsSocSec}}\n            <option value="{{value}}">{{label}}</option>\n        {{/OwnerOptionsSocSec}}\n    </select>\n</li>\n<li>\n    <label>Monthly PIA</label>\n    <div class="input">\n        <i>$</i>\n        <input type="text" data-type="money" maxlength="14" name="Amount" value="{{income.Amount}}" id="field-AnnualSalary" class="sm">\n        <i>/month</i>\n    </div>\n    <i class="fa fa-question-circle more-info" data-callout="MonthlyPIA">\n\n    </i>\n    <a class="estimate_SS" data-callout="PIA">\n        <i class="fa fa-lg fa-magic"></i>\n    </a>\n</li>\n<li>\n    <label>Starts at Age</label>\n    <select data-value="{{income.StartAge}}" name="StartAge" class="sm dropdown-direction-up">\n        <option value="">&nbsp;</option>\n        {{#SocialSecurityAgeOptions}}\n            <option value="{{.}}">{{.}}</option>\n        {{/SocialSecurityAgeOptions}}\n    </select>\n    <i class="fa fa-question-circle more-info" data-callout="StartsAtAge"></i>\n</li>\n<input type="hidden" name="Id" value="{{income.Id}}">',
};

window.ADV = (function(app) {
  app.initPrint = function() {
    HM.setViewModels(HM.ViewHelper);
    HM.add(templates);
  };

  return app;
})(window.ADV || {});

/*
    eslint-disable
    func-names,
    no-param-reassign,
    prefer-rest-params,
*/

ADV.util = (function(my) {
  /**
   * Combines close together signals into one.
   * @param func
   * @param wait
   * @param {boolean=} runFirst
   * @return {Function}
   */
  my.debounce = function(func, wait, runFirst) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      const later = function() {
        timeout = null;
        if (!runFirst) {
          func.apply(context, args);
        }
      };
      const callNow = runFirst && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  };

  my.throttle = function(func, threshhold, scope) {
    threshhold || (threshhold = 250);
    let last;
    let deferTimer;
    return function() {
      const context = scope || this;

      const now = +new Date();
      const args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(() => {
          last = now;
          func.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        func.apply(context, args);
      }
    };
  };

  my.guid = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  my.dispatchHTMLEvent = function(element, event) {
    if ('createEvent' in document) {
      var e = document.createEvent('HTMLEvents');
      e.initEvent(event, false, true);
      element.dispatchEvent(e);
    } else {
      var e = document.createEventObject();
      e.eventType = event;
      element.fireEvent(`on${e.eventType}`, e);
    }
  };

  my.getHash = function() {
    if (window.location.hash) {
      return window.location.hash.substring(1);
    }
    return false;
  };

  my.scrollToTop = function(duration) {
    duration = duration === 0 ? 0 : 300;
    jQuery('html,body').animate({ scrollTop: 0 }, duration);
  };

  my.scrollTo = function(top, duration) {
    duration = duration === undefined ? 300 : duration;
    jQuery('html,body').animate({ scrollTop: top }, duration);
  };

  /**
   * Returns true if thing is an empty array, empty object, undefined or null.
   * @param thing
   */
  my.isEmpty = function(thing) {
    if (typeof thing === 'undefined' || thing === null) {
      return true;
    }
    if (typeof thing === 'array' && thing.length === 0) {
      return true;
    }
    return $.isEmptyObject(thing);
  };

  my.go2 = function(loc) {
    window.location = loc;
  };

  my.supportsLocalStorage = function() {
    const test = 'advizr';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };

  /**
   * Returns HTML string of errors, which could be a string, array, or object mapping. The result to be shown in a
   * popup, or 500 page.
   * @param errors
   */
  my.getErrorsHTMLFromResponse = function(errors) {
    let errorString = '';
    if (typeof errors === 'string') {
      return errors;
    }
    if ($.isArray(errors) && errors.length === 1) {
      return errors[0];
    }
    if (errors instanceof Object && Object.keys(errors).length === 1) {
      $.each(errors, (k, v) => {
        errorString = v;
      });
      return errorString;
    }
    if (
      ($.isArray(errors) && errors.length > 1) ||
      (errors instanceof Object && Object.keys(errors).length > 1)
    ) {
      errorString = '<ul>';
      $.each(errors, (k, v) => {
        errorString += `<li>${v}</li>`;
      });
      return `${errorString}</ul>`;
    }
    return ADV.settings.MsgLib.generic_error;
  };

  /**
   * Adds an error bubble to $target.
   * @param errors
   * @param $target
   * @param method //append, prepend, before (default: prepend)
   * @param callback
   */
  my.insertErrorBubble = function(errors, $target, method, callback) {
    method = method || 'prepend';

    // remove any existing ones
    $('.ErrorBubble').remove();

    if (method === 'prepend') {
      $target.prependView('ErrorBubble', { errors }, callback);
    } else if (method === 'before') {
      $target.beforeView('ErrorBubble', { errors }, callback);
    } else {
      $target.appendView('ErrorBubble', { errors }, callback);
    }

    // scroll into view
    const newBubble = $('.ErrorBubble');
    if (newBubble.length > 0) {
      newBubble.parent().get(0).scrollTop = 0;
    }
  };

  my.validateEmail = function(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  /**
   * @param number
   * @param decimals //number of decimal places, defaults to 0
   * @param dec_point //defaults to .
   * @param thousands_sep //defaults to ,
   * @returns {string|*}
   */
  my.number_format = function(number, decimals, dec_point, thousands_sep) {
    number = `${number}`.replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
    const dec = typeof dec_point === 'undefined' ? '.' : dec_point;
    let s;
    const toFixedFix = function(n, prec) {
      const k = Math.pow(10, prec);
      return `${Math.round(n * k) / k}`;
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  };

  /**
   * Converts formatted number strings back to integers
   * @param val
   * @returns {*}
   */
  my.as_number = function(val) {
    if (!val) {
      return 0;
    }
    if (typeof val === 'number') {
      return val;
    }
    return parseInt(val.split(',').join(''), 10);
  };

  /**
   * Determines whether the key input was numeric. Also allows
   * modifiers and navigational keypresses
   * @param keyCode
   * @returns {boolean}
   */
  my.numeric_input = function(keyCode) {
    return (
      (keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      keyCode === 8 ||
      keyCode === 9 ||
      keyCode === 46 ||
      keyCode === 37 ||
      keyCode === 39 ||
      keyCode === 16
    );
  };

  /**
   * Determines whether the key input was a modifier or navigational keypress
   * @param keyCode
   * @returns {boolean}
   */
  my.is_navigational_input = function(keyCode) {
    return (
      keyCode === 8 ||
      keyCode === 9 ||
      keyCode === 46 ||
      keyCode === 37 ||
      keyCode === 39 ||
      keyCode === 16
    );
  };

  /**
   * shades a color based on a percentage
   * @param color
   * @param percent
   * @returns {string}
   */
  my.shade_color = function(color, percent) {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return `#${(
      0x1000000 +
      (Math.round((t - R) * p) + R) * 0x10000 +
      (Math.round((t - G) * p) + G) * 0x100 +
      (Math.round((t - B) * p) + B)
    )
      .toString(16)
      .slice(1)}`;
  };

  /**
   * Takes a large number, and shortens it using postfixes. Ex:
   * 1000000 => 1M, 10000 => 10K, 10843 => 10.8K
   * Supports up to trillions (T).
   * @param number //must be a number
   * @param decimals //default is 2
   */
  my.short_number_format = function(number, decimals, lang = ['', 'K', 'M', 'B', 'T']) {
    decimals = typeof decimals !== 'undefined' && decimals >= 0 ? parseInt(decimals) : 2;
    const n = Math.round(number).toString();
    const len = n.length;
    const index = Math.floor((len - 1) / 3);
    const ll = lang.length;
    const i = index < ll ? index : ll - 1; // max is lang.length - 1
    const wlen = len - 3 * i;
    const dec = parseFloat(`0.${n.substr(wlen, decimals)}`);
    const num = parseInt(n.substr(0, wlen));
    const tot = num + dec;
    const fixed = Number.parseFloat(tot)
      .toFixed(decimals)
      .replace(/[.]0+$/, '');
    const formatted = fixed.indexOf('.') >= 0 ? fixed.replace(/0+$/, '') : fixed;
    return formatted + lang[i];
  };

  my.randomString = function(length) {
    length = length || 5;
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  };

  /**
   * Makes $el stick to the top of the window. You must call the returned 'destroy' function to free
   * resources when done. $el should be a container for the actual element you want to be sticky.
   * @param $el
   * @param top // Defaults to 50 if within Adviser Area, 0 otherwise.
   * @param callback //called whenever the status changes (sticky on, sticky off). Called with boolean, with true
   *                 //representing the 'on' state, and false representing the 'off' state.
   * @returns {{destroy: destroy}}
   */
  my.makeSticky = function($el, callback, top, bindWidth) {
    if (!$el.length) {
      throw '$el is not a valid jQuery object, or is empty';
    }
    callback = callback || function() {};
    top = top || 0;
    if ($('html').hasClass('area-adviser')) {
      if (top < 50) {
        top = 50;
      }
    }
    // create unique namespace for events, so they can be bound/unbound individually
    const namespace = my.randomString();
    const $window = $(window);
    let is_sticky = false;
    const $child = $el.find('> *');
    const events = `scroll.${namespace} resize.${namespace}`;
    const stickyOnCSS = {
      width: bindWidth || $el.innerWidth(),
      position: 'fixed',
      backfaceVisibility: 'hidden',
      top: `${top}px`,
    };
    const stickyOffCSS = {
      width: '',
      position: '',
      top: '',
    };

    $window.on(
      events,
      ADV.util.throttle(() => {
        if ($window.scrollTop() >= $el.offset().top - top) {
          // set styles to prevent jumping, and so that $item > * is still sized relative to container instead
          // of window
          $el.css('height', $el.innerHeight());
          $child.css(stickyOnCSS);
          $el.addClass('sticky-on');
          if (!is_sticky) {
            callback.call($el, true);
          }
          is_sticky = true;
        } else {
          // restore styles
          $el.css('height', '');
          $child.css(stickyOffCSS);
          $el.removeClass('sticky-on');
          if (is_sticky) {
            callback.call($el, false);
          }
          is_sticky = false;
        }
      }, 50),
    );

    return {
      destroy() {
        $window.off(`scroll.${namespace} resize.${namespace}`); // unbind event observer
      },
    };
  };

  my.getCurrentClient = function(advData) {
    if (!advData) {
      throw 'getBaseConsumerAreaBaseRoute: ADV.data is not initialized!';
    }

    if (!advData.user) {
      throw 'getBaseConsumerAreaBaseRoute: ADV.data.user is not initialized!';
    }
    return advData.user;
  };

  my.getNullableCurrentClient = function(advData) {
    try {
      return my.getCurrentClient(advData);
    } catch (_) {
      return null;
    }
  };

  /**
   * Environment detection. Returns information about the browser, OS, ADV master Area, etc.
   * Caches results the first time they are tested, unless bustCache is true (defaults to false).
   * Possible keywords:
   * isChrome, isSafari, isiOS, isMac, isConsumerArea, isAdviserArea, isPrintArea
   * @param test
   * @param {boolean=} bustCache //defaults to false
   * @returns {*}
   */
  my.env = function(test, bustCache) {
    const tests = {};
    const cache = ADV.util.envCache || {};
    tests.isChrome = function() {
      return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    };
    tests.isSafari = function() {
      return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    };
    tests.isiOS = function() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };
    tests.isMac = function() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    };
    tests.isConsumerArea = function() {
      return $('html').hasClass('area-consumer');
    };
    tests.isAdviserArea = function() {
      return $('html').hasClass('area-adviser');
    };
    tests.isPrintArea = function() {
      return $('html').hasClass('area-print');
    };
    tests.isDemoMode = function() {
      return $('html').hasClass('DemoMode');
    };

    // make sure test exists
    if (typeof tests[test] === 'undefined') {
      throw `test '${test}' is not defined in ADV.util.env`;
    }

    if (typeof cache[test] === 'undefined' || bustCache) {
      // do test and cache
      cache[test] = tests[test].apply();
      ADV.util.envCache = cache; // save cache
    }

    return cache[test];
  };

  /**
   * @param str
   * @param maxlen
   * @param ellipse
   * @returns {*}
   */
  my.truncateString = function(str, maxlen, ellipse) {
    maxlen = maxlen || 20;
    ellipse = ellipse || '...';
    return str.length > maxlen ? str.substring(0, maxlen - 3) + ellipse : str;
  };

  /**
   * Returns true of all of the properties of objA have matching properties in objB. Uses a shallow iterator, so it only looks
   * at the immediate properties, and does not traverse any further. Use strict to use '===' comparison, otherwise
   * '==' is used.
   * @param objA
   * @param objB
   * @param strict
   * @returns {boolean}
   */
  my.shallowCompareObjects = function(objA, objB, strict) {
    let is_equal = true;
    $.each(objA, (k, v) => {
      if (strict) {
        if (v !== objB[k]) {
          is_equal = false;
        }
      } else if (v != objB[k]) {
        is_equal = false;
      }
    });
    return is_equal;
  };

  my.deepEqual = function(A, B, strict) {
    const eq = function(u, v) {
      const isUArray = Array.isArray(u);
      const isVArray = Array.isArray(v);
      if (isUArray !== isVArray) {
        return false;
      }
      if (isVArray) {
        return eqArrays(u, v);
      }

      const isUObject = typeof u === 'object';
      const isVObject = typeof v === 'object';
      if (isUObject !== isVObject) {
        return false;
      }
      if (isVObject) {
        return eqObjects(u, v);
      }
      return strict ? u === v : u == v;
    };

    var eqArrays = function(u, v) {
      if (!u || !v) {
        return strict ? u === v : u == v;
      }
      if (u.length !== v.length) {
        return false;
      }
      for (let i = 0, l = u.length; i < l; i++) {
        if (!eq(u[i], v[i])) {
          return false;
        }
      }
      return true;
    };

    var eqObjects = function(x, y) {
      if (!x || !y) {
        return strict ? x === y : x == y;
      }
      for (const k in x) {
        if (x.hasOwnProperty(k)) {
          if (!y.hasOwnProperty(k)) {
            return false;
          }
          if (!eq(x[k], y[k])) {
            return false;
          }
        }
      }
      return true;
    };

    return eq(A, B);
  };

  /**
   * @param $tabs_ul
   */
  my.setupTabs = function($tabs_ul) {
    const $li = $tabs_ul.find('li');

    // if there is only one tab, hide tabs.
    if ($li.length <= 1) {
      // hide tabs
      $tabs_ul.css('display', 'none');
    } else {
      // set width of LI of tabs
      $li.css('width', `${100 / ($li.length * 1)}%`);
    }

    $tabs_ul.on('click', 'li', function() {
      $li.removeClass('selected');
      $(this).addClass('selected');
    });
  };

  /**
   * Enables or disables the 'empty_state' styling for the Adviser Area
   * @param show
   */
  my.showAdviserAreaEmptyState = function(show) {
    const $html = $('html');
    if (show) {
      $html.addClass('empty-state');
    } else {
      $html.removeClass('empty-state');
    }
  };

  /**
   * Inserts a view into div#module_container (shortcut).
   * @param id
   * @param {object=} data
   * @param {function=} callback
   */
  my.showModule = function(id, data, callback) {
    window.$module_container = window.$module_container || $('#module_container'); // cache
    window.$module_container.insertView(id, data, callback);
  };

  /**
   * Shows or hides the consumer area topleft nav.
   * @param val
   */
  my.showConsumerAreaNav = function(val) {
    ADV.consumer.set_workflow(!val);
  };

  my.toggleFullScreen = function() {
    if (
      !document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  };

  /**
   * Returns the Client Model for a given clientId. If in the Adviser Area, this is taken from the SidebarWidget, since it has
   * all of the the Adviser's clients. If we're in the Consumer Area, the current user is returned, if it matches the clientId
   * provided.
   * @param clientId
   * @returns {*}
   */
  my.getClient = function(clientId) {
    if (ADV.util.env('isAdviserArea')) {
      return _.get(ADV.store.getState(), 'AdviserArea.currentClient');
    }
    if (ADV.util.env('isConsumerArea')) {
      // see if current user's ID matches clientId
      const current_user = ADV.entities.getUserObject();
      if (current_user.Id == clientId) {
        return current_user;
      }
      return false;
    }
    return false;
  };

  my.getCurrentClientId = function() {
    if (ADV.util.env('isAdviserArea')) {
      return ADV.entities.getCurrentClientId();
    }
    if (ADV.util.env('isConsumerArea')) {
      return ADV.entities.getUserObject().Id || false;
    }
    return false;
  };

  /**
   * Computes the offset of the body element
   * @returns {{top: Number, left: Number}}
   */
  my.bodyOffset = function(body) {
    let top = body.offsetTop;
    let left = body.offsetLeft;
    const doesNotIncludeMarginInBodyOffset = body.offsetTop !== 1;
    if (doesNotIncludeMarginInBodyOffset) {
      top += parseFloat(body.getAttribute('marginTop')) || 0;
      left += parseFloat(body.getAttribute('marginLeft')) || 0;
    }
    return { top, left };
  };

  /**
   * Tests if the object is the current window object
   * @returns {Boolean}
   */
  my.isWindow = function(obj) {
    return obj != null && obj == obj.window;
  };

  /**
   * Gets the current window element
   * @returns {Boolean | *}
   */
  my.getWindow = function(elem) {
    return my.isWindow(elem)
      ? elem
      : elem.nodeType === 9
      ? elem.defaultView || elem.parentWindow
      : false;
  };

  /**
   * Returns the offset of the domElement
   * @returns {{top: Number, left: Number} | null}
   */
  my.getOffset = function(domElement) {
    let box;
    let docElem;
    let body;
    let win;
    let clientTop;
    let clientLeft;
    let scrollTop;
    let scrollLeft;
    let top;
    let left;
    const elem = domElement;
    const doc = elem && elem.ownerDocument;

    if (!doc) {
      return null;
    }

    if ((body = doc.body) === elem) {
      return my.bodyOffset(elem);
    }
    docElem = doc.documentElement;

    box = elem.getBoundingClientRect();
    win = my.getWindow(doc);
    clientTop = docElem.clientTop || body.clientTop || 0;
    clientLeft = docElem.clientLeft || body.clientLeft || 0;
    scrollTop = win.pageYOffset || docElem.scrollTop;
    scrollLeft = win.pageXOffset || docElem.scrollLeft;
    top = box.top + scrollTop - clientTop;
    left = box.left + scrollLeft - clientLeft;

    return { top, left };
  };

  my.getCss = function(elem, attribute) {
    return window.getComputedStyle(elem)[attribute];
  };

  my.isNodeName = function(elem, name) {
    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
  };

  my.getOffsetParent = function(elem) {
    let offsetParent = elem.offsetParent || elem;

    while (
      offsetParent &&
      !my.isNodeName(offsetParent, 'html') &&
      my.getCss(offsetParent, 'position') === 'static'
    ) {
      offsetParent = offsetParent.offsetParent;
    }
    return offsetParent || elem;
  };

  my.getPosition = function(elem) {
    if (!elem) {
      return;
    }

    let offsetParent;
    let offset;
    let parentOffset = {
      top: 0,
      left: 0,
    };

    // fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
    if (my.getCss(elem, 'position') === 'fixed') {
      // we assume that getBoundingClientRect is available when computed position is fixed
      offset = elem.getBoundingClientRect();
    } else {
      // Get *real* offsetParent
      offsetParent = my.getOffsetParent(elem);

      // Get correct offsets
      offset = my.getOffset(elem);
      if (!my.isNodeName(offsetParent, 'html')) {
        parentOffset = my.getOffset(offsetParent);
      }

      // Add offsetParent borders
      parentOffset.top += parseFloat(my.getCss(offsetParent, 'borderTopWidth'));
      parentOffset.left += parseFloat(my.getCss(offsetParent, 'borderLeftWidth'));
    }

    // Subtract parent offsets and element margins
    // note: when an element has margin: auto the offsetLeft and marginLeft
    // are the same in Safari causing offset.left to incorrectly be 0
    return {
      top: offset.top - parentOffset.top - parseFloat(my.getCss(elem, 'marginTop')),
      left: offset.left - parentOffset.left - parseFloat(my.getCss(elem, 'marginLeft')),
    };
  };

  /**
   * Returns the offset of the domElement
   * @returns {Number}
   */
  my.getScrollTop = function(elem) {
    const win = my.getWindow(elem);
    const prop = 'pageYOffset';
    const method = 'scrollTop';

    return win ? (prop in win ? win[prop] : win.document.documentElement[method]) : elem[method];
  };

  /**
   * Binds the toggle 'Show Advanced' links in popups. Not sure if this really belongs here, but it's the best place
   * I can think to put this for now. It's reused in many popups.
   * @param $scope
   */
  my.bindToggleAdvanced = function($scope) {
    $scope.on('click', '.show-advanced a', function(e) {
      e.preventDefault();
      $(this).toggleClass('show');
      $scope.find('li.advanced').slideToggle({
        complete() {
          ADV.util.popup.position(false, true);
        },
      });
      return false;
    });
  };

  my.shouldPostTheEntireCalibrationObject = function(goalType) {
    switch (goalType) {
      case 'homePurchase':
        return true;
      case 'healthCare':
        return true;
      case 'largePurchase':
        return true;
      default:
        return false;
    }
  };

  my.getLogoInlineCssStyle = function() {
    let logo = `${ADV.settings.endpoints.imgDir}logo-hires-color-white.png`;
    const whiteLabel = ADV.data.user.WhiteLabelDashboardLogoAbsoluteUrl;
    let extraStyling = '';
    if (whiteLabel) {
      logo = whiteLabel;
      extraStyling = 'background-color: #242424;' + 'margin: 0;' + 'width: 250px;';
    }
    return `background-image: url(${logo});${extraStyling}`;
  };

  my.getAdviserTopNavBarData = function() {
    return {
      logoInlineCssStyle: my.getLogoInlineCssStyle(),
      hasWhiteLabel: !!ADV.data.user.WhiteLabelDashboardLogoAbsoluteUrl,
    };
  };

  my.getClientListData = function(clients) {
    return {
      clients,
      user: ADV.data.user,
      hasWhiteLabel: !!ADV.data.user.WhiteLabelDashboardLogoAbsoluteUrl,
    };
  };

  my.isNumeric = function(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  };

  my.isNonZeroNumeric = function(n) {
    return my.isNumeric(n) && parseInt(n) !== 0;
  };

  my.setHelp = function(helpDescriptor) {
    ADV.Help = Object.assign(
      {
        key: my.randomString(5),
      },
      helpDescriptor || {},
    );
    return ADV.Help.key;
  };

  my.unsetHelp = function(key) {
    if (ADV.Help && ADV.Help.key === key) {
      ADV.Help = null;
    }
  };

  // Fix for ADV-5243 Duplicate Advanced Section in some Account forms until
  // we move profile page to react.
  my.setProfileEditShellAdvancedSectionVisibility = function(visible) {
    document.querySelectorAll('.outer-advanced a').forEach(advancedA => {
      advancedA.classList.toggle('show', visible);
    });
    document.querySelectorAll('.outer-advanced + .advanced').forEach(advancedSection => {
      if (visible !== ($(advancedSection).css('display') !== 'none')) {
        $(advancedSection).slideToggle({
          complete() {
            ADV.util.popup.position(false, true);
          },
        });
      }
    });
  };

  my.escapeHTML = function(string) {
    const entityMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '/': '&#x2F;',
    };
    return String(string).replace(/[&<>"'\/]/g, s => entityMap[s]);
  };

  my.getProfileEditShellAdvancedSectionVisibility = function() {
    let isVisible = false;
    document.querySelectorAll('.outer-advanced + .advanced').forEach(advancedSection => {
      isVisible = isVisible || $(advancedSection).css('display') !== 'none';
    });
    return isVisible;
  };

  my.setProfileEditShellAdvancedButtonsVisibility = function(visible) {
    document.querySelectorAll('.outer-advanced').forEach(advancedButton => {
      advancedButton.setAttribute('style', visible ? 'display:block;' : 'display:none;');
    });
  };

  my.numberFrom = function(quantity) {
    if (quantity === 0) {
      quantity = '0';
    }
    const trimmed = (quantity || '')
      .toString()
      .replace(/[$]/g, '')
      .replace(/[,]/g, '');
    if (ADV.util.isNumeric(trimmed)) {
      return +trimmed;
    }
    return quantity;
  };

  my.getCurrentPPI = function() {
    let elem;
    let ppi;
    elem = document.createElement('div');
    elem.style.width = '1in';
    document.body.appendChild(elem);
    ppi = elem.offsetWidth;
    document.body.removeChild(elem);
    return ppi;
  };
  my.openTrainerVideoIfFirstPage = function() {
    document.body.dispatchEvent(new CustomEvent('openTrainerVideoIfFirstPage'));
  };

  my.shallowEqual = function(objA, objB) {
    if (objA === objB) {
      return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
      return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false;
    }

    // Test for A's keys different from B.
    const bHasOwnProperty = hasOwnProperty.bind(objB);
    for (let i = 0; i < keysA.length; i++) {
      if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
        return false;
      }
    }

    return true;
  };

  my.monotonicSequenceGenerator = function() {
    if (!window._monotonicSequenceGenerator) {
      window._monotonicSequenceGenerator = 1;
    }
    window._monotonicSequenceGenerator++;
    return window._monotonicSequenceGenerator;
  };

  /**
   * Clears cache on Dashboard controller
   */
  my.clearDashboardCache = function() {
    sessionStorage.removeItem('dashboardData');
  };

  return my;
})(ADV.util || {});

ADV.util = (function(util) {
  util.SessionTimeout = (function() {
    let warningTimeout;
    let sessionTimeout;
    let warningModalTrigger;

    /**
     * Stops the front-end timer (doesn't stop the session from actually ending).
     */
    function stopTimer() {
      clearTimeout(warningTimeout);
      clearTimeout(sessionTimeout);
    }

    /**
     * Called when the session has timed out.
     */
    function sessionDidTimeOut() {
      // redirect to login page
      ADV.Controller.logout(true);
    }

    /**
     * Starts or resets the timer.
     */
    function startTimer(displayModalCallback) {
      stopTimer();

      warningModalTrigger = displayModalCallback || sessionIsAboutToEnd;
      warningTimeout = setTimeout(
        warningModalTrigger,
        ADV.settings.misc.session_timeout - ADV.settings.misc.session_warning_time,
      );
      sessionTimeout = setTimeout(sessionDidTimeOut, ADV.settings.misc.session_timeout);
    }

    /**
     * Sends a request to the server to have the session extended.
     */
    function extendSession() {
      ADV.util
        .request({
          uri: 'session/renew',
          type: 'POST',
          showSpinner: false,
        })
        .then(response => {
          if (response) {
            extendTimer();
          }
        });
    }

    /**
     * This should be called before the session ends, so the user has a chance to extend the session.
     */
    function sessionIsAboutToEnd() {
      ADV.util.popup.confirm(
        ADV.settings.MsgLib.timeout_warning,
        [
          {
            label: 'Sign me out',
            classes: 'rhs outline secondary',
          },
          {
            label: 'Keep me logged in',
            classes: 'rhs primary',
          },
        ],
        function(selection) {
          switch (selection) {
            case 0:
            default:
              // just log them out now
              ADV.Controller.logout(true);
              break;
            case 1:
              extendSession();
              break;
          }
        },
        'important-message',
      );
    }

    /**
     * Resets the timer. Only works if one has been set in the first place with _startTimer()
     */
    function extendTimer() {
      if (sessionTimeout) {
        clearTimeout(sessionTimeout);
        sessionTimeout = setTimeout(sessionDidTimeOut, ADV.settings.misc.session_timeout);
      }
      if (warningTimeout) {
        clearTimeout(warningTimeout);
        warningTimeout = setTimeout(
          warningModalTrigger,
          ADV.settings.misc.session_timeout - ADV.settings.misc.session_warning_time,
        );
      }
    }

    return {
      startTimer,
      stopTimer,
      extendTimer,
    };
  })();
  return util;
})(ADV.util || {});

ADV.util = (function(my) {
  var current_spinner_id;

  my.Spinner = function() {
    var $body = $('body');

    var id = ADV.util.randomString();
    current_spinner_id = id;

    if (!$body.find('.spinner').length) {
      $body.addClass('loading');
      $body.prepend(
        '<div class="spinner spinner-overlay"><div class="spinner spinner-container" role="status" aria-live="polite"></div></div>',
      );
      $('.spinner-container').append(
        '<p class="sr-only">Content is loading</p><i alt="loading"></i>',
      );
    }

    return {
      destroy: function() {
        if (current_spinner_id === id) {
          $body.removeClass('loading');
          $body.find('.spinner').remove();
          current_spinner_id = null;
        }
      },
    };
  };

  return my;
})(ADV.util || {});

ADV.util = (function(my) {
  var onBlur = function(e, dest) {
    if (!this.isFocused) return;
    this.isFocused = false;

    if (this.ignoreFocus) {
      return;
    } else if (
      (!this.ignoreBlur && document.activeElement === this.$dropdown_content[0]) ||
      // necessary to prevent IE closing the dropdown when the scrollbar is clicked
      !!document.querySelector('.selectize-dropdown:hover')
    ) {
      this.ignoreBlur = true;
      this.onFocus(e);
      return;
    }

    var deactivate = function() {
      this.close();
      this.setTextboxValue('');
      this.setActiveItem(null);
      this.setActiveOption(null);
      this.setCaret(this.items.length);
      this.refreshState();

      // IE11 bug: element still marked as active
      dest && dest.focus && dest.focus();

      this.ignoreFocus = false;
      this.trigger('blur');
    }.bind(this);

    this.ignoreFocus = true;
    if (this.settings.create && this.settings.createOnBlur) {
      this.createItem(null, false, deactivate);
    } else {
      deactivate();
    }
  };

  /**
   * Sets value selected in all <select>, optionally within $scope, that has data-value defined.
   * @param $scope
   */
  my.selectSelects = function($scope) {
    $scope = $scope || $(document);
    $scope.find('select[data-value]').each(function() {
      var $this = $(this);
      my.selectDropdownValue($this.get(0), $this.data('value'));
    });
  };

  /**
   * Initializes all <select> within $scope using Selectize.JS with default options. Ignores any <select>
   * with data-custom attribute, since those will be instantiated individually.
   * @param $scope
   */
  my.initSelectsWithDefaultOptions = function($scope) {
    //select values
    my.selectSelects($scope);

    $scope.find('select').each(function() {
      var $this = $(this);
      if (!$this.data('custom') && !$this.hasClass('selectized')) {
        $this.selectize();

        $this[0].selectize.on('focus', () => {
          this.on('blur', onBlur);
        });
      }
    });
  };

  /**
   * Initializes input boxes with units (div.input). This is done using EVENT DELEGATION on $scope, so it's only necessary
   * to do once on $scope. Inputs don't need to be live in DOM at time function call.
   * @param $scope
   */
  my.initCustomInputBoxes = function($scope) {
    //clicking on box focuses input
    $scope.on('click', 'div.input', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this)
        .find('input')
        .focus();
    });

    //event handlers for text input box
    $scope.on('focus', 'div.input input', function() {
      $(this)
        .parent()
        .addClass('focus');
    });
    $scope.on('blur', 'div.input input', function() {
      $(this)
        .parent()
        .removeClass('focus');
    });
  };

  /**
   * Selects an option of a <\select>.
   * @param select //DOM element
   * @param value
   */
  my.selectDropdownValue = function(select, value) {
    //make sure value is parsed as string
    if (value.toString) value = value.toString();
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) {
        select.selectedIndex = i;
        $(select).data('val', value);
        break;
      }
    }
  };

  my.formatInputField = function($field) {
    if ($field.val() !== '') {
      switch ($field.data('type')) {
        case 'money':
          var val = $field.val().replace(/[^0-9.]/g, '') * 1;
          if (val < 0) {
            val = -1 * val;
          }
          $field.val(my.number_format(val));
          break;

        case 'integer':
          $field.val(my.number_format($field.val(), 0));
          break;

        case 'interest':
          if ($field.val() < 0) {
            $field.val(-1 * $field.val());
          }
          $field.val(my.number_format($field.val(), 2));
          break;
        case 'interest-negative':
          $field.val(my.number_format($field.val(), 2));
          break;
      }
    }
  };

  my.bindAutoFormatInputFields = function($scope) {
    //unbind first, just in case
    my.unbindAutoFormatInputFields($scope);

    function formatFields() {
      $scope.find('input').each(function() {
        ADV.util.formatInputField($(this));
      });
    }

    //start off by formatting
    formatFields();

    //format input on change
    $scope.on('change.afif', 'input', function() {
      ADV.util.formatInputField($(this));
    });
  };

  my.unbindAutoFormatInputFields = function($scope) {
    $scope.off('change.afif');
  };

  /**
   * Initializes input boxes with data-type="date".
   * @param $scope
   */
  my.initDatepickerInputs = function($scope) {
    //rome options
    var options = {
      time: false,
      inputFormat: 'MM/DD/YYYY',
    };

    var $inputs = $scope.find('input[data-type="date"]');
    var timeout;

    function initDatePicker($inp) {}

    //iterate through all inputs with data-type="date"
    $inputs.each(function() {
      var $inp = $(this);

      //make sure we don't do this twice
      if ($inp.hasClass('rome-init')) return;

      initDatePicker($inp);
    });
  };

  /**
   * Calls the commonly used input setup functions.
   * @param $scope
   */
  my.setupInputs = function($scope) {
    ADV.util.initSelectsWithDefaultOptions($scope);
    ADV.util.initCustomInputBoxes($scope);
    ADV.util.bindAutoFormatInputFields($scope);
    ADV.util.initDatepickerInputs($scope);
  };

  my.adaptEarmarkMultiSelectFormData = function(values, field) {
    var accountEarmarks = values[field + '[Type]'] || [];
    delete values[field + '[Type]'];
    if (accountEarmarks.length) {
      values[field] = [];
    }

    for (var _i = 0; _i < accountEarmarks.length; _i++) {
      values[field].push({
        Type: accountEarmarks[_i],
      });
    }
    return values;
  };

  my.formatValue = function(value, type) {
    var val = value || value === 0 ? value.toString() : '';
    if (value !== '') {
      switch (type) {
        case 'money':
          val = val.replace(/[^0-9.]/g, '') * 1;
          if (val < 0) {
            val = -1 * val;
          }
          return my.number_format(val);
        case 'integer':
          return my.number_format(val, 0);

        case 'interest':
          if (val < 0) {
            val = -1 * val;
          }
          return my.number_format(val, 2);
        case 'interest-negative':
          return my.number_format(val, 2);
        case 'percentage':
          if (val < 0) {
            val = -1 * val;
          }
          val = my.number_format(val, 2);
          if (+val == Math.trunc(val)) {
            val = Math.trunc(val);
          }
          return `${val}%`;
      }
    } else {
      value = '0';
    }
    return value;
  };

  return my;
})(ADV.util || {});

ADV.util = (function(my) {
  ADV.util.popup = (function() {
    let $popup = null;
    let popupData = null;

    /**
     * Opens a popup (and force closes existing popup).
     * Template provided must also have attribute id="[template name]". For example, if tmpl = "MyTemplate", the
     * template must have attribute id="MyTemplate".
     * @param {string} tmpl
     * @param {object=} data
     */
    function open(tmpl, data) {
      data = data || {};

      close(true);

      popupData = clone(data);

      const $app = $('#app');
      $app.css('overflow', 'hidden'); // prevent body from scrolling
      $app.prepend(`<div id="closerdiv" ${data.class ? `class="${data.class}"` : ''}></div>`);

      setTimeout(function() {
        $app.find('#closerdiv').prependView(tmpl, data, function() {
          $popup = this;

          // get attributes from $popup classes
          const attr = ['custom', 'customRender', 'modal'];
          let i;
          const len = attr.length;
          for (i = 0; i > len; i++) {
            if ($popup.hasClass(attr[i])) {
              popupData[attr[i]] = true;
            }
          }

          // don't bind events for 'custom' popups
          if (!popupData.custom) {
            _bindEvents($app);
          }

          // don't show/position popup for customRender popups
          if (!popupData.customRender) {
            setupPosition();
          }
        });
      }, 50);
    }

    function _bindEvents($app) {
      // overlay click
      if (!popupData.modal) {
        $('body').on('click.popup', '.popup:not(.cannot-close) #closerdiv', close);
      }

      // close/dismiss buttons
      $popup.on('click.popup', '.close, .dismiss', function() {
        close();
        return false;
      });

      // close on ESC
      $app.on('keyup.popup', function(e) {
        if (e.keyCode == 27) {
          // escape key maps to keycode `27`
          close();
        }
      });
    }

    function setupPosition() {
      const $window = $(window);
      $window.off('resize.popup'); // unbind just in case
      setTimeout(function() {
        position();
        // reposition on window resize
        $window.on(
          'resize.popup',
          ADV.util.debounce(function() {
            position(false);
          }, 50),
        );
      }, 20);
    }

    /**
     * Shows alert dialog box.
     * @param message
     * @param button_label //Defaults to {ADV.settings.MsgLib.buttons.default_button_ok}.
     * @param callback //Function called when alert is dismissed. Defaults to empty function.
     */
    function alert(message, button_label, callback) {
      setTimeout(function() {
        button_label = button_label || ADV.settings.MsgLib.buttons.default_button_ok;
        callback = callback || function() {};
        open('alert', {
          message,
          button_label,
          callback,
        });
      }, 50);
    }

    /**
     * Shows confirmation dialog box.
     * @param message
     * @param buttons //Defaults to ['OK','Cancel'].
     * @param callback //Function called with index (starting at 0) of button selected. Defaults to empty function.
     */
    function confirm(message, buttons, callback, extraClass) {
      setTimeout(function() {
        buttons = buttons || [
          ADV.settings.MsgLib.buttons.default_button_ok,
          ADV.settings.MsgLib.buttons.default_button_cancel,
        ];
        callback = callback || function() {};

        // turn buttons into object required by mustache
        if (ADV.util.isEmpty(buttons) || !buttons[0].label) {
          $.each(buttons, function(k, v) {
            buttons[k] = { label: v };
          });
        }

        // go through buttons array and add index.
        $.each(buttons, function(k, v) {
          v.index = k;
        });

        open('confirm', {
          message,
          buttons,
          callback,
          class: extraClass,
        });
      }, 50);
    }

    /**
     * Positions and shows popup.
     * @param {boolean=} focus //true by default
     * @param {boolean=} transition //false by default
     */
    function position(focus, transition) {
      focus = typeof focus === 'undefined' ? true : focus;
      transition = typeof transition === 'undefined' ? false : transition;

      if (transition) {
        $popup.addClass('transition-position');
      }

      $popup.css({
        display: document.body.clientWidth <= 768 ? 'flex' : 'block',
      });

      if (focus) {
        setTimeout(function() {
          // set focus to popup
          $popup.attr('tabindex', '-1');
        }, 100);
      }

      if (transition) {
        setTimeout(function() {
          $popup.removeClass('transition-position');
        }, 205);
      }
    }

    /**
     * Closes the popup.
     * @param {boolean=} force //defaults to false
     */
    function close(force) {
      if (popupData && typeof popupData.onClose === 'function') {
        const res = popupData.onClose();
        if (res || force === true) {
          _tearDown();
        }
      } else {
        _tearDown();
      }
    }

    function _tearDown() {
      const $app = $('#app');
      $app.css('overflow', 'auto'); // allow body to scroll
      if ($popup) {
        $popup.remove();
      }
      $('#closerdiv').remove();
      $app.off('click.popup');
      $app.off('keyup.popup');
      $(window).off('resize.popup');
      $popup = null;
      popupData = null;
    }

    function _setOnClose(callback) {
      if (typeof popupData !== null) {
        popupData.onClose = callback;
      }
    }

    /* RETURN API */

    return {
      open,
      close,
      alert,
      confirm,
      position,
      setupPosition,
      setOnClose: _setOnClose,
    };
  })();

  return my;
})(ADV.util || {});

/* global ADV, routeMatcher */
/*
    eslint-disable
    func-names,
    no-underscore-dangle,
    no-throw-literal,
    camelcase,
    no-restricted-syntax,
    no-prototype-builtins,
    no-param-reassign,
*/

ADV.util.Router = (function() {
  const _my = {
    navigateAwayCallback: null,
    ignoreHashChange: false,
  };

  function _callControllerFromObj(id, params) {
    if (ADV.Controller[id]) {
      ADV.Controller[id].call(undefined, params);
    } else {
      throw `ADV.util.Router: Controller[${id}] does not exist.`;
    }
  }

  /**
   * Returns a hash string from a route ID and parameter map.
   * If id does not exist, throws an Exception.
   * @param id
   * @param params
   * @returns {*|String}
   * @private
   */
  function _getHashFromObj(id, params = {}) {
    const hash = ADV.routes[id];

    if (!hash) {
      throw `Undefined route '${id}'`;
    }

    const rm = routeMatcher(hash.path);

    return {
      path: rm.stringify(params),
      type: hash.type,
      show_plan_selector: hash.has_plan_selection,
    };
  }

  /**
   * Returns an object with the id and params object {id:[String],params:{}} from a hash string.
   * Returns false if no match was found.
   * @param hash
   * @returns {*}
   * @private
   */
  function _getObjFromHash(hash) {
    if (!hash) {
      return false;
    }

    for (const k in ADV.routes) {
      if (ADV.routes.hasOwnProperty(k)) {
        const rm = routeMatcher(ADV.routes[k].path);
        const p = rm.parse(hash);
        const { type, has_plan_selection, skipWrapper = false } = ADV.routes[k];

        if (p !== null) {
          return {
            id: k,
            params: p,
            type,
            has_plan_selection,
            skipWrapper,
          };
        }
      }
    }

    return false;
  }

  /**
   * Calls an HM route via the AdviserArea component.
   * @param id
   * @param params
   * @param show_plan_selector
   */

  function _hm_route(controller, params, show_plan_selector, skipWrapper = false) {
    const event = new CustomEvent('hmroute', {
      detail: {
        controller,
        params,
        show_plan_selector,
        skipWrapper,
        isReactRoute: false,
      },
    });

    document.dispatchEvent(event);
  }

  /**
   * Calls a React route via the AdviserArea component.
   * @param id
   * @param params
   * @param show_plan_selector
   */
  function _react_route(controller, params, show_plan_selector, skipWrapper = false) {
    const event = new CustomEvent('reactroute', {
      detail: {
        controller,
        params,
        show_plan_selector,
        skipWrapper,
        isReactRoute: true,
      },
    });

    document.dispatchEvent(event);
  }

  /**
   * onHashChange event handler.
   */
  function onHashChange() {
    const hash = ADV.util.getHash();
    const o = _getObjFromHash(hash);

    if (o) {
      if (_my.navigateAwayCallback) {
        if (!_my.navigateAwayCallback()) {
          // halt if callback returns false, and go back to the previous route
          _my.ignoreHashChange = true;

          window.history.go(-1);

          return;
        }
      }

      if (_my.ignoreHashChange) {
        // ignore just once, then reset.
        _my.ignoreHashChange = false;

        return;
      }

      switch (o.type) {
        case 'HM':
          _hm_route(o.id, o.params, o.has_plan_selection, o.skipWrapper);
          break;
        case 'React':
          _react_route(o.id, o.params, o.has_plan_selection, o.skipWrapper);
          break;
        default:
      }
    }
  }

  /**
   * Returns an object which represents the current hash.
   * @return {*}
   */
  function status() {
    return _getObjFromHash(ADV.util.getHash());
  }

  async function go2(id, params, doNotRoute /* DO NOT USE THIS */) {
    if (_my.navigateAwayCallback instanceof Function && !(await _my.navigateAwayCallback())) {
      return false;
    }

    const { path } = _getHashFromObj(id, params || {});

    if (doNotRoute) {
      _my.ignoreHashChange = true;
    }

    const previousHash = window.location.hash;
    window.location.hash = path;

    if (previousHash === `#${path}`) {
      return onHashChange();
    }

    return true;
  }

  /**
   * Routes based on current hash. Returns true if a match was found, false otherwise.
   * NavigateAwayCallback is ignored.
   * @return boolean
   */
  function route() {
    const o = status(); // get current hash object.
    if (o) {
      _callControllerFromObj(o.id, o.params);
      return true;
    }
    return false;
  }

  function init() {
    window.onhashchange = onHashChange;
  }

  /**
   * Registers a callback to be called when navigating to a different route.
   * If the callback DOESNT return true, the route change is cancelled.
   * This callback must be unregistered with unregisterNavigateAwayCallback() when
   * no longer needed.
   * @param callback
   */
  function registerNavigateAwayCallback(callback) {
    _my.navigateAwayCallback = callback;
  }

  /**
   * Unregisters the callback.
   */
  function unregisterNavigateAwayCallback() {
    _my.navigateAwayCallback = null;
  }

  init();

  return {
    route,
    status,
    go2,
    registerNavigateAwayCallback,
    unregisterNavigateAwayCallback,
    getRegisteredNavigateAwayCallback() {
      return _my.navigateAwayCallback;
    },
    getObjFromHash: _getObjFromHash,
    getHashFromObj: _getHashFromObj,
  };
})();

ADV.util = (function (my) {

	/**
	 * Returns false if one or more of the modules aren't loaded. Returns
	 * true otherwise.
	 * @param modules //array or string
	 */
	my.isLoaded = function(modules){
		modules = $.isArray(modules) ? modules : [modules];
		window.loaded_resources = window.loaded_resources || {};
		for(var i = 0; i < modules.length; i++){
			if(!window.loaded_resources[modules[i]]){
				return false;
			}
		}
		return true;
	};

	/**
	 * Modular loading system, using LazyLoad. Only loads modules once. All modules must be defined
	 * in ADV.resources object (adv.resources.js).
	 * Ex: ADV.util.require(['foo','bar'], callback);
	 *     ADV.util.require('foo', callback);
	 * @param modules //[array|string] the id of the module, or array of strings
	 * @param callback //called after all of the resources have loaded
	 */
	my.require = function(modules, callback, noRecall){

		modules = $.isArray(modules) ? modules : [modules];

		var timeout = 6000, //6 second timeout
			timeout_error;

		//make sure all of the modules exist
		var i, len = modules.length;
		for(i = 0; i < len; i++){
			if(ADV.util.isEmpty(ADV.resources[modules[i]])){
				throw('"ADV.util.require: ADV.resources.' + modules[i] + '" does not exist.');
			}
		}

		//check to see if already loaded. If they are, call the callback and stop.
		if(ADV.util.isLoaded(modules)){
			if (!noRecall) callback.apply();
			return;
		}

		//show spinner before we begin loading
		var spinner = new ADV.util.Spinner();

		//if timeout is reached, show the 'cannot connect' popup.
		var tobj = setTimeout(function(){
			ADV.util.showCannotConnectErrorPopup();
			timeout_error = true;
		}, timeout);

		//combine all of the JS assets
		var js_assets = modules.reduce(function(prev, cur) {
			return prev.concat(ADV.resources[cur]);
		}, []);

		//load the modules via LazyLoad
		LazyLoad.js(js_assets, function(){
			for(var k in modules){
				window.loaded_resources[modules[k]] = true;
			}
			clearTimeout(tobj);
			spinner.destroy();
			if(timeout_error){
				ADV.util.popup.close(); //clear the timeout error
			}
			callback.apply();
		});
	};


	return my;
})(ADV.util || {});
ADV.util = (function(my) {
  /**
   * Loads templates via GET.
   * @param callback
   */
  my.loadTemplates = function(callback) {
    const spinner = new ADV.util.Spinner();
    $.ajax({
      dataType: 'json',
      url: ADV.settings.endpoints.templates,
      success(resp) {
        HM.add(resp);
        callback.call(this);
      },
      error(httpReq, status, exception) {
        console.log(`AJAX error: ${httpReq}, ${status}, ${exception}`);
        alert(ADV.settings.MsgLib.generic_error);
      },
    }).always(function() {
      spinner.destroy();
    });
  };

  /**
   * Performs an API request to the Advizr server.
   * Parameters: {
   *   uri [string], //required. ex: Adviser/Adviser/GetClients
   *   data [Object], //any data to send to server along with request
   *   showSpinner [bool], //default: true
   *   dataType [string], //default: "json"
   *   type [string], //default: "GET"
   *   onSuccess [Callable], //event handler for success case (resp.success === true),
   *   onFailure [Callable] //event handler for failure case (resp.success === false),
   *   onRequestError [Callable] //event handler for request error
   * }
   *
   * Also accepts any parameters
   * @param opts
   */
  my.request = async function(opts, isAsync) {
    const hookKey = `${opts.method || 'GET'}.${opts.uri}`;
    if (ADV.mocks && ADV.mocks.map && ADV.mocks.map[hookKey]) {
      return ADV.mocks.requestAPIMock(opts, isAsync, ADV.mocks.map[hookKey](opts));
    }
    /** Promise if we need it * */

    /** default event handlers * */

    const default_event_handlers = {
      onSuccess(respData) {}, // does nothing
      onFailure(errors, errorType, respData, reqData) {
        if (!isAsync) {
          // parse error (may be a string, array, or object)
          const errorString = ADV.util.getErrorsHTMLFromResponse(errors);

          if (options.redirectTo500OnFailure) {
            ADV.util.Router.go2('FatalError');
          } else if (options.parsedErrorCallback) {
            options.parsedErrorCallback.call(undefined, errorString);
          } else {
            // ADV.util.popup.alert(errorString);
          }
        }
      },
      onError(httpReq, status, exception) {
        const licenseInUse = 'License in use';

        if (
          httpReq.status === 401 &&
          ADV.util.env('isAdviserArea') &&
          httpReq.getResponseHeader('X-Adv-Reason') === licenseInUse
        ) {
          return window.ADV.adviser.showMultipleSessionWarningModal();
        }

        if (httpReq.status === 401) {
          return ADV.Controller.logout(false, true);
        }

        if (!isAsync) {
          if (!httpReq.getAllResponseHeaders()) {
            // there was no response. Either there is a poor/no internet connection, the server is down,
            // or the user cancelled the request. After a few moments, return an error message.
            setTimeout(function() {
              ADV.util.showCannotConnectErrorPopup();
            }, 500);
            return;
          }

          //do some things based on status code
          switch (httpReq.status) {
            case 402: //redirect to checkout
              var location = ADV.util.Router.status();
              if (location.id !== 'Checkout') {
                ADV.util.Router.go2('Checkout');
              }
              return; // don't call onFailure
            case 403: // incorrect page/unauthorized
              return; // don't call onFailure
            case 503: // Maintenance
              window.location.href = '/Maintenance';
              return; // don't call onFailure
          }

          // call the onFailure event handler
          options.onFailure.call(undefined, ADV.settings.MsgLib.generic_error);
        }
      },
    };

    const headersOptions = () => {
      const baseOptions = {
        xsrf: window.ADV.settings.tokens.xsrf,
      };

      if (window.ADV.settings.tokens.access_token) {
        return {
          ...baseOptions,
          authorization: `Bearer ${window.ADV.settings.tokens.access_token}`,
        };
      }
      return baseOptions;
    };

    /** default options * */

    const headers = {};

    const { xsrf, authorization } = headersOptions();

    const sid = sessionStorage.getItem('sid');

    if (!_.isEmpty(sid)) {
      headers['X-Adv-Sid'] = sid;
    }

    if (!_.isEmpty(xsrf)) {
      headers['X-Xsrf-Token'] = xsrf;
    }

    if (authorization) {
      headers.Authorization = authorization;
    }

    var options = $.extend(
      {
        uri: '',
        urlParams: {},
        showSpinner: true,
        type: 'GET',
        onSuccess: default_event_handlers.onSuccess,
        onFailure: default_event_handlers.onFailure,
        onError: default_event_handlers.onError,
        dataType: 'json', // json or html
        data: {},
        sendStringifyJSON: false, // if true, sends {[sendJSONParam]: JSON.stringify(options.data)}
        sendStringifyJSONParam: 'json',
        xhrFields: { withCredentials: true },
        redirectTo500OnFailure: false,
        parsedErrorCallback: null, // if this is provided, and there are validation errors, this callback is called with HTML
        // instead of shown in a popup (the default)
        doNotExtendSession: false,
        headers,
      },
      opts,
    );

    /** create the request * */

    if (options.uri.indexOf('?') > -1) {
      options.uri += '&';
    } else {
      options.uri += '?';
    }

    options.urlParams.cb = new Date().getTime();

    if (ADV.data.cx) {
      options.urlParams.cx = true;
    }

    if (ADV.data.oid) {
      options.urlParams.oid = encodeURIComponent(ADV.data.oid);
    }

    if (ADV.cobrowsingOperator) {
      options.urlParams.cobrowsingOperator = ADV.cobrowsingOperator;
    }

    Object.keys(options.urlParams).forEach(function(key) {
      options.uri += `${key}=${options.urlParams[key]}&`;
    });

    if (options.uri.slice(-1) === '&') {
      options.uri = options.uri.substr(0, options.uri.length - 1);
    }

    // show loader
    let spinner;
    if (options.showSpinner) {
      spinner = new ADV.util.Spinner();
    }

    // convert data to stringified JSON
    if (options.sendStringifyJSON) {
      const data = {};
      data[options.sendStringifyJSONParam] = JSON.stringify(options.data);
      options.data = data;
    }

    // prepare parameters for $.ajax
    const ajax_params = $.extend(
      {
        url: ADV.settings.endpoints.api + options.uri,
        success(resp) {
          let response_data = {};
          const request_data = options.data;

          // due to the way the backend is coded, we have to manually combine these two response parameters
          if (resp && resp.payload) {
            response_data = $.extend(resp.payload.viewData, resp.payload.extensions);
          }

          if (resp && resp.success) {
            options.onSuccess.call(undefined, response_data);
          } else if (resp) {
            options.onFailure.call(
              undefined,
              resp.errors,
              resp.errorType,
              response_data,
              request_data,
            );
          }
        },
        error: options.onError,
      },
      options,
    );

    /** send the request * */

    return new Promise(function(resolve, reject) {
      const finalize = { success: true, param: null };
      $.ajax(ajax_params)
        .done(function(resolved, __, xhr) {
          if (xhr.getResponseHeader('X-Slided') === '1' && !options.doNotExtendSession) {
            ADV.util.SessionTimeout.extendTimer();
          }

          const sidRenewToken = xhr.getResponseHeader('X-Adv-Sid-Renew');
          const xsrfRenewToken = xhr.getResponseHeader('X-Xsrf-Token-Renew');

          if (!_.isEmpty(sidRenewToken)) {
            sessionStorage.setItem('sid', sidRenewToken);
          }

          if (!_.isEmpty(xsrfRenewToken)) {
            sessionStorage.setItem('xsrf', xsrfRenewToken);
          }

          finalize.success = true;
          finalize.param = resolved;
        })
        .fail(function(xhr, status, error) {
          finalize.success = false;
          finalize.param = (xhr && xhr.status) || status;
          default_event_handlers.onError(xhr, status, error);
        })
        .always(function() {
          if (spinner) {
            spinner.destroy();
          }
          if (finalize.success) {
            resolve(finalize.param);
          } else {
            reject(finalize.param);
          }
        });
    });
  };

  my.redirectToLoginPage = function(noRedirect, timeout) {
    if (ADV.settings.endpoints.logOutRedirectUrl) {
      location.href = ADV.settings.endpoints.logOutRedirectUrl;
    } else {
      const query = { action: 'logout' };

      if (timeout) {
        query.timeout = '1';
      }

      if (!noRedirect && my.getHash()) {
        query.returnurl = `#${my.getHash()}`;
      }

      const queryString = Object.entries(query)
        .map(([k, v]) => `${k}=${v}`)
        .join('&');

      location.href = `${ADV.settings.endpoints.api}?${queryString}`;
    }
  };

  (my.showCannotConnectErrorPopup = function() {
    ADV.util.popup.confirm(
      ADV.settings.MsgLib.cannot_connect,
      [{ label: 'Reload Page' }, { label: 'Cancel', classes: 'secondary' }],
      function(choice) {
        if (choice === 0) {
          window.location.reload();
        }
      },
    );
  }),
    (my.downloadPDF = function(
      clientId,
      fpId,
      beforeDownload,
      whenTimeoutExpires,
      method,
      jsonString,
      pdfBool,
    ) {
      beforeDownload = beforeDownload || function() {};
      whenTimeoutExpires = whenTimeoutExpires || function() {};
      method = method || 'GET';
      jsonString = jsonString || null;
      pdfBool = pdfBool == null ? true : pdfBool;
      beforeDownload();
      const form = document.createElement('form');
      let json;
      let clientIdInput;
      let fpIdInput;
      const pdf = document.createElement('input');
      let queryString = '';
      let csrfInput;

      form.method = method;
      form.style.display = 'none';

      if (method == 'POST') {
        queryString = `?clientId=${clientId}&fpId=${fpId}`;
      } else {
        clientIdInput = document.createElement('input');
        clientIdInput.name = 'clientId';
        clientIdInput.value = clientId;
        form.appendChild(clientIdInput);

        fpIdInput = document.createElement('input');
        fpIdInput.name = 'fpId';
        fpIdInput.value = fpId;
        form.appendChild(fpIdInput);
      }

      pdf.name = 'pdf';
      pdf.value = pdfBool.toString();
      form.appendChild(pdf);

      if (jsonString !== null) {
        json = document.createElement('input');
        json.name = 'json';
        json.value = jsonString;
        form.appendChild(json);
      }
      const iframe = document.createElement('iframe');
      iframe.name = `download_pdf`;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      csrfInput = document.createElement('input');
      csrfInput.name = '__RequestVerificationToken';
      csrfInput.value = ADV.settings.tokens.xsrf;
      form.appendChild(csrfInput);

      form.target = `download_pdf`;
      form.action = `/Consumer/Print${queryString}`;
      iframe.appendChild(form);
      form.submit();
      setTimeout(whenTimeoutExpires, 14000);
    });

  return my;
})(ADV.util || {});

ADV.util = (function (util) {
	util.chart = (function(chart){

		/**
		 * Expects an array of Asset Allocation series data, like follows:
		 * [
		 *   "name": "Cash",
		 *   "y": 0.21,
		 *   "color_group": 0 //will use colors from group 0
		 * ],
		 * [
		 *   "name": "Large Cap Equity",
		 *   "y": 0.44,
		 *   "color_group": 1 //will use colors from group 0
		 * ]
		 *
		 * Returns:
		 * {
		 *   Series: [...],
		 *   Labels: [...]
		 * }
		 *
		 * @param allocation_series
		 *
		 */
		chart.parseAllocationSeries = function(allocation_series){

			var color_groups = ADV.settings.color_groups,
				next_color = [],
				i,
				Series = clone(allocation_series),
				Labels = [];

			//set up next color array
			for(i = 0; i < color_groups.length; i++){
				next_color.push(0);
			}

			$.each(allocation_series, function(k,v){

				var color = color_groups[v.color_group][next_color[v.color_group]];
				if(!color){
					color = color_groups[3][next_color[v.color_group] % color_groups[v.color_group].length];
				}

				Series[k].color = v.color || color;

				Labels.push({
					index: k,
					label: v.name,
					value: v.y,
					color: Series[k].color,
					color_group: v.color_group,
					primary: (next_color[v.color_group] == 0),
					inactive: v.y <= 0
				});

				next_color[v.color_group]++;
			});

			return {
				Series: Series,
				Labels: Labels
			};
		};

		return chart;
	})(util.chart || {});
	return util;
})(ADV.util || {});

ADV.util = (function (my) {

    my.pages = (function(){

        function buildPagination(page, pageCount) {
            if (!!pageCount) {
                var pages = [],
                    offsetPage = page - 1,
                    arrayLength = pageCount - 1,
                    pagesToDisplay = 10,
                    halfPages = Math.floor(pagesToDisplay / 2);
                if (pageCount < 10) {
                    return Array.apply(null, Array(pageCount)).map(function (x, i) {
                        // Builds an array based on the total page count
                        var adjustedIndex = i + 1;
                        return {
                            Page: adjustedIndex,
                            Selected: page == adjustedIndex
                        };
                    });
                }

                var i = offsetPage - halfPages > -1 ? offsetPage - halfPages : 0,
                    l;

                if (offsetPage + halfPages - 1 >= arrayLength) {
                    l = arrayLength;
                    i = l - pagesToDisplay + 1; //offset for array indexes
                } else if (offsetPage <= 5) {
                    l = pagesToDisplay - 1; //offset for array indexes
                } else {
                    l = offsetPage + halfPages + (offsetPage <= halfPages ? offsetPage : 0);
                }

                for (;
                    i <= l;
                    i++) {
                    var adjustedIndex = i + 1;
                    pages.push({
                        Page: adjustedIndex,
                        Selected: page == adjustedIndex
                    });
                }

                if (pages[pagesToDisplay - 1].Page < arrayLength - 1) {
                    pages.splice(pagesToDisplay - 1, 2, {Page: '...', Selected: false, NoClick: true}, {
                        Page: pageCount,
                        Selected: false
                    });
                }

                if (pages[0].Page >= 2) {
                    pages.splice(0, 2, {Page: 1, Selected: false}, {Page: '...', Selected: false, NoClick: true});
                }

                return pages;
            } else {
                return {Pages: [1], Selected: false}
            }
        }

        /* RETURN API */

        return {
            buildPages: buildPagination
        };

    })();

    return my;
})(ADV.util || {});
/*************************************************************************
 * Helpful jquery plugins
 *************************************************************************/

(function($){

    "use strict";

    /**
     * Checks to see if an element is overflowing it's bounds.
     * @return {Boolean}
     */
    $.fn.isOverflowing = function(){
        var el = $(this).get(0);
        var curOverflow = el.style.overflow;
        if ( !curOverflow || curOverflow === "visible" ){
            el.style.overflow = 'hidden';
        }
        var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

        el.style.overflow = curOverflow;

        return isOverflowing;
    };


    /**
     * Returns a string representing the input type. If it's not an input, it returns the tag name of the element.
     * @return {*}
     */
    $.fn.getInputType = function () {
        return this[0].tagName.toString().toLowerCase() === "input" ?
            $(this[0]).prop("type").toLowerCase() :
            this[0].tagName.toLowerCase();
    };


    /**
     * Serialize form fields into JSON
     * @return {*}
     */
    $.fn.serializeJSON = function(){
        var json = {};
        var form = $(this);
        form.find('input, select, textarea').each(function(){
            var val;
            if (!this.name) return;
            if ('radio' === this.type) {
                if (json[this.name]) { return; }
                json[this.name] = this.checked ? this.value : '';
            } else if ('checkbox' === this.type) {
                val = json[this.name];
                if (!this.checked) {
                    if (!val) { json[this.name] = ''; }
                } else {
                    json[this.name] =
                        typeof val === 'string' ? [val, this.value] :
                            $.isArray(val) ? $.merge(val, [this.value]) :
                                this.value;
                }
            } else if ('select-multiple' == this.type) {
	            var selectedOptions = [],
		            i;
	            if(!this.options) return;
	            if(this.selectedOptions){
		            // HTML5
		            for(i = 0; i < this.selectedOptions.length; i++){
			            selectedOptions.push(this.selectedOptions[i].value);
		            }
	            } else {
		            // non-HTML5
		            for(i = 0; i < this.options.length; i++) {
			            if(this.options[i].selected) {
				            selectedOptions.push(this.options[i].value);
			            }
		            }
	            }
	            json[this.name] = selectedOptions;
            } else {
                json[this.name] = this.value;
            }
        });
        return json;
    };

    /**
     * Converts an object into an array.
     * @return {*}
     */
    $.fn.serializeObject = function(){
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

})(jQuery);
/* global ADV, _ */

ADV.Controller = ADV.Controller || {};

/**
 * For Adviser area, routes to either the Client Start page, or the Financial Plan, depending
 * on the state of the client.
 * @param clientId
 */
ADV.Controller.Go2AdviserArea = function() {
  window.location = '/Adviser/Adviser';
};

ADV.Controller.Go2AdminArea = function() {
  window.location = '/Admin/NewMain';
};

/**
 * @route overview/:clientId
 * @param data
 */
ADV.Controller.ConsumerOverview = function(data) {
  data.endpoint = ADV.settings.endpoints.api;

  ADV.util.showModule(
    'ConsumerOverview',
    $.extend(
      {
        endpoint: ADV.settings.endpoints.api,
      },
      data,
    ),
  );
};

ADV.Controller.logout = function(no_redirect, timeout) {
  // clear session storage
  sessionStorage.clear();

  const temp = {};
  const permanent = 'permanent-';
  Object.keys(localStorage).forEach(key => {
    if (key.substr(0, permanent.length) === permanent) {
      temp[key] = localStorage.getItem(key);
    }
  });

  localStorage.clear();

  Object.keys(temp).forEach(key => {
    localStorage.setItem(key, temp[key]);
  });

  const logoutMask = document.createElement('div');

  logoutMask.style = `
        position: fixed;
        background: white;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2147483647;
      `;

  document.body.appendChild(logoutMask);

  // fetch data from backend
  ADV.util.request({
    uri: 'Session/LogOff',
    onSuccess() {
      ADV.util.redirectToLoginPage(!!no_redirect, !!timeout);
    },
  });
};

// Used on Consumer area
ADV.Controller.Feedback = function(helpText) {
  ADV.util.popup.open('Feedback', {
    HelpText: helpText,
    HasHelpText: !!helpText,
    resourceCenterUrl: `${ADV.info.resourceCenterUrl}financial-planning`,
  });
};

// Used on Consumer area
ADV.Controller.Help = function() {
  const data = $.extend(ADV.Help ? ADV.Help : {}, {
    sample_clients: ADV.entities.getSampleClients(),
    client: ADV.util.env('isAdviserArea') ? ADV.entities.getCurrentClient() : ADV.data.user,
    demo_uri: ADV.settings.endpoints.demo,
    resourceCenterUrl: `${ADV.info.resourceCenterUrl}financial-planning`,
  });

  // pre-render description
  data.description = Mustache.render(data.description, data);

  ADV.util.popup.open('Help', data);
};

ADV.Controller = ADV.Controller || {};

/**
 * @route workflow/:workflowId/:pageId/:clientId/:pivotId
 */
ADV.Controller.Workflow = function(data){
	ADV.util.require('profile', function(){
		ADV.util.showModule('Workflow', data);
	});
};

/**
 * @route profile/:pageId/:clientId/:pivotId
 */
ADV.Controller.Profile = function(data){
	ADV.util.require('profile', function(){
		ADV.util.showModule('Profile', data);
	});
};

ADV.Controller.ProfileLifeInsurance = function(data) {
    ADV.util.require('profile', function(){
        ADV.util.showModule('Profile', Object.assign({}, data, {pageId: 'lifeinsurance'}));
    });
}

ADV.Controller.ProfileExpenses = function(data) {
    ADV.util.require('profile', function(){
        ADV.util.showModule('Profile', Object.assign({}, data, {pageId: 'expenses'}));
    });
}

ADV.Controller.Profile_RequestAddInstitution = function(data){
	ADV.util.require('profile', function(){
		ADV.util.popup.open('Profile_RequestAddInstitution', {
			InstitutionName: data.InstitutionName,
			clientId: data.clientId
		});
	});
};

ADV.Controller = (function(my){

    /**
     * @route Checkout
     */
    my.Checkout = function(){

        var SUBSCRIPTION_NONE = 0,
            SUBSCRIPTION_TRIAL = 1,
            SUBSCRIPTION_ACTIVE = 2,
            SUBSCRIPTION_EXPIRED = 3;

        var subscription;

         ADV.util.request({
             uri: 'Adviser/Subscription/GetSubscription',
             onSuccess: function(resp){
                 subscription = resp;
                 doAction();
             }
         });

        function doAction(){
            switch(subscription.SubscriptionType){
                case SUBSCRIPTION_NONE:
                case SUBSCRIPTION_EXPIRED:

                    subscription.Expired = subscription.SubscriptionType == SUBSCRIPTION_EXPIRED;
                    ADV.util.require('checkout', function(){
                        if (subscription.IsFrictionless) {
                          ADV.util.showModule('CheckoutFrictionless', subscription);
                        } else {
                          ADV.util.showModule('Checkout', subscription);
                        }
                    });
                    break;

                case SUBSCRIPTION_TRIAL:
                case SUBSCRIPTION_ACTIVE:

                    ADV.util.Router.go2('FatalError');
            }
        }
    };

    return my;
})(ADV.Controller || {});
ADV.Controller = (function(my){

    /**
     * @route express/:action/:goalId/:questionId
     */
    my.ExpressWizard = function(params){

        //recover ExpressWizard data from sessionStorage
        if(!ADV.ExpressWizard && sessionStorage && sessionStorage.getItem('ExpressWizard')){
            ADV.ExpressWizard = JSON.parse(sessionStorage.getItem('ExpressWizard'));
        }

        var data = $.extend(params, {
            img_dir: ADV.settings.endpoints.imgDir,
            Values: ADV.ExpressWizard
        });

        //create module ID
        var module = 'ExpressWizard_' + params.action + '_' + params.goalId;

        if(!HM.exists(module)) {
            //go to the Retirement Input page
            module = 'ExpressWizard_Input_Retirement';
        }

        ADV.util.require('express_wizard_hm', function(){
            ADV.util.showModule(module, data);
        });

    };

    return my;
})(ADV.Controller || {});
var ADV = (function(adv){
    adv.Tooltips = (function(){

        /**
         * Shows a tooltip represented by obj.
         * @param obj
         */
        function showTip(obj){
            //check for required properties
            if(ADV.util.isEmpty(obj)){
                throw("ADV.Tooltips: obj is required.");
            }
            if(ADV.util.isEmpty(obj.target)){
                throw("ADV.Tooltips: obj.target is required.");
            }
            if(ADV.util.isEmpty(obj.html)){
                throw("ADV.Tooltips: obj.html is required.");
            }

            //defaults
            obj.orientation = obj.orientation || 'top';

            $('#Tooltip').remove();

            //pre callback (before show)
            if(obj.pre && typeof obj.pre === 'function'){
                obj.pre.call(undefined, function(){
                    $('body').appendView('Tooltip', obj);
                })
            } else {
                $('body').appendView('Tooltip', obj);
            }
        }

        /**
         * Hides any shown tooltips.
         */
        function hideTip(){
            $('body').off('click.tip');
            $('#Tooltip').remove();
        }

       function bindCallouts($scope, callout_obj){
            if (!($scope instanceof jQuery)) $scope = $($scope)
            
            function show($this){
                var obj = clone(callout_obj[$this.data('callout')]);
                obj.target = $this;
                obj.classes = obj.classes || ''; obj.classes += ' callout-open';

                //overrides from $this
                if(!ADV.util.isEmpty($this.data('callout-params'))){
                    obj = $.extend(obj, $this.data('callout-params'), true);
                }

                showTip(obj);
            }

            $scope.find('[data-callout]').each(function(){
                var $this = $(this);
                if(!$this.hasClass('callout-init')){ //if not already init'd
                    //ignore if key is not present
                    if(!callout_obj[$this.data('callout')]) return;

                    //mouse devices
                    $this.on('mouseenter', function(){
                        if ($scope.find('#Tooltip').length) return
                        show($this);
                    }).on('mouseleave', function(){
                        if($('.callout-open').length){
                            hideTip();
                        }
                    });

                    //touch devices
                    $this.on('click', function(e){
	                    var callout = callout_obj[$this.data('callout')] || {};
	                    if($this.data('data-callout-hoveronly') || callout.hoverOnly) return; //only works on hover (disables for touch devices)
	                    e.stopPropagation();
                        hideTip();
                        show($this);
                        //hide on $scope click
                        $scope.on('click.calloutclose', function(){
                            if($('.callout-open').length){
                                hideTip();
                            }
                            $scope.off('click.calloutclose');
                        });
                    });

                    $this.addClass('callout-init');
                }
            });

        }

        /*** reveal api ***/

        return {
            showTip: showTip,
            hideTip: hideTip,
            bindCallouts: bindCallouts
        };

    })();
    return adv;
})(ADV || {});
HM.ViewHelper = (function(helpers){

    helpers.alert = function($scope, data){

        $scope.on('click', 'button', function(e){
            e.preventDefault();
            ADV.util.popup.close();
	        if(typeof data.callback == 'function'){
		        data.callback.apply();
	        }
        });

    };

    return helpers;
})(HM.ViewHelper || {});
HM.ViewHelper = (function(helpers){

    helpers.confirm = function($scope, data){

        $scope.on('click', 'button', function(e){
            e.preventDefault();
            ADV.util.popup.close();
	        if(typeof data.callback == 'function'){
		        data.callback.call(undefined, $(this).data('index'));
	        }
        });

    };

    return helpers;
})(HM.ViewHelper || {});
HM.ViewHelper = (function(helpers) {
  helpers.Help = function($scope, data) {
    ADV.util.setupInputs($scope);

    const $form = $scope.find('.adv-form');

    $form.on('submit', ev => {
      const query = $form.find('#term').val();

      window.open(
        `${ADV.info.resourceCenterUrl}global-search/${encodeURIComponent(query)}`,
        '_blank',
      );
      ev.preventDefault();
    });

    // remove target="_blank" if iOS, since popups are now disabled by default
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
      $scope.find('form').removeAttr('target');
    }
  };

  return helpers;
})(HM.ViewHelper || {});

/* eslint-disable */

HM.ViewHelper = (function(helpers) {
  helpers.Feedback = function($scope, data) {
    
    $scope.find('.submit').on('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();

      ADV.util.request({
        type: 'POST',
        uri: 'Adviser/UserFeedback/Save',
        data: {
          origin: JSON.stringify(ADV.util.Router.status()),
          message: $scope.find('textarea').val(),
        },
        onSuccess: function() {
          ADV.util.popup.alert('Your message has been sent. Thank you for your feedback.');
        },
      });
    });
  };

  return helpers;
})(HM.ViewHelper || {});

HM.ViewHelper = (function(helpers){

    helpers.ErrorBubble = function($scope, data){

        //close button
        $scope.on('click', '.close', function(e){
            e.preventDefault();
            e.stopPropagation();
            $scope.slideUp(200);
        });

        //open
	    data.animate = (typeof data.animate == "undefined" ? true : data.animate);
	    if(data.animate){
		    $scope.slideDown(200);
	    } else {
		    $scope.css('display','block');
	    }

        //make sure it's in viewport
        setTimeout(function(){
            var offset_top = $scope.offset().top - 70;
            if($(window).scrollTop() >= offset_top){
                ADV.util.scrollTo(offset_top);
            }
        }, 300);

    };

    return helpers;
})(HM.ViewHelper || {});
HM.ViewHelper = (function(helpers){

    helpers.Tooltip = function($scope, data){

        var $body = $('body'),
            position_top = 0,
            position_extra_room = 100;


        //prevent clicks in box closing the tooltip
        $scope.on('click', function(e){
            e.stopPropagation();
        });

        //handle clicks on 'close' icon
        $scope.on('click', '.close, .btn-done', function(e){
            e.preventDefault();
            ADV.Tooltips.hideTip();
        });

        //clicks outside tip closes tip
        $body.off('click.tip');
        $body.on('click.tip', function(){
            ADV.Tooltips.hideTip();
        });

        //'next' and 'ok, got it' buttons for tours
        if(data.tour){
            $scope.on('click', 'button', function(){
                var step_index = $(this).data('step'), next_btn, done_btn;
                if(step_index < data.tour.steps.length - 1){
                    next_btn = step_index + 1;
                } else {
                    done_btn = true;
                }
                var obj = $.extend(data.tour.steps[step_index], {
                    next: next_btn,
                    done: done_btn,
                    tour: data.tour
                }, true);
                ADV.Tooltips.showTip(obj);
            });
        }

        //position and show
        setTimeout(function(){
            positionTooltip();

            //if a custom show function (data.custom_show_function) is provided, run that instead. It will be responsible for showing the popup, and scrolling
            //to its position.
            if(data.custom_show_function){
                data.custom_show_function.call($scope, data);
            } else {
                scrollToAndShow();
            }
        }, 20);

        //automatic timeout. when timeout is up, automatically hide tip.
        if(data.timeout){
            setTimeout(function(){
                //if scope still exists, hide tooltip
                if($scope.closest('body').length > 0){
                    ADV.Tooltips.hideTip();
                }
            }, data.timeout);
        }

        /**
         * Positions the tooltip. Orientation (data.orientation) can be the following values: top, left, bottom, bottomleft, right,
         * and custom. If 'custom', no automatic positioning is done. If custom, positioning can be done either by using
         * data.inline_styles, or providing a callback by using data.post.
         */
        function positionTooltip(){

            var $target = data.target instanceof jQuery ? data.target : $(data.target);
            if(!$target.length) throw("ADV.Tooltips: obj.target (" + data.target + ") returns an empty result.");
            $target = $target.first();

            var target_offset = $target.offset();

            if(data.position === 'fixed'){
                target_offset.top -= $(window).scrollTop();
            }

            var target_dim = {
                width: $target.outerWidth(),
                height: $target.outerHeight()
            };
            var scope_dim = {
                width: $scope.outerWidth(),
                height: $scope.outerHeight()
            };

            switch(data.orientation){
                case 'left':
                    position_top = target_offset.top;
                    $scope.css({
                        top: position_top,
                        left: target_offset.left - scope_dim.width
                    });
                    $scope.addClass('orientation-left');
                    break;
                case 'top':
                    position_top = target_offset.top - scope_dim.height;
                    $scope.css({
                        top: position_top,
                        left: target_offset.left
                    });
                    $scope.addClass('orientation-top');
                    break;
                case 'right':
                    position_top = target_offset.top;
                    $scope.css({
                        top: position_top,
                        left: target_offset.left + target_dim.width
                    });
                    $scope.addClass('orientation-right');
                    break;
                case 'bottom':
                    position_top = target_offset.top + target_dim.height;
                    $scope.css({
                        top: position_top,
                        left: target_offset.left
                    });
                    $scope.addClass('orientation-bottom');
                    break;
                case 'bottomleft':
                    position_top = target_offset.top + target_dim.height;
                    $scope.css({
                        top: position_top,
                        left: target_offset.left - scope_dim.width
                    });
                    $scope.addClass('orientation-bottomleft');
                    break;
                case 'custom':
                    //do nothing
                    break;
            }

        }

        function scrollToAndShow(){

            //if position:fixed, just show. don't autoscroll
            if(data.position === 'fixed'){
                $scope.css('position', 'fixed');
                $scope.css('display', 'block'); //show tooltip
                return;
            }

            //if this is a callout, just show. don't autoscroll
            if($scope.hasClass('callout-open')){
                $scope.css('display', 'block'); //show tooltip
                return;
            }

            //position to tip, if off screen
            //scroll to tip before showing
            if(!isTipOnScreen()){
                ADV.util.scrollTo(position_top - position_extra_room, 500);
                setTimeout(function(){
                    $scope.css('display', 'block'); //show tooltip
                }, 600);
            } else {
                $scope.css('display', 'block'); //show tooltip
            }

            //callback after render (post)
            if(data.post){
                data.post.apply(this);
            }
        }

        function isTipOnScreen(){
            var viewport = {};
            viewport.top = $(window).scrollTop();
            viewport.bottom = viewport.top + $(window).height();
            var bounds = {};
            bounds.top = position_top;
            bounds.bottom = bounds.top + $scope.outerHeight();
            //if we're already at top, and tooltip is on screen, return true.
            if(position_top - position_extra_room < 0 && viewport.top < 5){
                return true;
            }
            return ((bounds.top - position_extra_room >= viewport.top) && (bounds.bottom + position_extra_room <= viewport.bottom));
        }

    };

    return helpers;
})(HM.ViewHelper || {});
ADV.PortfolioWidget = (function(){

    function open(Series, Labels, Title, HypotheticalReturn, ShowHypotheticalReturn, onChange){
	    ADV.util.popup.open('PortfolioWidget_Editable', {
		    onChange: onChange,
		    Series: Series,
		    Labels: Labels,
			HypotheticalReturn: HypotheticalReturn,
			ShowHypotheticalReturn: ShowHypotheticalReturn,
		    Title: Title || "Choose an asset allocation.",
		    format_percentage: function(){
			    return function(text, render) {
				    return ADV.util.number_format(render(text) * 100);
			    }
		    }
	    });
    }

	function openReadOnly(Series, Labels, Title, HypotheticalReturn){
		ADV.util.popup.open('PortfolioWidget', {
			Labels: Labels,
			Series: Series,
			Title: Title,
			HypotheticalReturn: HypotheticalReturn,
			format_percentage: function(){
				return function(text, render) {
					return ADV.util.number_format(render(text) * 100, 1);
				}
			}
		});
	}

	function openAccountPortfolio(accountId, clientId, onSaveSuccess){

		function _onSuccess(){
			//call callback
			if(typeof onSaveSuccess === 'function'){
				onSaveSuccess.apply(this);
			}
			//close popup
			close();
		}

		function _saveChanges(AssetAllocation, HypotheticalReturn){

			//send to server
			ADV.util.request({
				uri: 'Consumer/AccountPortfolioUpdate/Save',
				onSuccess: _onSuccess,
				data: {
					AccountId: accountId,
					AssetAllocation: AssetAllocation,
					HypotheticalReturn: HypotheticalReturn,
					clientId: clientId
				},
				sendStringifyJSON: true,
				type:'POST'
			});
		}

		//fetch data from server
		ADV.util.request({
			type: 'GET',
			uri: 'Consumer/AccountPortfolio',
			data: {
				accountId: accountId,
				clientId: clientId
			},
			onSuccess: function(resp){

				if(!$.isArray(resp.AssetAllocation) || !resp.AssetAllocation.length){
					throw('No asset allocation fields are assigned for this portfolio!');
				}

				//format response data
				var AllocationData = ADV.util.chart.parseAllocationSeries(resp.AssetAllocation);

				open(AllocationData.Series, 
					AllocationData.Labels, 
					null, 
					resp.HypotheticalReturn, 
					resp.ShowHypotheticalReturn, 
					_saveChanges);
			}
		});
	}

    function close(){
        ADV.util.popup.close();
    }

    return {
        open: open, //editable
	    openReadOnly: openReadOnly,
	    openAccountPortfolio: openAccountPortfolio,
        close: close
    };

})();
HM.ViewHelper = (function(helpers){

    helpers.PortfolioWidget = function($scope, data){

        var $chart = $scope.find('.chart');

        function init(){
            setTimeout(_renderChart, 200);
	        _bindEvents();
        }

	    function _bindEvents(){
		    //select item when hovering on the label
		    // (delay it, otherwise it could mess up the rendering of the chart, due to HC bug)
		    setTimeout(function(){
			    $scope.on("mouseenter", ".labels li", function() {
				    var $this = $(this),
					    index = $this.data("index");
				    $this.addClass('highlighted');
				    $chart.highcharts().series[0].data[index].setState('hover');
			    }).on("mouseleave", ".labels li", function(){
				    var $this = $(this),
					    index = $this.data("index");
				    $this.removeClass('highlighted');
				    $chart.highcharts().series[0].data[index].setState('');
			    });

			    //also enable click event, for touch devices
			    $scope.on("click", ".labels li", function() {

				    //un-highlight others
				    $scope.find('.labels li').each(function(){
					    var $this = $(this),
						    index = $this.data("index");
					    $this.removeClass('highlighted');
					    $chart.highcharts().series[0].data[index].setState('');
				    });

				    var $this = $(this),
					    index = $this.data("index");
				    $this.addClass('highlighted');
				    $chart.highcharts().series[0].data[index].setState('hover');
			    });
		    }, 700);
	    }

	    function _renderChart(){

		    //create chart obj to send to HighCharts
		    var hc_params = clone(ADV.ChartDescriptors.AssetAllocationPortfolioWidget); //clone so we don't alter it

		    hc_params.series[0].data = data.Series;
		    hc_params.chart.renderTo = $chart[0];

		    //highlighting
		    hc_params.plotOptions.pie.point.events.mouseOver = function(e) {
			    var label = this.name,
				    value = ADV.util.number_format(this.y * 100, 1) + '%';
			    $scope.find(".labels li:contains('"+ label +"'):contains('"+ value +"')").addClass('highlighted');
		    };
		    hc_params.plotOptions.pie.point.events.mouseOut = function(e) {
			    var label = this.name,
				    value = ADV.util.number_format(this.y * 100, 1) + '%';
			    $scope.find(".labels li:contains('"+ label +"'):contains('"+ value +"')").removeClass('highlighted');
		    };

		    //hover
		    hc_params.plotOptions.series.states.hover.enabled = true;

		    //render chart!
		    new Highcharts.Chart(hc_params);
	    }

        init();


    };

    return helpers;
})(HM.ViewHelper || {});
HM.ViewHelper = (function (helpers) {

    helpers.PortfolioWidget_Editable = function ($scope, data) {

        var $chart = $scope.find('.chart'),
            $submit = $scope.find('button.save'),
            disableSave = false;

        function _init() {
            ADV.util.setupInputs($scope);
            setTimeout(_renderChart, 200);
            _bindEvents();
        }

        function _getTotal() {
            var tot = 0;
            $.each(data.Series, function (k, v) {
                tot += v.y;
            });
            return Math.round(tot * 100);
        }

        function _bindEvents() {

            //update on input change
            $scope.on('change', '.labels input', function () {
                var $this = $(this),
                    val = parseInt(ADV.util.number_format($this.val()));
                if (val > 100) val = 100; //max is 100
                $this.val(val);
                data.Series[$this.parents('li').first().data('index')].y = ADV.util.number_format(val / 100, 2, '.', '') * 1;
                _updateTotalLabel(_getTotal());
                _renderChart();
            });

            $scope.on('click', 'button.save', function (e) {
                $scope.find('input').blur(); //fire blur event handlers
                if(disableSave) return false;
                e.stopPropagation();
                setTimeout(_saveChanges, 100); //give it a chance for input.change event to fire
            });

            $scope.on('blur', '#hypothetical_return', function () {
                var $this = $(this),
                    val = parseInt(Math.ceil($this.val()));
                if (val > 12) {
                    _handleError('.hypothetical', true);
                } else {
                    _handleError('.hypothetical', false);
                }
            });

            //focus/blur handlers for inputs
            $scope.find('input').on('focus', function () {
                $(this).parent().addClass('focus');
            });
            $scope.find('input').on('blur', function () {
                $(this).parent().removeClass('focus');
            });
            $scope.find('.input').on('click', function () {
                $(this).find('input').focus();
            });
        }

        function _updateTotalLabel(val) {
            //update total
            $scope.find('.tip.total').html('Total: ' + val + '%');

            //if total != 100, disable button and show error
            if (val != 100) {
                _handleError('.total', true);
            } else {
                _handleError('.total', false);
            }
        }
        
        function _handleError(className, show) {
            var tip = $scope.find('.tip.error'),
                errorType = tip.find(className);
            if (show) {
                tip.show();
                errorType.show();
                $submit.addClass('disabled');
                disableSave = true;
            } else {
                errorType.hide();
                if (tip.children('li:visible').length === 0) {
                    tip.hide();
                }
                $submit.removeClass('disabled');
                disableSave = false;
            }
        }

        function _renderChart() {

            //render chart!
            var hc = $chart.data('hc');
            if (hc) {
                //already rendered, call setData instead
                hc.series[0].setData(data.Series.map(function(serie) { return {name: serie.name, y: serie.y}}), true);
                hc.redraw()
            } else {
                //create chart obj to send to HighCharts
                var hc_params = clone(ADV.ChartDescriptors.AssetAllocationPortfolioWidget); //clone so we don't alter it

                hc_params.series[0].data = data.Series;
                hc_params.chart.renderTo = $chart[0];

                //highlighting
                hc_params.plotOptions.pie.point.events.mouseOver = function (e) {
                    var label = this.name,
                        value = ADV.util.number_format(this.y * 100, 1) + '%';
                    $scope.find(".labels li:contains('" + label + "'):contains('" + value + "')").addClass('highlighted');
                };
                hc_params.plotOptions.pie.point.events.mouseOut = function (e) {
                    var label = this.name,
                        value = ADV.util.number_format(this.y * 100, 1) + '%';
                    $scope.find(".labels li:contains('" + label + "'):contains('" + value + "')").removeClass('highlighted');
                };

                //hover
                hc_params.plotOptions.series.states.hover.enabled = true;

                $chart.data('hc', new Highcharts.Chart(hc_params));
            }

        }

        function _saveChanges() {

            //make sure total == 100
            if (_getTotal() !== 100) {
                console.log('Total must be 100!');
                return false;
            }

            //create object to send back
            var AssetAllocation = [];
            $.each(data.Series, function (k, v) {
                AssetAllocation.push({
                    id: v.id,
                    y: v.y
                });
            });

            var HypotheticalReturn = $scope.find('#hypothetical_return').val();

            if (typeof data.onChange == 'function') {
                data.onChange.call(undefined, AssetAllocation, HypotheticalReturn);
            }
        }

        _init();


    };

    return helpers;
})(HM.ViewHelper || {});
/**
 * Created by Josh on 4/4/2016.
 *
 * REMOVE THIS AS SOON REACT MIGRATION IS COMPLETE.
 */
(function() {
  if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.findIndex called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }
      return -1;
    };
  }

  Object.equals = function(object, compareTo) {
    if (object === null) {
      throw new TypeError('Object.equals called on null or undefined');
    }
    if (typeof compareTo !== 'object' || typeof object !== 'object') {
      throw new TypeError('Object.equals must be called on an object');
    }
    var aProps = Object.getOwnPropertyNames(object);
    var bProps = Object.getOwnPropertyNames(compareTo);

    if (aProps.length != bProps.length) {
      return false;
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];

      if (object[propName] !== compareTo[propName]) {
        return false;
      }
    }
    return true;
  };
})();

(function() {
  if (!Array.prototype.find) {
    Array.prototype.find = function(predicate) {
      'use strict';
      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    };
  }
})();

(function() {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function() {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }
})();

(function() {
  if (typeof NodeList.prototype.forEach === 'function') return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

(function() {
  if (!Element.prototype.remove) {
    Element.prototype.remove = function() {
      if (this.parentElement) {
        this.parentElement.removeChild(this);
      }
    };
  }

  if (!NodeList.prototype.remove) {
    NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
      for (var i = this.length - 1; i >= 0; i--) {
        if (this[i] && this[i].parentElement) {
          this[i].parentElement.removeChild(this[i]);
        }
      }
    };
  }
})();

(function() {
  if (typeof window.CustomEvent === 'function') return false; //If not IE

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function() {
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function(s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }
})();

(function(arr) {
  arr.forEach(function(item) {
    if (item.hasOwnProperty('prepend')) {
      return;
    }
    Object.defineProperty(item, 'prepend', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function prepend() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function(argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.insertBefore(docFrag, this.firstChild);
      },
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

if (!Element.prototype.scrollIntoViewIfNeeded) {
  Element.prototype.scrollIntoViewIfNeeded = function(centerIfNeeded) {
    centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;

    var parent = this.parentNode,
      parentComputedStyle = window.getComputedStyle(parent, null),
      parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width')),
      parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width')),
      overTop = this.offsetTop - parent.offsetTop < parent.scrollTop,
      overBottom =
        this.offsetTop - parent.offsetTop + this.clientHeight - parentBorderTopWidth >
        parent.scrollTop + parent.clientHeight,
      overLeft = this.offsetLeft - parent.offsetLeft < parent.scrollLeft,
      overRight =
        this.offsetLeft - parent.offsetLeft + this.clientWidth - parentBorderLeftWidth >
        parent.scrollLeft + parent.clientWidth,
      alignWithTop = overTop && !overBottom;

    if ((overTop || overBottom) && centerIfNeeded) {
      parent.scrollTop =
        this.offsetTop -
        parent.offsetTop -
        parent.clientHeight / 2 -
        parentBorderTopWidth +
        this.clientHeight / 2;
    }

    if ((overLeft || overRight) && centerIfNeeded) {
      parent.scrollLeft =
        this.offsetLeft -
        parent.offsetLeft -
        parent.clientWidth / 2 -
        parentBorderLeftWidth +
        this.clientWidth / 2;
    }

    if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
      this.scrollIntoView(alignWithTop);
    }
  };
}
